/* oxlint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as R2fa_setupRouteImport } from './routes/2fa_setup';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as AcademyLoginRouteImport } from './routes/academy-login';
import { Route as AcceptGuestInvitationRouteImport } from './routes/accept-guest-invitation';
import { Route as CheckoutRouteImport } from './routes/checkout';
import { Route as CliRouteImport } from './routes/cli';
import { Route as Confirm_accountRouteImport } from './routes/confirm_account';
import { Route as DesignStudioEmbedRouteImport } from './routes/design-studio-embed';
import { Route as JoinRequestRouteImport } from './routes/join-request';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as R2fa_setupIndexRouteImport } from './routes/2fa_setup.index';
import { Route as R2fa_setupNew_totpRouteImport } from './routes/2fa_setup.new_totp';
import { Route as R2fa_setupSplatRouteImport } from './routes/2fa_setup_.$';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index';
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated.$';
import { Route as AuthenticatedWorkspacesRouteImport } from './routes/_authenticated.workspaces';
import { Route as AccountSplatRouteImport } from './routes/account.$';
import { Route as Account_canceledSplatRouteImport } from './routes/account_canceled.$';
import { Route as Account_cancelledSplatRouteImport } from './routes/account_cancelled.$';
import { Route as CliIndexRouteImport } from './routes/cli.index';
import { Route as CliDnsSetupRouteImport } from './routes/cli.dns-setup';
import { Route as Confirm_account_noticeSplatRouteImport } from './routes/confirm_account_notice.$';
import { Route as DevVercelInstallRouteImport } from './routes/dev.vercel-install';
import { Route as EnvSplatRouteImport } from './routes/env.$';
import { Route as HarSanitizerSplatRouteImport } from './routes/har-sanitizer.$';
import { Route as IntegrationsSplatRouteImport } from './routes/integrations.$';
import { Route as JourneysSplatRouteImport } from './routes/journeys.$';
import { Route as LoginSplatRouteImport } from './routes/login.$';
import { Route as LogoutSplatRouteImport } from './routes/logout.$';
import { Route as MobileAuthorizeRouteImport } from './routes/mobile.authorize';
import { Route as No_accessible_workspacesSplatRouteImport } from './routes/no_accessible_workspaces.$';
import { Route as Oauth2SplatRouteImport } from './routes/oauth2.$';
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index';
import { Route as OnboardingGetStartedRouteImport } from './routes/onboarding.get-started';
import { Route as OnboardingWizardRouteImport } from './routes/onboarding.wizard';
import { Route as Post_cancelSplatRouteImport } from './routes/post_cancel.$';
import { Route as Post_registrationSplatRouteImport } from './routes/post_registration.$';
import { Route as Reset_passwordIndexRouteImport } from './routes/reset_password.index';
import { Route as Reset_passwordSplatRouteImport } from './routes/reset_password.$';
import { Route as Reset_passwordNew_passwordRouteImport } from './routes/reset_password.new_password';
import { Route as SignupSplatRouteImport } from './routes/signup.$';
import { Route as UsersSplatRouteImport } from './routes/users.$';
import { Route as VercelInstallRouteImport } from './routes/vercel.install';
import { Route as VwbDemoSplatRouteImport } from './routes/vwb-demo.$';
import { Route as AuthenticatedInternalToolsIndexRouteImport } from './routes/_authenticated.internal-tools.index';
import { Route as AuthenticatedInternalToolsSplatRouteImport } from './routes/_authenticated.internal-tools.$';
import { Route as AuthenticatedInternalToolsCioCliToolRouteImport } from './routes/_authenticated.internal-tools.cio-cli-tool';
import { Route as AuthenticatedInternalToolsInspectRouteImport } from './routes/_authenticated.internal-tools.inspect';
import { Route as AuthenticatedSampleWorkspaceIndexRouteImport } from './routes/_authenticated.sample-workspace.index';
import { Route as AuthenticatedSampleWorkspaceSplatRouteImport } from './routes/_authenticated.sample-workspace.$';
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated.settings.index';
import { Route as AuthenticatedSettingsSplatRouteImport } from './routes/_authenticated.settings.$';
import { Route as AuthenticatedSettingsAiRouteImport } from './routes/_authenticated.settings.ai';
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated.settings.api-keys';
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated.settings.audit-logs';
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated.settings.billing';
import { Route as AuthenticatedSettingsExperimentalFeaturesRouteImport } from './routes/_authenticated.settings.experimental-features';
import { Route as AuthenticatedSettingsPartnerRouteImport } from './routes/_authenticated.settings.partner';
import { Route as AuthenticatedSettingsPrivacyRouteImport } from './routes/_authenticated.settings.privacy';
import { Route as AuthenticatedSettingsReceiptsRouteImport } from './routes/_authenticated.settings.receipts';
import { Route as AuthenticatedSettingsSlackAgentRouteImport } from './routes/_authenticated.settings.slack-agent';
import { Route as AuthenticatedSettingsSubscriptionRouteImport } from './routes/_authenticated.settings.subscription';
import { Route as AuthenticatedTrialExpiredJourneysRouteImport } from './routes/_authenticated.trial-expired.journeys';
import { Route as AuthenticatedWorkspacesIndexRouteImport } from './routes/_authenticated.workspaces.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId';
import { Route as AccountCancelledSplatRouteImport } from './routes/account.cancelled.$';
import { Route as DesignStudioEmbedCioIndexRouteImport } from './routes/design-studio-embed.cio.index';
import { Route as DesignStudioEmbedCioSplatRouteImport } from './routes/design-studio-embed.cio.$';
import { Route as DesignStudioEmbedCioEmailRouteImport } from './routes/design-studio-embed.cio.email';
import { Route as DesignStudioEmbedCioInAppRouteImport } from './routes/design-studio-embed.cio.in-app';
import { Route as AuthenticatedSettingsAccountIndexRouteImport } from './routes/_authenticated.settings.account.index';
import { Route as AuthenticatedSettingsAccountEditRouteImport } from './routes/_authenticated.settings.account.edit';
import { Route as AuthenticatedSettingsApi_credentialsIndexRouteImport } from './routes/_authenticated.settings.api_credentials.index';
import { Route as AuthenticatedSettingsBillingIndexRouteImport } from './routes/_authenticated.settings.billing.index';
import { Route as AuthenticatedSettingsBillingSplatRouteImport } from './routes/_authenticated.settings.billing.$';
import { Route as AuthenticatedSettingsBillingAddOnsRouteImport } from './routes/_authenticated.settings.billing.add-ons';
import { Route as AuthenticatedSettingsBillingBillingDetailsRouteImport } from './routes/_authenticated.settings.billing.billing-details';
import { Route as AuthenticatedSettingsBillingBillingHistoryRouteImport } from './routes/_authenticated.settings.billing.billing-history';
import { Route as AuthenticatedSettingsBillingCheckoutRouteImport } from './routes/_authenticated.settings.billing.checkout';
import { Route as AuthenticatedSettingsBillingInboxPreviewUsageRouteImport } from './routes/_authenticated.settings.billing.inbox-preview-usage';
import { Route as AuthenticatedSettingsBillingLlmUsageRouteImport } from './routes/_authenticated.settings.billing.llm-usage';
import { Route as AuthenticatedSettingsBillingOverviewRouteImport } from './routes/_authenticated.settings.billing.overview';
import { Route as AuthenticatedSettingsBillingPaymentMethodsRouteImport } from './routes/_authenticated.settings.billing.payment-methods';
import { Route as AuthenticatedSettingsBillingUsageRouteImport } from './routes/_authenticated.settings.billing.usage';
import { Route as AuthenticatedSettingsBillingYourPlanRouteImport } from './routes/_authenticated.settings.billing.your-plan';
import { Route as AuthenticatedSettingsPartnerIndexRouteImport } from './routes/_authenticated.settings.partner.index';
import { Route as AuthenticatedSettingsPartnerCreateRouteImport } from './routes/_authenticated.settings.partner.create';
import { Route as AuthenticatedSettingsPersonalIndexRouteImport } from './routes/_authenticated.settings.personal.index';
import { Route as AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport } from './routes/_authenticated.settings.personal.google-identities';
import { Route as AuthenticatedSettingsRolesIndexRouteImport } from './routes/_authenticated.settings.roles.index';
import { Route as AuthenticatedSettingsRolesRoleIdRouteImport } from './routes/_authenticated.settings.roles.$roleId';
import { Route as AuthenticatedSettingsRolesNewRouteImport } from './routes/_authenticated.settings.roles.new';
import { Route as AuthenticatedSettingsSecurityIndexRouteImport } from './routes/_authenticated.settings.security.index';
import { Route as AuthenticatedSettingsSecuritySsoRouteImport } from './routes/_authenticated.settings.security.sso';
import { Route as AuthenticatedSettingsSlackAgentLinkRouteImport } from './routes/_authenticated.settings.slack-agent_.link';
import { Route as AuthenticatedSettingsTeamIndexRouteImport } from './routes/_authenticated.settings.team.index';
import { Route as AuthenticatedSettingsTeamAddRouteImport } from './routes/_authenticated.settings.team.add';
import { Route as AuthenticatedSettingsTeamInviteGuestRouteImport } from './routes/_authenticated.settings.team.invite-guest';
import { Route as AuthenticatedSettingsTeamSet_passwordRouteImport } from './routes/_authenticated.settings.team.set_password';
import { Route as AuthenticatedSettingsWorkspacesIndexRouteImport } from './routes/_authenticated.settings.workspaces.index';
import { Route as AuthenticatedSettingsWorkspacesNewRouteImport } from './routes/_authenticated.settings.workspaces.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnonymousRouteImport } from './routes/_authenticated.workspaces.$workspaceId.anonymous';
import { Route as AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections';
import { Route as AuthenticatedWorkspacesWorkspaceIdDashboardRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dashboard';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments';
import { Route as AuthenticatedWorkspacesWorkspaceIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets';
import { Route as AuthenticatedWorkspacesWorkspaceIdHealthRouteImport } from './routes/_authenticated.workspaces.$workspaceId.health';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys_';
import { Route as AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.message-library';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines';
import { Route as AuthenticatedWorkspacesWorkspaceIdSignUpFormsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.sign-up-forms';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional';
import { Route as PipelinesWorkspacesWorkspaceIdIndexRouteImport } from './routes/pipelines.workspaces.$workspaceId.index';
import { Route as PipelinesWorkspacesWorkspaceIdSplatRouteImport } from './routes/pipelines.workspaces.$workspaceId.$';
import { Route as AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport } from './routes/_authenticated.settings.api_credentials.service_accounts.$serviceAccountId';
import { Route as AuthenticatedSettingsBillingAvailablePlansIndexRouteImport } from './routes/_authenticated.settings.billing.available-plans.index';
import { Route as AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport } from './routes/_authenticated.settings.billing.available-plans.journeys';
import { Route as AuthenticatedSettingsPersonalSecurityIndexRouteImport } from './routes/_authenticated.settings.personal.security.index';
import { Route as AuthenticatedSettingsPersonalSecurityBackup_codesRouteImport } from './routes/_authenticated.settings.personal.security.backup_codes';
import { Route as AuthenticatedSettingsPersonalSecurityNewRouteImport } from './routes/_authenticated.settings.personal.security.new';
import { Route as AuthenticatedSettingsPersonalSecurityNew_backup_codesRouteImport } from './routes/_authenticated.settings.personal.security.new_backup_codes';
import { Route as AuthenticatedSettingsPersonalSecurityNew_totpRouteImport } from './routes/_authenticated.settings.personal.security.new_totp';
import { Route as AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport } from './routes/_authenticated.settings.team.join-requests.$requestId';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.routines';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.email-clients';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.gmail-postmaster';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.boards.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.boards.$boardId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts.api-triggered';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts.one_time_sends';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts.send-volume';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.$collectionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.data-index.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.data-index.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_.dashboard';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_.global-styles';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.condition-viewer';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.import';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdGoalsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.goals.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.goals.$goalId';
import { Route as AuthenticatedWorkspacesWorkspaceIdGoalsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.goals.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.cdp_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.cdp_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.customerio';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.facebook_lead_ads';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.forms';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.mparticle_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.segment_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.segment_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.dashboard';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.deliveries';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.message-library';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.layouts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdLayoutsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.layouts.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.layouts.starters';
import { Route as AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.message_activity.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes.$goalId';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profile_activity.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profile_activity.$tab';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.email-clients';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.gmail-postmaster';
import { Route as AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.segments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.ai-business-profile';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.anonymous_events';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api-keys';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.audit-logs';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.auto_archive';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.confirm_delete';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsConsentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.consent';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.knowledge_library';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.language';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.live-notification-types';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.merge_options';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.seed-lists';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.suppressions';
import { Route as AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.sign-up-forms_.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.sign-up-forms_.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.template.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.template.$templateId';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.new';
import { Route as AuthenticatedSettingsTeamMembersUserIdEditRouteImport } from './routes/_authenticated.settings.team.members.$userId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.$skillPath';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.workflow';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.welcome.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.welcome.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.$collectionId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.$collectionId.data';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.$collectionId.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.collections.$collectionId.usage';
import { Route as AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.composer.actions.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.data-index.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.brand';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.goals.$goalId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.goals.$goalId.milestones';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.developers';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.directory';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.data_out.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.facebook_lead_ads_.$formId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.forms_.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.forms_.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.$webhookId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.bigquery';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.redshift';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.snowflake';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.activity_logs.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.activity_logs.$tab';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.analysis.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.anonymous.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.api-triggered';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletters';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.one_time_sends';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.send-volume';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.data-index.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.data-index.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.goals.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.goals.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.goals.$goalId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.goals.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.home.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.cdp_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.cdp_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.customerio';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.facebook_lead_ads';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.forms';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.mparticle_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.segment_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.segment_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.starters';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.message_activity.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.outbox.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profile_activity.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profile_activity.$tab';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.reports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.setup-guide.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.template.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.template.$templateId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.triggered.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.triggered.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.v2.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.layouts.$layoutId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.layouts.$layoutId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.guide';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.segments.$segmentId.audiences';
import { Route as AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.segments.$segmentId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.segments.$segmentId.people';
import { Route as AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.segments.$segmentId.usage';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.in_app';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.line';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.message_frequency_limits';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.messaging_limit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.push';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.slack';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.time_zone_match';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.twilio';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.urban_airship';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.whatsapp';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api_credentials.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.data-index.$type.$itemId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.data-index.$type.$itemId.$nestedItemId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.import';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.fields';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.preprocessing';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.preview';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.validating';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.audiences.$type.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.audiences.$type.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.forms_.$type_.$formId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.$type_.sync';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.workflow';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.welcome.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.welcome.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.workflow';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.welcome.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.welcome.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.data';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.usage';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.composer.actions.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.data-index.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.goals.$goalId_.milestones';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.home.workspace-setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.home.workspace-setup.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.developers';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.directory';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.data_out.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.facebook_lead_ads_.$formId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.forms_.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.forms_.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.$webhookId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.bigquery';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.redshift';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.snowflake';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.$layoutId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.$layoutId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.guide';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.audiences';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.people';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.usage';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.activity';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.relationships';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.activity.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.attributes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.attributes.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.devices.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.drafts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.journeys.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.journeys.$subjectId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.live-notifications.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.live-notifications.$conversationId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.relationships.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.segments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.segments.belongs';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.segments.others';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.$personId.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.data-out';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.tester';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add_.$destinationOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.data-in';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.databases';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.imports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.syncs';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add_.$sourceOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.apps.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.apps.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.defaults';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.dynamic_addresses';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.from_addresses';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.postmaster_tools';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.smtp';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.suppression_list';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.push.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.push.android';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.push.ios';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.push.web';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.phone-numbers';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.registration';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api_credentials.service_accounts.$serviceAccountId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.$configurationId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.edit.$objectType';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.branding.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.localization.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.topics.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.topics.set_preferences';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.$webhookId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.send';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.setup.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.tests.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.triggering_details';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.content';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.recipients';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.reports';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.sent';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.[test]';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.content';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.recipients';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.schedule';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.setup.tracking';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.tests.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.in-app.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.inbox-message.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.push.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.sign-up-form.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.sms.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.whatsapp.$id';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.journeys.$templateWorkspaceId.$templateId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.actions.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.query';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.relationships-query';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.data-index.$type.$itemId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.data-index.$type.$itemId.$nestedItemId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.fields';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.preprocessing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.preview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.validating';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.audiences.$type.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.audiences.$type.setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.forms_.$type_.$formId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.$type_.sync';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.activity';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.relationships';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.activity.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.attributes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.attributes.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.devices.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.drafts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.journeys.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.journeys.$subjectId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.live-notifications.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.live-notifications.$conversationId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.relationships.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.segments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.segments.belongs';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.segments.others';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.$personId.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview_.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview_.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview_.send';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.setup.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.attributes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.attributes.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.$subscriptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.$syncId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.apps.edit.$appId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.sending_domains.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.sending_domains.$domainId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers.credentials.$credentialId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.registration.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.registration.business-info';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.registration.point-of-contact';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms.registration.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.transactional_.$transactionalMessageId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.broadcasts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.drafts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.drafts.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.tests.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.newsletter.$newsletterId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.campaigns.$campaignId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.$id_.inbox-previews.$runId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.setup.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.journey_metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.metrics';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.tests';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.triggering_details';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.content';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.form-submissions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.recipients';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.reports';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.sent';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.[test]';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.content';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.recipients';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.schedule';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.setup.tracking';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.setup.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.query';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.relationships-query';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.attributes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.attributes.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.imports.csv.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview_.sent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.transactional.$transactionalMessageId.overview_.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.broadcasts.$triggerId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.broadcasts.$triggerId.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.broadcasts_.broadcast.$broadcastId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.broadcasts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.drafts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.drafts.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.tests.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.newsletter.$newsletterId.overview.sent.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_._editor.editor.$id_.inbox-previews.$runId_.previews.$previewId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.broadcasts.$triggerId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.broadcasts.$triggerId.$deliveryId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.broadcasts.broadcast.$broadcastId.overview.tests.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.imports.csv.setup.$importId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.segments.$segmentId.imports.csv.setup.$importId.$step';

const R2fa_setupRoute = R2fa_setupRouteImport.update({
  id: '/2fa_setup',
  path: '/2fa_setup',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const AcademyLoginRoute = AcademyLoginRouteImport.update({
  id: '/academy-login',
  path: '/academy-login',
  getParentRoute: () => rootRouteImport,
} as any);
const AcceptGuestInvitationRoute = AcceptGuestInvitationRouteImport.update({
  id: '/accept-guest-invitation',
  path: '/accept-guest-invitation',
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any);
const CliRoute = CliRouteImport.update({
  id: '/cli',
  path: '/cli',
  getParentRoute: () => rootRouteImport,
} as any);
const Confirm_accountRoute = Confirm_accountRouteImport.update({
  id: '/confirm_account',
  path: '/confirm_account',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignStudioEmbedRoute = DesignStudioEmbedRouteImport.update({
  id: '/design-studio-embed',
  path: '/design-studio-embed',
  getParentRoute: () => rootRouteImport,
} as any);
const JoinRequestRoute = JoinRequestRouteImport.update({
  id: '/join-request',
  path: '/join-request',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const R2fa_setupIndexRoute = R2fa_setupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => R2fa_setupRoute,
} as any);
const R2fa_setupNew_totpRoute = R2fa_setupNew_totpRouteImport.update({
  id: '/new_totp',
  path: '/new_totp',
  getParentRoute: () => R2fa_setupRoute,
} as any);
const R2fa_setupSplatRoute = R2fa_setupSplatRouteImport.update({
  id: '/2fa_setup_/$',
  path: '/2fa_setup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AccountSplatRoute = AccountSplatRouteImport.update({
  id: '/account/$',
  path: '/account/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Account_canceledSplatRoute = Account_canceledSplatRouteImport.update({
  id: '/account_canceled/$',
  path: '/account_canceled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Account_cancelledSplatRoute = Account_cancelledSplatRouteImport.update({
  id: '/account_cancelled/$',
  path: '/account_cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const CliIndexRoute = CliIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CliRoute,
} as any);
const CliDnsSetupRoute = CliDnsSetupRouteImport.update({
  id: '/dns-setup',
  path: '/dns-setup',
  getParentRoute: () => CliRoute,
} as any);
const Confirm_account_noticeSplatRoute =
  Confirm_account_noticeSplatRouteImport.update({
    id: '/confirm_account_notice/$',
    path: '/confirm_account_notice/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const DevVercelInstallRoute = DevVercelInstallRouteImport.update({
  id: '/dev/vercel-install',
  path: '/dev/vercel-install',
  getParentRoute: () => rootRouteImport,
} as any);
const EnvSplatRoute = EnvSplatRouteImport.update({
  id: '/env/$',
  path: '/env/$',
  getParentRoute: () => rootRouteImport,
} as any);
const HarSanitizerSplatRoute = HarSanitizerSplatRouteImport.update({
  id: '/har-sanitizer/$',
  path: '/har-sanitizer/$',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsSplatRoute = IntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => rootRouteImport,
} as any);
const JourneysSplatRoute = JourneysSplatRouteImport.update({
  id: '/journeys/$',
  path: '/journeys/$',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginSplatRoute = LoginSplatRouteImport.update({
  id: '/login/$',
  path: '/login/$',
  getParentRoute: () => rootRouteImport,
} as any);
const LogoutSplatRoute = LogoutSplatRouteImport.update({
  id: '/logout/$',
  path: '/logout/$',
  getParentRoute: () => rootRouteImport,
} as any);
const MobileAuthorizeRoute = MobileAuthorizeRouteImport.update({
  id: '/mobile/authorize',
  path: '/mobile/authorize',
  getParentRoute: () => rootRouteImport,
} as any);
const No_accessible_workspacesSplatRoute =
  No_accessible_workspacesSplatRouteImport.update({
    id: '/no_accessible_workspaces/$',
    path: '/no_accessible_workspaces/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const Oauth2SplatRoute = Oauth2SplatRouteImport.update({
  id: '/oauth2/$',
  path: '/oauth2/$',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any);
const OnboardingGetStartedRoute = OnboardingGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => OnboardingRoute,
} as any);
const OnboardingWizardRoute = OnboardingWizardRouteImport.update({
  id: '/wizard',
  path: '/wizard',
  getParentRoute: () => OnboardingRoute,
} as any);
const Post_cancelSplatRoute = Post_cancelSplatRouteImport.update({
  id: '/post_cancel/$',
  path: '/post_cancel/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Post_registrationSplatRoute = Post_registrationSplatRouteImport.update({
  id: '/post_registration/$',
  path: '/post_registration/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Reset_passwordIndexRoute = Reset_passwordIndexRouteImport.update({
  id: '/reset_password/',
  path: '/reset_password/',
  getParentRoute: () => rootRouteImport,
} as any);
const Reset_passwordSplatRoute = Reset_passwordSplatRouteImport.update({
  id: '/reset_password/$',
  path: '/reset_password/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Reset_passwordNew_passwordRoute =
  Reset_passwordNew_passwordRouteImport.update({
    id: '/reset_password/new_password',
    path: '/reset_password/new_password',
    getParentRoute: () => rootRouteImport,
  } as any);
const SignupSplatRoute = SignupSplatRouteImport.update({
  id: '/signup/$',
  path: '/signup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersSplatRoute = UsersSplatRouteImport.update({
  id: '/users/$',
  path: '/users/$',
  getParentRoute: () => rootRouteImport,
} as any);
const VercelInstallRoute = VercelInstallRouteImport.update({
  id: '/vercel/install',
  path: '/vercel/install',
  getParentRoute: () => rootRouteImport,
} as any);
const VwbDemoSplatRoute = VwbDemoSplatRouteImport.update({
  id: '/vwb-demo/$',
  path: '/vwb-demo/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedInternalToolsIndexRoute =
  AuthenticatedInternalToolsIndexRouteImport.update({
    id: '/internal-tools/',
    path: '/internal-tools/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsSplatRoute =
  AuthenticatedInternalToolsSplatRouteImport.update({
    id: '/internal-tools/$',
    path: '/internal-tools/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsCioCliToolRoute =
  AuthenticatedInternalToolsCioCliToolRouteImport.update({
    id: '/internal-tools/cio-cli-tool',
    path: '/internal-tools/cio-cli-tool',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsInspectRoute =
  AuthenticatedInternalToolsInspectRouteImport.update({
    id: '/internal-tools/inspect',
    path: '/internal-tools/inspect',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceIndexRoute =
  AuthenticatedSampleWorkspaceIndexRouteImport.update({
    id: '/sample-workspace/',
    path: '/sample-workspace/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceSplatRoute =
  AuthenticatedSampleWorkspaceSplatRouteImport.update({
    id: '/sample-workspace/$',
    path: '/sample-workspace/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSplatRoute =
  AuthenticatedSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAiRoute = AuthenticatedSettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsExperimentalFeaturesRoute =
  AuthenticatedSettingsExperimentalFeaturesRouteImport.update({
    id: '/settings/experimental-features',
    path: '/settings/experimental-features',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPartnerRoute =
  AuthenticatedSettingsPartnerRouteImport.update({
    id: '/settings/partner',
    path: '/settings/partner',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPrivacyRoute =
  AuthenticatedSettingsPrivacyRouteImport.update({
    id: '/settings/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsReceiptsRoute =
  AuthenticatedSettingsReceiptsRouteImport.update({
    id: '/settings/receipts',
    path: '/settings/receipts',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSlackAgentRoute =
  AuthenticatedSettingsSlackAgentRouteImport.update({
    id: '/settings/slack-agent',
    path: '/settings/slack-agent',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSubscriptionRoute =
  AuthenticatedSettingsSubscriptionRouteImport.update({
    id: '/settings/subscription',
    path: '/settings/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrialExpiredJourneysRoute =
  AuthenticatedTrialExpiredJourneysRouteImport.update({
    id: '/trial-expired/journeys',
    path: '/trial-expired/journeys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesIndexRoute =
  AuthenticatedWorkspacesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AccountCancelledSplatRoute = AccountCancelledSplatRouteImport.update({
  id: '/account/cancelled/$',
  path: '/account/cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignStudioEmbedCioIndexRoute =
  DesignStudioEmbedCioIndexRouteImport.update({
    id: '/cio/',
    path: '/cio/',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const DesignStudioEmbedCioSplatRoute =
  DesignStudioEmbedCioSplatRouteImport.update({
    id: '/cio/$',
    path: '/cio/$',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const DesignStudioEmbedCioEmailRoute =
  DesignStudioEmbedCioEmailRouteImport.update({
    id: '/cio/email',
    path: '/cio/email',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const DesignStudioEmbedCioInAppRoute =
  DesignStudioEmbedCioInAppRouteImport.update({
    id: '/cio/in-app',
    path: '/cio/in-app',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const AuthenticatedSettingsAccountIndexRoute =
  AuthenticatedSettingsAccountIndexRouteImport.update({
    id: '/settings/account/',
    path: '/settings/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountEditRoute =
  AuthenticatedSettingsAccountEditRouteImport.update({
    id: '/settings/account/edit',
    path: '/settings/account/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsApi_credentialsIndexRoute =
  AuthenticatedSettingsApi_credentialsIndexRouteImport.update({
    id: '/settings/api_credentials/',
    path: '/settings/api_credentials/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsBillingIndexRoute =
  AuthenticatedSettingsBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingSplatRoute =
  AuthenticatedSettingsBillingSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingAddOnsRoute =
  AuthenticatedSettingsBillingAddOnsRouteImport.update({
    id: '/add-ons',
    path: '/add-ons',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingBillingDetailsRoute =
  AuthenticatedSettingsBillingBillingDetailsRouteImport.update({
    id: '/billing-details',
    path: '/billing-details',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingBillingHistoryRoute =
  AuthenticatedSettingsBillingBillingHistoryRouteImport.update({
    id: '/billing-history',
    path: '/billing-history',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingCheckoutRoute =
  AuthenticatedSettingsBillingCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingInboxPreviewUsageRoute =
  AuthenticatedSettingsBillingInboxPreviewUsageRouteImport.update({
    id: '/inbox-preview-usage',
    path: '/inbox-preview-usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingLlmUsageRoute =
  AuthenticatedSettingsBillingLlmUsageRouteImport.update({
    id: '/llm-usage',
    path: '/llm-usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingOverviewRoute =
  AuthenticatedSettingsBillingOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingPaymentMethodsRoute =
  AuthenticatedSettingsBillingPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingUsageRoute =
  AuthenticatedSettingsBillingUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingYourPlanRoute =
  AuthenticatedSettingsBillingYourPlanRouteImport.update({
    id: '/your-plan',
    path: '/your-plan',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsPartnerIndexRoute =
  AuthenticatedSettingsPartnerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsPartnerRoute,
  } as any);
const AuthenticatedSettingsPartnerCreateRoute =
  AuthenticatedSettingsPartnerCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsPartnerRoute,
  } as any);
const AuthenticatedSettingsPersonalIndexRoute =
  AuthenticatedSettingsPersonalIndexRouteImport.update({
    id: '/settings/personal/',
    path: '/settings/personal/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalGoogleIdentitiesRoute =
  AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport.update({
    id: '/settings/personal/google-identities',
    path: '/settings/personal/google-identities',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesIndexRoute =
  AuthenticatedSettingsRolesIndexRouteImport.update({
    id: '/settings/roles/',
    path: '/settings/roles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesRoleIdRoute =
  AuthenticatedSettingsRolesRoleIdRouteImport.update({
    id: '/settings/roles/$roleId',
    path: '/settings/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesNewRoute =
  AuthenticatedSettingsRolesNewRouteImport.update({
    id: '/settings/roles/new',
    path: '/settings/roles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecurityIndexRoute =
  AuthenticatedSettingsSecurityIndexRouteImport.update({
    id: '/settings/security/',
    path: '/settings/security/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecuritySsoRoute =
  AuthenticatedSettingsSecuritySsoRouteImport.update({
    id: '/settings/security/sso',
    path: '/settings/security/sso',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSlackAgentLinkRoute =
  AuthenticatedSettingsSlackAgentLinkRouteImport.update({
    id: '/settings/slack-agent_/link',
    path: '/settings/slack-agent/link',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamIndexRoute =
  AuthenticatedSettingsTeamIndexRouteImport.update({
    id: '/settings/team/',
    path: '/settings/team/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamAddRoute =
  AuthenticatedSettingsTeamAddRouteImport.update({
    id: '/settings/team/add',
    path: '/settings/team/add',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamInviteGuestRoute =
  AuthenticatedSettingsTeamInviteGuestRouteImport.update({
    id: '/settings/team/invite-guest',
    path: '/settings/team/invite-guest',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamSet_passwordRoute =
  AuthenticatedSettingsTeamSet_passwordRouteImport.update({
    id: '/settings/team/set_password',
    path: '/settings/team/set_password',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsWorkspacesIndexRoute =
  AuthenticatedSettingsWorkspacesIndexRouteImport.update({
    id: '/settings/workspaces/',
    path: '/settings/workspaces/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsWorkspacesNewRoute =
  AuthenticatedSettingsWorkspacesNewRouteImport.update({
    id: '/settings/workspaces/new',
    path: '/settings/workspaces/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnonymousRoute =
  AuthenticatedWorkspacesWorkspaceIdAnonymousRouteImport.update({
    id: '/anonymous',
    path: '/anonymous',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteImport.update({
    id: '/broadcasts',
    path: '/broadcasts',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdCollectionsRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDashboardRoute =
  AuthenticatedWorkspacesWorkspaceIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport.update({
    id: '/design-studio',
    path: '/design-studio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport.update({
    id: '/geosets',
    path: '/geosets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHealthRoute =
  AuthenticatedWorkspacesWorkspaceIdHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport.update({
    id: '/journeys_',
    path: '/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute =
  AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport.update({
    id: '/message-library',
    path: '/message-library',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport.update({
    id: '/outcomes',
    path: '/outcomes',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute =
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsRouteImport.update({
    id: '/sign-up-forms',
    path: '/sign-up-forms',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport.update({
    id: '/snippets',
    path: '/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTransactionalRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalRouteImport.update({
    id: '/transactional',
    path: '/transactional',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const PipelinesWorkspacesWorkspaceIdIndexRoute =
  PipelinesWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/',
    path: '/pipelines/workspaces/$workspaceId/',
    getParentRoute: () => rootRouteImport,
  } as any);
const PipelinesWorkspacesWorkspaceIdSplatRoute =
  PipelinesWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/$',
    path: '/pipelines/workspaces/$workspaceId/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute =
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport.update(
    {
      id: '/settings/api_credentials/service_accounts/$serviceAccountId',
      path: '/settings/api_credentials/service_accounts/$serviceAccountId',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedSettingsBillingAvailablePlansIndexRoute =
  AuthenticatedSettingsBillingAvailablePlansIndexRouteImport.update({
    id: '/available-plans/',
    path: '/available-plans/',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingAvailablePlansJourneysRoute =
  AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport.update({
    id: '/available-plans/journeys',
    path: '/available-plans/journeys',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsPersonalSecurityIndexRoute =
  AuthenticatedSettingsPersonalSecurityIndexRouteImport.update({
    id: '/settings/personal/security/',
    path: '/settings/personal/security/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalSecurityBackup_codesRoute =
  AuthenticatedSettingsPersonalSecurityBackup_codesRouteImport.update({
    id: '/settings/personal/security/backup_codes',
    path: '/settings/personal/security/backup_codes',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalSecurityNewRoute =
  AuthenticatedSettingsPersonalSecurityNewRouteImport.update({
    id: '/settings/personal/security/new',
    path: '/settings/personal/security/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute =
  AuthenticatedSettingsPersonalSecurityNew_backup_codesRouteImport.update({
    id: '/settings/personal/security/new_backup_codes',
    path: '/settings/personal/security/new_backup_codes',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalSecurityNew_totpRoute =
  AuthenticatedSettingsPersonalSecurityNew_totpRouteImport.update({
    id: '/settings/personal/security/new_totp',
    path: '/settings/personal/security/new_totp',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamJoinRequestsRequestIdRoute =
  AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport.update({
    id: '/settings/team/join-requests/$requestId',
    path: '/settings/team/join-requests/$requestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport.update({
    id: '/routines',
    path: '/routines',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRouteImport.update({
    id: '/analysis/',
    path: '/analysis/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport.update({
    id: '/analysis/deliverability',
    path: '/analysis/deliverability',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport.update({
    id: '/analysis/email-clients',
    path: '/analysis/email-clients',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRouteImport.update({
    id: '/analysis/gmail-postmaster',
    path: '/analysis/gmail-postmaster',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsNewRouteImport.update({
    id: '/automations/new',
    path: '/automations/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport.update({
    id: '/boards/',
    path: '/boards/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport.update({
    id: '/boards/$boardId',
    path: '/boards/$boardId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRouteImport.update({
    id: '/api-triggered',
    path: '/api-triggered',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRouteImport.update({
    id: '/one_time_sends',
    path: '/one_time_sends',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRouteImport.update({
    id: '/send-volume',
    path: '/send-volume',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRouteImport.update({
    id: '/broadcasts_/new',
    path: '/broadcasts/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdCollectionsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdCollectionsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRouteImport.update({
    id: '/data-index/',
    path: '/data-index/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRouteImport.update({
    id: '/data-index/$',
    path: '/data-index/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteImport.update({
    id: '/design-studio_/_editor',
    path: '/design-studio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport.update({
    id: '/design-studio_/dashboard',
    path: '/design-studio/dashboard',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport.update({
    id: '/design-studio_/global-styles',
    path: '/design-studio/global-styles',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute =
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport.update({
    id: '/dev/condition-viewer',
    path: '/dev/condition-viewer',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport.update({
    id: '/$experimentId',
    path: '/$experimentId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport.update({
    id: '/$geosetId',
    path: '/$geosetId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGoalsIndexRouteImport.update({
    id: '/goals/',
    path: '/goals/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteImport.update({
    id: '/goals/$goalId',
    path: '/goals/$goalId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGoalsNewRouteImport.update({
    id: '/goals/new',
    path: '/goals/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport.update({
    id: '/add-people',
    path: '/add-people',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport.update({
    id: '/workspace-setup',
    path: '/workspace-setup',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport.update({
    id: '/imports/',
    path: '/imports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdImportsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport.update({
    id: '/imports/new',
    path: '/imports/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport.update({
    id: '/integrations/$type',
    path: '/integrations/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport.update({
    id: '/integrations/all',
    path: '/integrations/all',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport.update({
    id: '/integrations/cdp_in',
    path: '/integrations/cdp_in',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport.update({
    id: '/integrations/cdp_out',
    path: '/integrations/cdp_out',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport.update({
    id: '/integrations/customerio',
    path: '/integrations/customerio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRouteImport.update(
    {
      id: '/integrations/facebook_lead_ads',
      path: '/integrations/facebook_lead_ads',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRouteImport.update({
    id: '/integrations/forms',
    path: '/integrations/forms',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport.update(
    {
      id: '/integrations/mparticle_out',
      path: '/integrations/mparticle_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport.update({
    id: '/integrations/segment_in',
    path: '/integrations/segment_in',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport.update({
    id: '/integrations/segment_out',
    path: '/integrations/segment_out',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport.update({
    id: '/journeys/$',
    path: '/journeys/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport.update({
    id: '/journeys/assets',
    path: '/journeys/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport.update({
    id: '/journeys/collections',
    path: '/journeys/collections',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRouteImport.update({
    id: '/journeys/dashboard',
    path: '/journeys/dashboard',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport.update({
    id: '/journeys/deliveries',
    path: '/journeys/deliveries',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport.update({
    id: '/journeys/drafts',
    path: '/journeys/drafts',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport.update({
    id: '/journeys/exports',
    path: '/journeys/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport.update({
    id: '/journeys/geofences',
    path: '/journeys/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport.update({
    id: '/journeys/message-library',
    path: '/journeys/message-library',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport.update({
    id: '/journeys/settings',
    path: '/journeys/settings',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport.update({
    id: '/journeys/snippets',
    path: '/journeys/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport.update({
    id: '/journeys/tasks',
    path: '/journeys/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRouteImport.update({
    id: '/layouts/',
    path: '/layouts/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdLayoutsNewRouteImport.update({
    id: '/layouts/new',
    path: '/layouts/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute =
  AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRouteImport.update({
    id: '/layouts/starters',
    path: '/layouts/starters',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute =
  AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRouteImport.update({
    id: '/message_activity/$',
    path: '/message_activity/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport.update({
    id: '/objects/',
    path: '/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdOutcomesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport.update({
    id: '/$goalId',
    path: '/$goalId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdOutcomesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport.update({
    id: '/parcel/',
    path: '/parcel/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport.update({
    id: '/parcel/$',
    path: '/parcel/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteImport.update({
    id: '/people/$personId',
    path: '/people/$personId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport.update({
    id: '/people/create',
    path: '/people/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport.update({
    id: '/people/merge',
    path: '/people/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport.update({
    id: '/people/new',
    path: '/people/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport.update({
    id: '/people/welcome',
    path: '/people/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRouteImport.update({
    id: '/profile_activity/',
    path: '/profile_activity/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute =
  AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRouteImport.update({
    id: '/profile_activity/$tab',
    path: '/profile_activity/$tab',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport.update({
    id: '/profiles/',
    path: '/profiles/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport.update({
    id: '/profiles/create',
    path: '/profiles/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport.update({
    id: '/profiles/merge',
    path: '/profiles/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport.update({
    id: '/profiles/new',
    path: '/profiles/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport.update({
    id: '/profiles/welcome',
    path: '/profiles/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport.update({
    id: '/reports/deliverability',
    path: '/reports/deliverability',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport.update({
    id: '/reports/email-clients',
    path: '/reports/email-clients',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRouteImport.update({
    id: '/reports/gmail-postmaster',
    path: '/reports/gmail-postmaster',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRouteImport.update({
    id: '/segments/',
    path: '/segments/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport.update(
    {
      id: '/settings/ai-business-profile',
      path: '/settings/ai-business-profile',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport.update({
    id: '/settings/anonymous_events',
    path: '/settings/anonymous_events',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport.update({
    id: '/settings/auto_archive',
    path: '/settings/auto_archive',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport.update({
    id: '/settings/confirm_delete',
    path: '/settings/confirm_delete',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsConsentRouteImport.update({
    id: '/settings/consent',
    path: '/settings/consent',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport.update({
    id: '/settings/edit',
    path: '/settings/edit',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport.update({
    id: '/settings/geofences',
    path: '/settings/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRouteImport.update(
    {
      id: '/settings/knowledge_library',
      path: '/settings/knowledge_library',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport.update({
    id: '/settings/language',
    path: '/settings/language',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRouteImport.update(
    {
      id: '/settings/live-notification-types',
      path: '/settings/live-notification-types',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport.update(
    {
      id: '/settings/llm_configuration',
      path: '/settings/llm_configuration',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport.update({
    id: '/settings/merge_options',
    path: '/settings/merge_options',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRouteImport.update({
    id: '/settings/seed-lists',
    path: '/settings/seed-lists',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport.update(
    {
      id: '/settings/subscription_center',
      path: '/settings/subscription_center',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport.update({
    id: '/settings/suppressions',
    path: '/settings/suppressions',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRouteImport.update({
    id: '/sign-up-forms_/$id',
    path: '/sign-up-forms/$id',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRouteImport.update({
    id: '/sign-up-forms_/new',
    path: '/sign-up-forms/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport.update({
    id: '/$snippetId',
    path: '/$snippetId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport.update({
    id: '/template/',
    path: '/template/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute =
  AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport.update({
    id: '/template/$templateId',
    path: '/template/$templateId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalNewRouteImport.update({
    id: '/transactional_/new',
    path: '/transactional/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedSettingsTeamMembersUserIdEditRoute =
  AuthenticatedSettingsTeamMembersUserIdEditRouteImport.update({
    id: '/settings/team/members/$userId/edit',
    path: '/settings/team/members/$userId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport.update({
    id: '/$skillPath',
    path: '/$skillPath',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRouteImport.update(
    {
      id: '/automations/$campaignId/',
      path: '/automations/$campaignId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport.update(
    {
      id: '/automations/$campaignId/workflow',
      path: '/automations/$campaignId/workflow',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRouteImport.update({
    id: '/automations/welcome/',
    path: '/automations/welcome/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRouteImport.update({
    id: '/automations/welcome/create',
    path: '/automations/welcome/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRouteImport.update({
    id: '/campaigns/$campaignId/',
    path: '/campaigns/$campaignId/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRouteImport.update(
    {
      id: '/data',
      path: '/data',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRouteImport.update(
    {
      id: '/importing',
      path: '/importing',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRouteImport.update(
    {
      id: '/usage',
      path: '/usage',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRouteImport.update({
    id: '/composer/actions/$actionId',
    path: '/composer/actions/$actionId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRouteImport.update({
    id: '/data-index/$type/',
    path: '/data-index/$type/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRouteImport.update(
    {
      id: '/assets',
      path: '/assets',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRouteImport.update({
    id: '/brand',
    path: '/brand',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRouteImport.update(
    {
      id: '/welcome',
      path: '/welcome',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport.update({
    id: '/dev/db/campaigns',
    path: '/dev/db/campaigns',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport.update({
    id: '/geofences',
    path: '/geofences',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute =
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRouteImport.update({
    id: '/milestones',
    path: '/milestones',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport.update(
    {
      id: '/add-people',
      path: '/add-people',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport.update({
    id: '/imports/$importId/',
    path: '/imports/$importId/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport.update(
    {
      id: '/developers',
      path: '/developers',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport.update({
    id: '/directory',
    path: '/directory',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport.update({
    id: '/integrations/data_out/$type',
    path: '/integrations/data_out/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRouteImport.update(
    {
      id: '/integrations/facebook_lead_ads_/$formId',
      path: '/integrations/facebook_lead_ads/$formId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRouteImport.update({
    id: '/integrations/forms_/$type',
    path: '/integrations/forms/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRouteImport.update(
    {
      id: '/integrations/forms_/settings',
      path: '/integrations/forms/settings',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/',
      path: '/integrations/reporting-webhooks/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/$webhookId',
      path: '/integrations/reporting-webhooks/$webhookId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/new',
      path: '/integrations/reporting-webhooks/new',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport.update({
    id: '/integrations/sql-sync/$type',
    path: '/integrations/sql-sync/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport.update(
    {
      id: '/integrations/warehouse/$type',
      path: '/integrations/warehouse/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport.update(
    {
      id: '/integrations/warehouse/bigquery',
      path: '/integrations/warehouse/bigquery',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport.update(
    {
      id: '/integrations/warehouse/redshift',
      path: '/integrations/warehouse/redshift',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport.update(
    {
      id: '/integrations/warehouse/snowflake',
      path: '/integrations/warehouse/snowflake',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport.update(
    {
      id: '/journeys/activity_logs/',
      path: '/journeys/activity_logs/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport.update({
    id: '/journeys/activity_logs/$tab',
    path: '/journeys/activity_logs/$tab',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRouteImport.update({
    id: '/journeys/analysis/',
    path: '/journeys/analysis/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport.update(
    {
      id: '/journeys/analysis/deliverability',
      path: '/journeys/analysis/deliverability',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRouteImport.update({
    id: '/journeys/anonymous/',
    path: '/journeys/anonymous/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRouteImport.update({
    id: '/journeys/automations/',
    path: '/journeys/automations/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRouteImport.update({
    id: '/journeys/automations/new',
    path: '/journeys/automations/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRouteImport.update({
    id: '/journeys/broadcasts/',
    path: '/journeys/broadcasts/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRouteImport.update(
    {
      id: '/journeys/broadcasts/api-triggered',
      path: '/journeys/broadcasts/api-triggered',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRouteImport.update({
    id: '/journeys/broadcasts/new',
    path: '/journeys/broadcasts/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRouteImport.update(
    {
      id: '/journeys/broadcasts/newsletters',
      path: '/journeys/broadcasts/newsletters',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRouteImport.update(
    {
      id: '/journeys/broadcasts/one_time_sends',
      path: '/journeys/broadcasts/one_time_sends',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRouteImport.update(
    {
      id: '/journeys/broadcasts/send-volume',
      path: '/journeys/broadcasts/send-volume',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRouteImport.update(
    {
      id: '/journeys/broadcasts/welcome',
      path: '/journeys/broadcasts/welcome',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRouteImport.update({
    id: '/journeys/campaigns/',
    path: '/journeys/campaigns/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRouteImport.update({
    id: '/journeys/campaigns/new',
    path: '/journeys/campaigns/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRouteImport.update({
    id: '/journeys/data-index/',
    path: '/journeys/data-index/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRouteImport.update({
    id: '/journeys/data-index/$',
    path: '/journeys/data-index/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport.update(
    {
      id: '/$geofenceId',
      path: '/$geofenceId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRouteImport.update({
    id: '/journeys/goals/',
    path: '/journeys/goals/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRouteImport.update({
    id: '/journeys/goals/$',
    path: '/journeys/goals/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRouteImport.update({
    id: '/journeys/goals/$goalId',
    path: '/journeys/goals/$goalId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRouteImport.update({
    id: '/journeys/goals/new',
    path: '/journeys/goals/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRouteImport.update({
    id: '/journeys/home/',
    path: '/journeys/home/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport.update({
    id: '/journeys/imports/',
    path: '/journeys/imports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport.update({
    id: '/journeys/imports/new',
    path: '/journeys/imports/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport.update(
    {
      id: '/journeys/integrations/',
      path: '/journeys/integrations/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport.update({
    id: '/journeys/integrations/$type',
    path: '/journeys/integrations/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport.update({
    id: '/journeys/integrations/all',
    path: '/journeys/integrations/all',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport.update(
    {
      id: '/journeys/integrations/cdp_in',
      path: '/journeys/integrations/cdp_in',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport.update(
    {
      id: '/journeys/integrations/cdp_out',
      path: '/journeys/integrations/cdp_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport.update(
    {
      id: '/journeys/integrations/customerio',
      path: '/journeys/integrations/customerio',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRouteImport.update(
    {
      id: '/journeys/integrations/facebook_lead_ads',
      path: '/journeys/integrations/facebook_lead_ads',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRouteImport.update(
    {
      id: '/journeys/integrations/forms',
      path: '/journeys/integrations/forms',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport.update(
    {
      id: '/journeys/integrations/mparticle_out',
      path: '/journeys/integrations/mparticle_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport.update(
    {
      id: '/journeys/integrations/reporting-webhooks',
      path: '/journeys/integrations/reporting-webhooks',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport.update(
    {
      id: '/journeys/integrations/segment_in',
      path: '/journeys/integrations/segment_in',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport.update(
    {
      id: '/journeys/integrations/segment_out',
      path: '/journeys/integrations/segment_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport.update({
    id: '/journeys/layouts/',
    path: '/journeys/layouts/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport.update({
    id: '/journeys/layouts/new',
    path: '/journeys/layouts/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport.update({
    id: '/journeys/layouts/starters',
    path: '/journeys/layouts/starters',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport.update(
    {
      id: '/journeys/message_activity/$',
      path: '/journeys/message_activity/$',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport.update({
    id: '/journeys/objects/',
    path: '/journeys/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport.update({
    id: '/journeys/outbox/$',
    path: '/journeys/outbox/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport.update({
    id: '/journeys/people/',
    path: '/journeys/people/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport.update({
    id: '/journeys/people/create',
    path: '/journeys/people/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport.update({
    id: '/journeys/people/merge',
    path: '/journeys/people/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport.update({
    id: '/journeys/people/new',
    path: '/journeys/people/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport.update({
    id: '/journeys/people/welcome',
    path: '/journeys/people/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport.update(
    {
      id: '/journeys/profile_activity/',
      path: '/journeys/profile_activity/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport.update(
    {
      id: '/journeys/profile_activity/$tab',
      path: '/journeys/profile_activity/$tab',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport.update({
    id: '/journeys/profiles/',
    path: '/journeys/profiles/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport.update({
    id: '/journeys/profiles/create',
    path: '/journeys/profiles/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport.update({
    id: '/journeys/profiles/merge',
    path: '/journeys/profiles/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport.update({
    id: '/journeys/profiles/new',
    path: '/journeys/profiles/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport.update({
    id: '/journeys/profiles/welcome',
    path: '/journeys/profiles/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRouteImport.update({
    id: '/journeys/reports/',
    path: '/journeys/reports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRouteImport.update({
    id: '/journeys/segments/',
    path: '/journeys/segments/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport.update({
    id: '/journeys/setup-guide/$',
    path: '/journeys/setup-guide/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport.update(
    {
      id: '/$snippetId',
      path: '/$snippetId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport.update({
    id: '/journeys/template/',
    path: '/journeys/template/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport.update(
    {
      id: '/journeys/template/$templateId',
      path: '/journeys/template/$templateId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRouteImport.update(
    {
      id: '/journeys/transactional/',
      path: '/journeys/transactional/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRouteImport.update({
    id: '/journeys/transactional/new',
    path: '/journeys/transactional/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport.update({
    id: '/journeys/triggered/',
    path: '/journeys/triggered/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport.update({
    id: '/journeys/triggered/new',
    path: '/journeys/triggered/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport.update({
    id: '/journeys/v2/$',
    path: '/journeys/v2/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRouteImport.update({
    id: '/layouts/$layoutId/',
    path: '/layouts/$layoutId/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRouteImport.update({
    id: '/layouts/$layoutId/edit',
    path: '/layouts/$layoutId/edit',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport.update({
    id: '/objects/$slug/',
    path: '/objects/$slug/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport.update({
    id: '/objects/$slug/$objectId',
    path: '/objects/$slug/$objectId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport.update({
    id: '/objects/$slug/guide',
    path: '/objects/$slug/guide',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport.update({
    id: '/objects/$slug/new',
    path: '/objects/$slug/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport.update(
    {
      id: '/destinations/',
      path: '/destinations/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport.update(
    {
      id: '/destinations/$destinationId',
      path: '/destinations/$destinationId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport.update({
    id: '/destinations/add',
    path: '/destinations/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport.update(
    {
      id: '/destinations/journeys',
      path: '/destinations/journeys',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport.update({
    id: '/sources/',
    path: '/sources/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport.update({
    id: '/sources/$sourceId',
    path: '/sources/$sourceId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport.update({
    id: '/sources/add',
    path: '/sources/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport.update({
    id: '/sources/journeys',
    path: '/sources/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute =
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRouteImport.update(
    {
      id: '/segments/$segmentId/audiences',
      path: '/segments/$segmentId/audiences',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRouteImport.update(
    {
      id: '/segments/$segmentId/overview',
      path: '/segments/$segmentId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRouteImport.update({
    id: '/segments/$segmentId/people',
    path: '/segments/$segmentId/people',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute =
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRouteImport.update({
    id: '/segments/$segmentId/usage',
    path: '/segments/$segmentId/usage',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport.update({
    id: '/settings/actions/email',
    path: '/settings/actions/email',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRouteImport.update({
    id: '/settings/actions/in_app',
    path: '/settings/actions/in_app',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport.update({
    id: '/settings/actions/line',
    path: '/settings/actions/line',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport.update(
    {
      id: '/settings/actions/message_frequency_limits',
      path: '/settings/actions/message_frequency_limits',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport.update(
    {
      id: '/settings/actions/messaging_limit',
      path: '/settings/actions/messaging_limit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteImport.update({
    id: '/settings/actions/push',
    path: '/settings/actions/push',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport.update({
    id: '/settings/actions/slack',
    path: '/settings/actions/slack',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteImport.update({
    id: '/settings/actions/sms',
    path: '/settings/actions/sms',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport.update(
    {
      id: '/settings/actions/sms-providers',
      path: '/settings/actions/sms-providers',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport.update(
    {
      id: '/settings/actions/time_zone_match',
      path: '/settings/actions/time_zone_match',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRouteImport.update({
    id: '/settings/actions/twilio',
    path: '/settings/actions/twilio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport.update(
    {
      id: '/settings/actions/urban_airship',
      path: '/settings/actions/urban_airship',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport.update(
    {
      id: '/settings/actions/url_params',
      path: '/settings/actions/url_params',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRouteImport.update({
    id: '/settings/actions/whatsapp',
    path: '/settings/actions/whatsapp',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport.update(
    {
      id: '/settings/api_credentials/',
      path: '/settings/api_credentials/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport.update({
    id: '/settings/objects/',
    path: '/settings/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport.update({
    id: '/settings/objects/new',
    path: '/settings/objects/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport.update(
    {
      id: '/settings/webhook_configuration/',
      path: '/settings/webhook_configuration/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport.update(
    {
      id: '/settings/webhook_configuration/new',
      path: '/settings/webhook_configuration/new',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteImport.update(
    {
      id: '/transactional_/$transactionalMessageId/overview',
      path: '/transactional/$transactionalMessageId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteImport.update(
    {
      id: '/transactional_/$transactionalMessageId/setup',
      path: '/transactional/$transactionalMessageId/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRouteImport.update(
    {
      id: '/automations/$campaignId/overview/',
      path: '/automations/$campaignId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRouteImport.update(
    {
      id: '/automations/$campaignId/overview/drafts',
      path: '/automations/$campaignId/overview/drafts',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/automations/$campaignId/overview/form-submissions',
      path: '/automations/$campaignId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/automations/$campaignId/overview/journey_metrics',
      path: '/automations/$campaignId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRouteImport.update(
    {
      id: '/automations/$campaignId/overview/metrics',
      path: '/automations/$campaignId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteImport.update(
    {
      id: '/automations/$campaignId/overview/tests',
      path: '/automations/$campaignId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/',
      path: '/broadcasts/broadcast/$broadcastId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteImport.update(
    {
      id: '/broadcasts_/newsletter/$newsletterId/overview',
      path: '/broadcasts/newsletter/$newsletterId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteImport.update(
    {
      id: '/broadcasts_/newsletter/$newsletterId/setup',
      path: '/broadcasts/newsletter/$newsletterId/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/',
      path: '/campaigns/$campaignId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/drafts',
      path: '/campaigns/$campaignId/overview/drafts',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/form-submissions',
      path: '/campaigns/$campaignId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/journey_metrics',
      path: '/campaigns/$campaignId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/metrics',
      path: '/campaigns/$campaignId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/tests',
      path: '/campaigns/$campaignId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRouteImport.update({
    id: '/data-index/$type/$itemId/',
    path: '/data-index/$type/$itemId/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRouteImport.update(
    {
      id: '/data-index/$type/$itemId/$nestedItemId',
      path: '/data-index/$type/$itemId/$nestedItemId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRouteImport.update(
    {
      id: '/editor/',
      path: '/editor/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRouteImport.update(
    {
      id: '/editor/$id',
      path: '/editor/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport.update(
    {
      id: '/$geofenceId',
      path: '/$geofenceId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport.update(
    {
      id: '/import',
      path: '/import',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport.update(
    {
      id: '/imports/$importId/setup/',
      path: '/imports/$importId/setup/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport.update(
    {
      id: '/imports/$importId/setup/fields',
      path: '/imports/$importId/setup/fields',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport.update(
    {
      id: '/imports/$importId/setup/importing',
      path: '/imports/$importId/setup/importing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport.update(
    {
      id: '/imports/$importId/setup/preprocessing',
      path: '/imports/$importId/setup/preprocessing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport.update(
    {
      id: '/imports/$importId/setup/preview',
      path: '/imports/$importId/setup/preview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport.update(
    {
      id: '/imports/$importId/setup/review',
      path: '/imports/$importId/setup/review',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport.update(
    {
      id: '/imports/$importId/setup/validating',
      path: '/imports/$importId/setup/validating',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRouteImport.update(
    {
      id: '/integrations/audiences/$type/settings',
      path: '/integrations/audiences/$type/settings',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRouteImport.update(
    {
      id: '/integrations/audiences/$type/setup',
      path: '/integrations/audiences/$type/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRouteImport.update(
    {
      id: '/integrations/forms_/$type_/$formId',
      path: '/integrations/forms/$type/$formId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport.update(
    {
      id: '/$sqlImportId',
      path: '/$sqlImportId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport.update(
    {
      id: '/integrations/warehouse/$type_/sync',
      path: '/integrations/warehouse/$type/sync',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/',
      path: '/journeys/automations/$campaignId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/workflow',
      path: '/journeys/automations/$campaignId/workflow',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRouteImport.update(
    {
      id: '/journeys/automations/welcome/',
      path: '/journeys/automations/welcome/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRouteImport.update(
    {
      id: '/journeys/automations/welcome/create',
      path: '/journeys/automations/welcome/create',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/',
      path: '/journeys/broadcasts/broadcast/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/newsletter/',
      path: '/journeys/broadcasts/newsletter/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/',
      path: '/journeys/campaigns/$campaignId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/workflow',
      path: '/journeys/campaigns/$campaignId/workflow',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRouteImport.update(
    {
      id: '/journeys/campaigns/welcome/',
      path: '/journeys/campaigns/welcome/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRouteImport.update(
    {
      id: '/journeys/campaigns/welcome/create',
      path: '/journeys/campaigns/welcome/create',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport.update(
    {
      id: '/$collectionId/',
      path: '/$collectionId/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport.update(
    {
      id: '/$collectionId/$',
      path: '/$collectionId/$',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport.update(
    {
      id: '/$collectionId/data',
      path: '/$collectionId/data',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport.update(
    {
      id: '/$collectionId/importing',
      path: '/$collectionId/importing',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport.update(
    {
      id: '/$collectionId/usage',
      path: '/$collectionId/usage',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRouteImport.update(
    {
      id: '/journeys/composer/actions/$actionId',
      path: '/journeys/composer/actions/$actionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRouteImport.update(
    {
      id: '/journeys/data-index/$type/',
      path: '/journeys/data-index/$type/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRouteImport.update(
    {
      id: '/journeys/goals/$goalId_/milestones',
      path: '/journeys/goals/$goalId/milestones',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRouteImport.update(
    {
      id: '/journeys/home/workspace-setup/',
      path: '/journeys/home/workspace-setup/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRouteImport.update(
    {
      id: '/journeys/home/workspace-setup/add-people',
      path: '/journeys/home/workspace-setup/add-people',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport.update(
    {
      id: '/journeys/imports/$importId/',
      path: '/journeys/imports/$importId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport.update(
    {
      id: '/developers',
      path: '/developers',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport.update(
    {
      id: '/directory',
      path: '/directory',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport.update(
    {
      id: '/webhooks',
      path: '/webhooks',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport.update(
    {
      id: '/journeys/integrations/data_out/$type',
      path: '/journeys/integrations/data_out/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRouteImport.update(
    {
      id: '/journeys/integrations/facebook_lead_ads_/$formId',
      path: '/journeys/integrations/facebook_lead_ads/$formId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRouteImport.update(
    {
      id: '/journeys/integrations/forms_/$type',
      path: '/journeys/integrations/forms/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRouteImport.update(
    {
      id: '/journeys/integrations/forms_/settings',
      path: '/journeys/integrations/forms/settings',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport.update(
    {
      id: '/$webhookId',
      path: '/$webhookId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport.update(
    {
      id: '/journeys/integrations/sql-sync/$type',
      path: '/journeys/integrations/sql-sync/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/$type',
      path: '/journeys/integrations/warehouse/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/bigquery',
      path: '/journeys/integrations/warehouse/bigquery',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/redshift',
      path: '/journeys/integrations/warehouse/redshift',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/snowflake',
      path: '/journeys/integrations/warehouse/snowflake',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport.update(
    {
      id: '/journeys/layouts/$layoutId/',
      path: '/journeys/layouts/$layoutId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport.update(
    {
      id: '/journeys/layouts/$layoutId/edit',
      path: '/journeys/layouts/$layoutId/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport.update({
    id: '/journeys/objects/$slug/',
    path: '/journeys/objects/$slug/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport.update({
    id: '/journeys/objects/$slug/guide',
    path: '/journeys/objects/$slug/guide',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport.update({
    id: '/journeys/objects/$slug/new',
    path: '/journeys/objects/$slug/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/',
      path: '/journeys/people/$personId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/',
      path: '/journeys/segments/$segmentId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/audiences',
      path: '/journeys/segments/$segmentId/audiences',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/overview',
      path: '/journeys/segments/$segmentId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/people',
      path: '/journeys/segments/$segmentId/people',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/usage',
      path: '/journeys/segments/$segmentId/usage',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview',
      path: '/journeys/transactional/$transactionalMessageId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/setup',
      path: '/journeys/transactional/$transactionalMessageId/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRouteImport.update(
    {
      id: '/activity',
      path: '/activity',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRouteImport.update(
    {
      id: '/relationships',
      path: '/relationships',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRouteImport.update(
    {
      id: '/activity/',
      path: '/activity/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRouteImport.update(
    {
      id: '/attributes/',
      path: '/attributes/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRouteImport.update(
    {
      id: '/attributes/edit',
      path: '/attributes/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRouteImport.update(
    {
      id: '/devices/',
      path: '/devices/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRouteImport.update(
    {
      id: '/drafts/',
      path: '/drafts/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRouteImport.update(
    {
      id: '/journeys/',
      path: '/journeys/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRouteImport.update(
    {
      id: '/journeys/$subjectId',
      path: '/journeys/$subjectId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRouteImport.update(
    {
      id: '/live-notifications/',
      path: '/live-notifications/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRouteImport.update(
    {
      id: '/live-notifications/$conversationId',
      path: '/live-notifications/$conversationId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRouteImport.update(
    {
      id: '/relationships/',
      path: '/relationships/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRouteImport.update(
    {
      id: '/segments/',
      path: '/segments/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRouteImport.update(
    {
      id: '/segments/belongs',
      path: '/segments/belongs',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRouteImport.update(
    {
      id: '/segments/others',
      path: '/segments/others',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRouteImport.update({
    id: '/sent/',
    path: '/sent/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport.update(
    {
      id: '/data-out',
      path: '/data-out',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport.update(
    {
      id: '/exports',
      path: '/exports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport.update(
    {
      id: '/subscriptions',
      path: '/subscriptions',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport.update(
    {
      id: '/tester',
      path: '/tester',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport.update(
    {
      id: '/destinations/add_/$destinationOptionId',
      path: '/destinations/add/$destinationOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport.update(
    {
      id: '/data-in',
      path: '/data-in',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport.update(
    {
      id: '/databases',
      path: '/databases',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport.update(
    {
      id: '/imports',
      path: '/imports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport.update(
    {
      id: '/syncs',
      path: '/syncs',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport.update(
    {
      id: '/sources/add_/$sourceOptionId',
      path: '/sources/add/$sourceOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRouteImport.update({
    id: '/settings/actions/apps/',
    path: '/settings/actions/apps/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRouteImport.update(
    {
      id: '/settings/actions/apps/create',
      path: '/settings/actions/apps/create',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport.update(
    {
      id: '/defaults',
      path: '/defaults',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport.update(
    {
      id: '/deliverability',
      path: '/deliverability',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport.update(
    {
      id: '/dynamic_addresses',
      path: '/dynamic_addresses',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport.update(
    {
      id: '/from_addresses',
      path: '/from_addresses',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRouteImport.update(
    {
      id: '/postmaster_tools',
      path: '/postmaster_tools',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport.update({
    id: '/smtp',
    path: '/smtp',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport.update(
    {
      id: '/suppression_list',
      path: '/suppression_list',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRouteImport.update(
    {
      id: '/android',
      path: '/android',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRouteImport.update({
    id: '/ios',
    path: '/ios',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRouteImport.update({
    id: '/web',
    path: '/web',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRouteImport.update(
    {
      id: '/phone-numbers',
      path: '/phone-numbers',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteImport.update(
    {
      id: '/registration',
      path: '/registration',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport.update(
    {
      id: '/settings/api_credentials/service_accounts/$serviceAccountId',
      path: '/settings/api_credentials/service_accounts/$serviceAccountId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport.update(
    {
      id: '/$configurationId/edit',
      path: '/$configurationId/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport.update(
    {
      id: '/settings/objects/edit/$objectType',
      path: '/settings/objects/edit/$objectType',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport.update(
    {
      id: '/branding/edit',
      path: '/branding/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport.update(
    {
      id: '/localization/edit',
      path: '/localization/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport.update(
    {
      id: '/topics/',
      path: '/topics/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport.update(
    {
      id: '/topics/set_preferences',
      path: '/topics/set_preferences',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport.update(
    {
      id: '/settings/webhook_configuration/$webhookId/edit',
      path: '/settings/webhook_configuration/$webhookId/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRouteImport.update(
    {
      id: '/drafts',
      path: '/drafts',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRouteImport.update(
    {
      id: '/metrics',
      path: '/metrics',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRouteImport.update(
    {
      id: '/send',
      path: '/send',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRouteImport.update(
    {
      id: '/automations/$campaignId/overview/sent/',
      path: '/automations/$campaignId/overview/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/automations/$campaignId/overview/sent/$deliveryId',
      path: '/automations/$campaignId/overview/sent/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/',
      path: '/broadcasts/broadcast/$broadcastId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/form-submissions',
      path: '/broadcasts/broadcast/$broadcastId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/journey_metrics',
      path: '/broadcasts/broadcast/$broadcastId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/journeys',
      path: '/broadcasts/broadcast/$broadcastId/overview/journeys',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/metrics',
      path: '/broadcasts/broadcast/$broadcastId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/tests',
      path: '/broadcasts/broadcast/$broadcastId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/triggering_details',
      path: '/broadcasts/broadcast/$broadcastId/overview/triggering_details',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRouteImport.update(
    {
      id: '/content',
      path: '/content',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/form-submissions',
      path: '/form-submissions',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport.update(
    {
      id: '/recipients',
      path: '/recipients',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteImport.update(
    {
      id: '/sent',
      path: '/sent',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport.update(
    {
      id: '/test',
      path: '/test',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRouteImport.update(
    {
      id: '/content',
      path: '/content',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport.update(
    {
      id: '/recipients',
      path: '/recipients',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport.update(
    {
      id: '/schedule',
      path: '/schedule',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport.update(
    {
      id: '/tracking',
      path: '/tracking',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/sent/',
      path: '/campaigns/$campaignId/overview/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/campaigns/$campaignId/overview/sent/$deliveryId',
      path: '/campaigns/$campaignId/overview/sent/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRouteImport.update(
    {
      id: '/editor/in-app/$id',
      path: '/editor/in-app/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRouteImport.update(
    {
      id: '/editor/inbox-message/$id',
      path: '/editor/inbox-message/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRouteImport.update(
    {
      id: '/editor/push/$id',
      path: '/editor/push/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRouteImport.update(
    {
      id: '/editor/sign-up-form/$id',
      path: '/editor/sign-up-form/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRouteImport.update(
    {
      id: '/editor/sms/$id',
      path: '/editor/sms/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRouteImport.update(
    {
      id: '/editor/whatsapp/$id',
      path: '/editor/whatsapp/$id',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRouteImport.update(
    {
      id: '/journeys/$templateWorkspaceId/$templateId',
      path: '/journeys/$templateWorkspaceId/$templateId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport.update(
    {
      id: '/actions/$actionId',
      path: '/actions/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport.update(
    {
      id: '/query',
      path: '/query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport.update(
    {
      id: '/relationships-query',
      path: '/relationships-query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/',
      path: '/journeys/automations/$campaignId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/drafts',
      path: '/journeys/automations/$campaignId/overview/drafts',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/form-submissions',
      path: '/journeys/automations/$campaignId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/journey_metrics',
      path: '/journeys/automations/$campaignId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/metrics',
      path: '/journeys/automations/$campaignId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/tests',
      path: '/journeys/automations/$campaignId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/',
      path: '/journeys/broadcasts/broadcast/$broadcastId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteImport.update(
    {
      id: '/journeys/broadcasts/newsletter/$newsletterId/overview',
      path: '/journeys/broadcasts/newsletter/$newsletterId/overview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteImport.update(
    {
      id: '/journeys/broadcasts/newsletter/$newsletterId/setup',
      path: '/journeys/broadcasts/newsletter/$newsletterId/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/',
      path: '/journeys/campaigns/$campaignId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/drafts',
      path: '/journeys/campaigns/$campaignId/overview/drafts',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/form-submissions',
      path: '/journeys/campaigns/$campaignId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/journey_metrics',
      path: '/journeys/campaigns/$campaignId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/metrics',
      path: '/journeys/campaigns/$campaignId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/tests',
      path: '/journeys/campaigns/$campaignId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRouteImport.update(
    {
      id: '/journeys/data-index/$type/$itemId/',
      path: '/journeys/data-index/$type/$itemId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRouteImport.update(
    {
      id: '/journeys/data-index/$type/$itemId/$nestedItemId',
      path: '/journeys/data-index/$type/$itemId/$nestedItemId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/',
      path: '/journeys/imports/$importId/setup/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/fields',
      path: '/journeys/imports/$importId/setup/fields',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/importing',
      path: '/journeys/imports/$importId/setup/importing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/preprocessing',
      path: '/journeys/imports/$importId/setup/preprocessing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/preview',
      path: '/journeys/imports/$importId/setup/preview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/review',
      path: '/journeys/imports/$importId/setup/review',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/validating',
      path: '/journeys/imports/$importId/setup/validating',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRouteImport.update(
    {
      id: '/journeys/integrations/audiences/$type/settings',
      path: '/journeys/integrations/audiences/$type/settings',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRouteImport.update(
    {
      id: '/journeys/integrations/audiences/$type/setup',
      path: '/journeys/integrations/audiences/$type/setup',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRouteImport.update(
    {
      id: '/journeys/integrations/forms_/$type_/$formId',
      path: '/journeys/integrations/forms/$type/$formId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport.update(
    {
      id: '/$sqlImportId',
      path: '/$sqlImportId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/$type_/sync',
      path: '/journeys/integrations/warehouse/$type/sync',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/',
      path: '/journeys/objects/$slug/$objectId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/activity',
      path: '/journeys/objects/$slug/$objectId/activity',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/relationships',
      path: '/journeys/objects/$slug/$objectId/relationships',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/activity/',
      path: '/journeys/people/$personId/activity/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/attributes/',
      path: '/journeys/people/$personId/attributes/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRouteImport.update(
    {
      id: '/journeys/people/$personId/attributes/edit',
      path: '/journeys/people/$personId/attributes/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/devices/',
      path: '/journeys/people/$personId/devices/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/drafts/',
      path: '/journeys/people/$personId/drafts/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/journeys/',
      path: '/journeys/people/$personId/journeys/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRouteImport.update(
    {
      id: '/journeys/people/$personId/journeys/$subjectId',
      path: '/journeys/people/$personId/journeys/$subjectId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/live-notifications/',
      path: '/journeys/people/$personId/live-notifications/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRouteImport.update(
    {
      id: '/journeys/people/$personId/live-notifications/$conversationId',
      path: '/journeys/people/$personId/live-notifications/$conversationId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/relationships/',
      path: '/journeys/people/$personId/relationships/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/segments/',
      path: '/journeys/people/$personId/segments/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRouteImport.update(
    {
      id: '/journeys/people/$personId/segments/belongs',
      path: '/journeys/people/$personId/segments/belongs',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRouteImport.update(
    {
      id: '/journeys/people/$personId/segments/others',
      path: '/journeys/people/$personId/segments/others',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRouteImport.update(
    {
      id: '/journeys/people/$personId/sent/',
      path: '/journeys/people/$personId/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview_/drafts',
      path: '/journeys/transactional/$transactionalMessageId/overview/drafts',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview_/metrics',
      path: '/journeys/transactional/$transactionalMessageId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview_/send',
      path: '/journeys/transactional/$transactionalMessageId/overview/send',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRouteImport.update(
    {
      id: '/attributes/',
      path: '/attributes/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRouteImport.update(
    {
      id: '/attributes/edit',
      path: '/attributes/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport.update(
    {
      id: '/$subscriptionId',
      path: '/$subscriptionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport.update(
    {
      id: '/sources/$sourceId_/syncs/$syncId',
      path: '/sources/$sourceId/syncs/$syncId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport.update(
    {
      id: '/sources/$sourceId_/syncs/add',
      path: '/sources/$sourceId/syncs/add',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdPipelinesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRouteImport.update(
    {
      id: '/settings/actions/apps/edit/$appId',
      path: '/settings/actions/apps/edit/$appId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport.update(
    {
      id: '/sending_domains/',
      path: '/sending_domains/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport.update(
    {
      id: '/sending_domains/$domainId',
      path: '/sending_domains/$domainId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport.update(
    {
      id: '/credentials/$credentialId',
      path: '/credentials/$credentialId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRouteImport.update(
    {
      id: '/business-info',
      path: '/business-info',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRouteImport.update(
    {
      id: '/point-of-contact',
      path: '/point-of-contact',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRouteImport.update(
    {
      id: '/sent/',
      path: '/sent/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/sent/$deliveryId',
      path: '/sent/$deliveryId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/broadcasts/',
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/drafts/',
      path: '/broadcasts/broadcast/$broadcastId/overview/drafts/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId',
      path: '/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/$deliveryId',
      path: '/$deliveryId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRouteImport.update(
    {
      id: '/editor/$id_/inbox-previews/$runId',
      path: '/editor/$id/inbox-previews/$runId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/sent/',
      path: '/journeys/automations/$campaignId/overview/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/sent/$deliveryId',
      path: '/journeys/automations/$campaignId/overview/sent/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/workflow/actions',
      path: '/journeys/automations/$campaignId/overview/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/setup/workflow/actions',
      path: '/journeys/automations/$campaignId/setup/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/journeys',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/journeys',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/metrics',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/metrics',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/tests',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/tests',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRouteImport.update(
    {
      id: '/content',
      path: '/content',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport.update(
    {
      id: '/form-submissions',
      path: '/form-submissions',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport.update(
    {
      id: '/recipients',
      path: '/recipients',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteImport.update(
    {
      id: '/sent',
      path: '/sent',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport.update(
    {
      id: '/test',
      path: '/test',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRouteImport.update(
    {
      id: '/content',
      path: '/content',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport.update(
    {
      id: '/recipients',
      path: '/recipients',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport.update(
    {
      id: '/schedule',
      path: '/schedule',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport.update(
    {
      id: '/tracking',
      path: '/tracking',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/sent/',
      path: '/journeys/campaigns/$campaignId/overview/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/sent/$deliveryId',
      path: '/journeys/campaigns/$campaignId/overview/sent/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/workflow/actions',
      path: '/journeys/campaigns/$campaignId/overview/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/setup/workflow/actions',
      path: '/journeys/campaigns/$campaignId/setup/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport.update(
    {
      id: '/$sqlImportId_/query',
      path: '/$sqlImportId/query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport.update(
    {
      id: '/$sqlImportId_/relationships-query',
      path: '/$sqlImportId/relationships-query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport.update(
    {
      id: '/$sqlImportId_/settings',
      path: '/$sqlImportId/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/attributes/',
      path: '/journeys/objects/$slug/$objectId/attributes/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/attributes/edit',
      path: '/journeys/objects/$slug/$objectId/attributes/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/imports/csv/new',
      path: '/journeys/segments/$segmentId/imports/csv/new',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview_/sent/',
      path: '/journeys/transactional/$transactionalMessageId/overview/sent/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId',
      path: '/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/',
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport.update(
    {
      id: '/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId',
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport.update(
    {
      id: '/$deliveryId',
      path: '/$deliveryId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRouteImport.update(
    {
      id: '/editor/$id_/inbox-previews/$runId_/previews/$previewId',
      path: '/editor/$id/inbox-previews/$runId/previews/$previewId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport.update(
    {
      id: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId',
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/imports/csv/setup/$importId/',
      path: '/journeys/segments/$segmentId/imports/csv/setup/$importId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRouteImport.update(
    {
      id: '/journeys/segments/$segmentId/imports/csv/setup/$importId/$step',
      path: '/journeys/segments/$segmentId/imports/csv/setup/$importId/$step',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/2fa_setup': typeof R2fa_setupRouteWithChildren;
  '/': typeof AuthenticatedIndexRoute;
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/confirm_account': typeof Confirm_accountRoute;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/onboarding': typeof OnboardingRouteWithChildren;
  '/2fa_setup/new_totp': typeof R2fa_setupNew_totpRoute;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/dev/vercel-install': typeof DevVercelInstallRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/mobile/authorize': typeof MobileAuthorizeRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/reset_password/new_password': typeof Reset_passwordNew_passwordRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vercel/install': typeof VercelInstallRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/2fa_setup/': typeof R2fa_setupIndexRoute;
  '/cli/': typeof CliIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/reset_password/': typeof Reset_passwordIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/internal-tools/cio-cli-tool': typeof AuthenticatedInternalToolsCioCliToolRoute;
  '/internal-tools/inspect': typeof AuthenticatedInternalToolsInspectRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/billing': typeof AuthenticatedSettingsBillingRouteWithChildren;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/partner': typeof AuthenticatedSettingsPartnerRouteWithChildren;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/design-studio-embed/cio/email': typeof DesignStudioEmbedCioEmailRoute;
  '/design-studio-embed/cio/in-app': typeof DesignStudioEmbedCioInAppRoute;
  '/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/settings/billing/add-ons': typeof AuthenticatedSettingsBillingAddOnsRoute;
  '/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/settings/slack-agent/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/settings/team/set_password': typeof AuthenticatedSettingsTeamSet_passwordRoute;
  '/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/workspaces/$workspaceId/anonymous': typeof AuthenticatedWorkspacesWorkspaceIdAnonymousRoute;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteWithChildren;
  '/workspaces/$workspaceId/collections': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRouteWithChildren;
  '/workspaces/$workspaceId/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDashboardRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  '/workspaces/$workspaceId/pipelines': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRouteWithChildren;
  '/workspaces/$workspaceId/sign-up-forms': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/workspaces/$workspaceId/transactional': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/api_credentials/': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/settings/billing/': typeof AuthenticatedSettingsBillingIndexRoute;
  '/settings/partner/': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/settings/personal/': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/settings/team/': typeof AuthenticatedSettingsTeamIndexRoute;
  '/settings/workspaces/': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/settings/personal/security/backup_codes': typeof AuthenticatedSettingsPersonalSecurityBackup_codesRoute;
  '/settings/personal/security/new': typeof AuthenticatedSettingsPersonalSecurityNewRoute;
  '/settings/personal/security/new_backup_codes': typeof AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute;
  '/settings/personal/security/new_totp': typeof AuthenticatedSettingsPersonalSecurityNew_totpRoute;
  '/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/workspaces/$workspaceId/analysis/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute;
  '/workspaces/$workspaceId/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute;
  '/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/workspaces/$workspaceId/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute;
  '/workspaces/$workspaceId/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute;
  '/workspaces/$workspaceId/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute;
  '/workspaces/$workspaceId/broadcasts/new': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute;
  '/workspaces/$workspaceId/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteWithChildren;
  '/workspaces/$workspaceId/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/design-studio/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/workspaces/$workspaceId/design-studio/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  '/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/workspaces/$workspaceId/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteWithChildren;
  '/workspaces/$workspaceId/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  '/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute;
  '/workspaces/$workspaceId/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute;
  '/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute;
  '/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute;
  '/workspaces/$workspaceId/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute;
  '/workspaces/$workspaceId/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute;
  '/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/people/$personId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteWithChildren;
  '/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/workspaces/$workspaceId/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute;
  '/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/workspaces/$workspaceId/reports/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/workspaces/$workspaceId/settings/consent': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute;
  '/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/workspaces/$workspaceId/settings/knowledge_library': typeof AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute;
  '/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/workspaces/$workspaceId/settings/live-notification-types': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute;
  '/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/seed-lists': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute;
  '/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/sign-up-forms/$id': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute;
  '/workspaces/$workspaceId/sign-up-forms/new': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/transactional/new': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute;
  '/settings/billing/available-plans/': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/settings/personal/security/': typeof AuthenticatedSettingsPersonalSecurityIndexRoute;
  '/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/analysis/': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute;
  '/workspaces/$workspaceId/automations/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute;
  '/workspaces/$workspaceId/boards/': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute;
  '/workspaces/$workspaceId/collections/': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute;
  '/workspaces/$workspaceId/data-index/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute;
  '/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/experiments/': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/workspaces/$workspaceId/geosets/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/workspaces/$workspaceId/goals/': typeof AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute;
  '/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/imports/': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/workspaces/$workspaceId/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/workspaces/$workspaceId/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute;
  '/workspaces/$workspaceId/objects/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/workspaces/$workspaceId/outcomes/': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/people/': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute;
  '/workspaces/$workspaceId/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/workspaces/$workspaceId/reports/': typeof AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute;
  '/workspaces/$workspaceId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/template/': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute;
  '/workspaces/$workspaceId/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute;
  '/workspaces/$workspaceId/design-studio/assets': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute;
  '/workspaces/$workspaceId/design-studio/brand': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute;
  '/workspaces/$workspaceId/design-studio/welcome': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/goals/$goalId/milestones': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/integrations/facebook_lead_ads/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute;
  '/workspaces/$workspaceId/integrations/forms/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute;
  '/workspaces/$workspaceId/integrations/forms/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  '/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute;
  '/workspaces/$workspaceId/journeys/campaigns/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute;
  '/workspaces/$workspaceId/journeys/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/goals/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute;
  '/workspaces/$workspaceId/journeys/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute;
  '/workspaces/$workspaceId/journeys/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute;
  '/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute;
  '/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/journeys/transactional/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute;
  '/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/workspaces/$workspaceId/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  '/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute;
  '/workspaces/$workspaceId/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute;
  '/workspaces/$workspaceId/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute;
  '/workspaces/$workspaceId/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute;
  '/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/in_app': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute;
  '/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/workspaces/$workspaceId/settings/actions/push': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/workspaces/$workspaceId/settings/actions/sms': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/workspaces/$workspaceId/settings/actions/twilio': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute;
  '/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/whatsapp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteWithChildren;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteWithChildren;
  '/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/automations/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/data-index/$type/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/workspaces/$workspaceId/goals/$goalId/': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/workspaces/$workspaceId/journeys/analysis/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute;
  '/workspaces/$workspaceId/journeys/anonymous/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/goals/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute;
  '/workspaces/$workspaceId/journeys/home/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/workspaces/$workspaceId/journeys/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/workspaces/$workspaceId/journeys/reports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute;
  '/workspaces/$workspaceId/journeys/segments/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/journeys/template/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute;
  '/workspaces/$workspaceId/journeys/triggered/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/workspaces/$workspaceId/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/people/$personId/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/settings/api_credentials/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/workspaces/$workspaceId/settings/objects/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute;
  '/workspaces/$workspaceId/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute;
  '/workspaces/$workspaceId/integrations/forms/$type/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/journeys/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/journeys/campaigns/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/journeys/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute;
  '/workspaces/$workspaceId/journeys/goals/$goalId/milestones': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute;
  '/workspaces/$workspaceId/journeys/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteWithChildren;
  '/workspaces/$workspaceId/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute;
  '/workspaces/$workspaceId/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute;
  '/workspaces/$workspaceId/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute;
  '/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/workspaces/$workspaceId/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute;
  '/workspaces/$workspaceId/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/settings/actions/apps/create': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute;
  '/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/postmaster_tools': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute;
  '/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/workspaces/$workspaceId/settings/actions/push/android': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute;
  '/workspaces/$workspaceId/settings/actions/push/ios': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute;
  '/workspaces/$workspaceId/settings/actions/push/web': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute;
  '/workspaces/$workspaceId/settings/actions/sms/phone-numbers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/sms/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/send': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/data-index/$type/$itemId/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute;
  '/workspaces/$workspaceId/design-studio/editor/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/people/$personId/activity/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute;
  '/workspaces/$workspaceId/people/$personId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute;
  '/workspaces/$workspaceId/people/$personId/devices/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute;
  '/workspaces/$workspaceId/people/$personId/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/journeys/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute;
  '/workspaces/$workspaceId/people/$personId/live-notifications/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/relationships/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/sent/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/settings/actions/apps/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/workspaces/$workspaceId/settings/actions/push/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/in-app/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/inbox-message/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/push/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/sign-up-form/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/sms/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/whatsapp/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute;
  '/workspaces/$workspaceId/design-studio/journeys/$templateWorkspaceId/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute;
  '/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/$type/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/send': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/settings/actions/apps/edit/$appId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/business-info': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/review': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/devices/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/journeys/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/relationships/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId/previews/$previewId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute;
}
export interface FileRoutesByTo {
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/confirm_account': typeof Confirm_accountRoute;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/2fa_setup/new_totp': typeof R2fa_setupNew_totpRoute;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/dev/vercel-install': typeof DevVercelInstallRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/mobile/authorize': typeof MobileAuthorizeRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/reset_password/new_password': typeof Reset_passwordNew_passwordRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vercel/install': typeof VercelInstallRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/2fa_setup': typeof R2fa_setupIndexRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/cli': typeof CliIndexRoute;
  '/onboarding': typeof OnboardingIndexRoute;
  '/reset_password': typeof Reset_passwordIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/internal-tools/cio-cli-tool': typeof AuthenticatedInternalToolsCioCliToolRoute;
  '/internal-tools/inspect': typeof AuthenticatedInternalToolsInspectRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/design-studio-embed/cio/email': typeof DesignStudioEmbedCioEmailRoute;
  '/design-studio-embed/cio/in-app': typeof DesignStudioEmbedCioInAppRoute;
  '/internal-tools': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/settings/billing/add-ons': typeof AuthenticatedSettingsBillingAddOnsRoute;
  '/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/settings/slack-agent/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/settings/team/set_password': typeof AuthenticatedSettingsTeamSet_passwordRoute;
  '/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/anonymous': typeof AuthenticatedWorkspacesWorkspaceIdAnonymousRoute;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDashboardRoute;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/workspaces/$workspaceId/sign-up-forms': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/workspaces/$workspaceId/transactional': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/api_credentials': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/settings/billing': typeof AuthenticatedSettingsBillingIndexRoute;
  '/settings/partner': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/settings/personal': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/settings/roles': typeof AuthenticatedSettingsRolesIndexRoute;
  '/settings/security': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/settings/team': typeof AuthenticatedSettingsTeamIndexRoute;
  '/settings/workspaces': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/settings/personal/security/backup_codes': typeof AuthenticatedSettingsPersonalSecurityBackup_codesRoute;
  '/settings/personal/security/new': typeof AuthenticatedSettingsPersonalSecurityNewRoute;
  '/settings/personal/security/new_backup_codes': typeof AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute;
  '/settings/personal/security/new_totp': typeof AuthenticatedSettingsPersonalSecurityNew_totpRoute;
  '/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/workspaces/$workspaceId/analysis/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute;
  '/workspaces/$workspaceId/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute;
  '/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/workspaces/$workspaceId/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute;
  '/workspaces/$workspaceId/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute;
  '/workspaces/$workspaceId/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute;
  '/workspaces/$workspaceId/broadcasts/new': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute;
  '/workspaces/$workspaceId/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/design-studio/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/workspaces/$workspaceId/design-studio/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/workspaces/$workspaceId/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute;
  '/workspaces/$workspaceId/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute;
  '/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute;
  '/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute;
  '/workspaces/$workspaceId/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute;
  '/workspaces/$workspaceId/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute;
  '/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/workspaces/$workspaceId/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute;
  '/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/workspaces/$workspaceId/reports/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/workspaces/$workspaceId/settings/consent': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute;
  '/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/workspaces/$workspaceId/settings/knowledge_library': typeof AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute;
  '/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/workspaces/$workspaceId/settings/live-notification-types': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/seed-lists': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/sign-up-forms/$id': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute;
  '/workspaces/$workspaceId/sign-up-forms/new': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/transactional/new': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute;
  '/settings/billing/available-plans': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/settings/personal/security': typeof AuthenticatedSettingsPersonalSecurityIndexRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/analysis': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute;
  '/workspaces/$workspaceId/automations': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute;
  '/workspaces/$workspaceId/boards': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/workspaces/$workspaceId/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute;
  '/workspaces/$workspaceId/collections': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute;
  '/workspaces/$workspaceId/data-index': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute;
  '/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/workspaces/$workspaceId/goals': typeof AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/workspaces/$workspaceId/integrations': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/workspaces/$workspaceId/layouts': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute;
  '/workspaces/$workspaceId/objects': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/workspaces/$workspaceId/parcel': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/people': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/workspaces/$workspaceId/pipelines': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/profile_activity': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute;
  '/workspaces/$workspaceId/profiles': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/workspaces/$workspaceId/reports': typeof AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute;
  '/workspaces/$workspaceId/segments': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/template': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute;
  '/workspaces/$workspaceId/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute;
  '/workspaces/$workspaceId/design-studio/assets': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute;
  '/workspaces/$workspaceId/design-studio/brand': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute;
  '/workspaces/$workspaceId/design-studio/welcome': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/workspaces/$workspaceId/goals/$goalId/milestones': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/integrations/facebook_lead_ads/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute;
  '/workspaces/$workspaceId/integrations/forms/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute;
  '/workspaces/$workspaceId/integrations/forms/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute;
  '/workspaces/$workspaceId/journeys/campaigns/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute;
  '/workspaces/$workspaceId/journeys/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/goals/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute;
  '/workspaces/$workspaceId/journeys/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute;
  '/workspaces/$workspaceId/journeys/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute;
  '/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute;
  '/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/journeys/transactional/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute;
  '/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/workspaces/$workspaceId/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute;
  '/workspaces/$workspaceId/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute;
  '/workspaces/$workspaceId/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute;
  '/workspaces/$workspaceId/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute;
  '/workspaces/$workspaceId/settings/actions/in_app': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute;
  '/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/workspaces/$workspaceId/settings/actions/twilio': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute;
  '/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/workspaces/$workspaceId/settings/actions/whatsapp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/automations/welcome': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/data-index/$type': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/workspaces/$workspaceId/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/imports/$importId': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/activity_logs': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/workspaces/$workspaceId/journeys/analysis': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute;
  '/workspaces/$workspaceId/journeys/anonymous': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute;
  '/workspaces/$workspaceId/journeys/automations': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute;
  '/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/goals': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute;
  '/workspaces/$workspaceId/journeys/home': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute;
  '/workspaces/$workspaceId/journeys/imports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/workspaces/$workspaceId/journeys/objects': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/workspaces/$workspaceId/journeys/people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/workspaces/$workspaceId/journeys/profile_activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/workspaces/$workspaceId/journeys/profiles': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/workspaces/$workspaceId/journeys/reports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute;
  '/workspaces/$workspaceId/journeys/segments': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/journeys/template': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute;
  '/workspaces/$workspaceId/journeys/triggered': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/workspaces/$workspaceId/layouts/$layoutId': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/objects/$slug': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/people/$personId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/settings/api_credentials': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/workspaces/$workspaceId/settings/objects': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute;
  '/workspaces/$workspaceId/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute;
  '/workspaces/$workspaceId/integrations/forms/$type/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/journeys/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/journeys/campaigns/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/journeys/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute;
  '/workspaces/$workspaceId/journeys/goals/$goalId/milestones': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute;
  '/workspaces/$workspaceId/journeys/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute;
  '/workspaces/$workspaceId/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute;
  '/workspaces/$workspaceId/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute;
  '/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/workspaces/$workspaceId/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute;
  '/workspaces/$workspaceId/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/settings/actions/apps/create': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute;
  '/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/postmaster_tools': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute;
  '/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/workspaces/$workspaceId/settings/actions/push/android': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute;
  '/workspaces/$workspaceId/settings/actions/push/ios': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute;
  '/workspaces/$workspaceId/settings/actions/push/web': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute;
  '/workspaces/$workspaceId/settings/actions/sms/phone-numbers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute;
  '/workspaces/$workspaceId/settings/actions/sms/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/send': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/data-index/$type/$itemId': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute;
  '/workspaces/$workspaceId/design-studio/editor': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/setup': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/people/$personId/activity': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute;
  '/workspaces/$workspaceId/people/$personId/attributes': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute;
  '/workspaces/$workspaceId/people/$personId/devices': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute;
  '/workspaces/$workspaceId/people/$personId/drafts': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute;
  '/workspaces/$workspaceId/people/$personId/live-notifications': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/segments': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/people/$personId/sent': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/settings/actions/apps': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/workspaces/$workspaceId/settings/actions/push': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/in-app/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/inbox-message/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/push/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/sign-up-form/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/sms/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/whatsapp/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute;
  '/workspaces/$workspaceId/design-studio/journeys/$templateWorkspaceId/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute;
  '/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute;
  '/workspaces/$workspaceId/journeys/integrations/forms/$type/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/send': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/settings/actions/apps/edit/$appId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/business-info': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration/review': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/data-index/$type/$itemId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/attributes': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/devices': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/live-notifications': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/segments': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/$personId/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/attributes': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms/registration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute;
  '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute;
  '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute;
  '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId/previews/$previewId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute;
  '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/2fa_setup': typeof R2fa_setupRouteWithChildren;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/confirm_account': typeof Confirm_accountRoute;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/onboarding': typeof OnboardingRouteWithChildren;
  '/2fa_setup/new_totp': typeof R2fa_setupNew_totpRoute;
  '/2fa_setup_/$': typeof R2fa_setupSplatRoute;
  '/_authenticated/$': typeof AuthenticatedSplatRoute;
  '/_authenticated/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/dev/vercel-install': typeof DevVercelInstallRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/mobile/authorize': typeof MobileAuthorizeRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/reset_password/new_password': typeof Reset_passwordNew_passwordRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vercel/install': typeof VercelInstallRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/2fa_setup/': typeof R2fa_setupIndexRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/cli/': typeof CliIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/reset_password/': typeof Reset_passwordIndexRoute;
  '/_authenticated/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/_authenticated/internal-tools/cio-cli-tool': typeof AuthenticatedInternalToolsCioCliToolRoute;
  '/_authenticated/internal-tools/inspect': typeof AuthenticatedInternalToolsInspectRoute;
  '/_authenticated/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/_authenticated/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/_authenticated/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRouteWithChildren;
  '/_authenticated/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/_authenticated/settings/partner': typeof AuthenticatedSettingsPartnerRouteWithChildren;
  '/_authenticated/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/_authenticated/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/_authenticated/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/_authenticated/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/_authenticated/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/_authenticated/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/design-studio-embed/cio/email': typeof DesignStudioEmbedCioEmailRoute;
  '/design-studio-embed/cio/in-app': typeof DesignStudioEmbedCioInAppRoute;
  '/_authenticated/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/_authenticated/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/_authenticated/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/_authenticated/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/_authenticated/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/_authenticated/settings/billing/add-ons': typeof AuthenticatedSettingsBillingAddOnsRoute;
  '/_authenticated/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/_authenticated/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/_authenticated/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/_authenticated/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/_authenticated/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/_authenticated/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/_authenticated/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/_authenticated/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/_authenticated/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/_authenticated/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/_authenticated/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/_authenticated/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/_authenticated/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/_authenticated/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/_authenticated/settings/slack-agent_/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/_authenticated/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/_authenticated/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/_authenticated/settings/team/set_password': typeof AuthenticatedSettingsTeamSet_passwordRoute;
  '/_authenticated/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/_authenticated/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/anonymous': typeof AuthenticatedWorkspacesWorkspaceIdAnonymousRoute;
  '/_authenticated/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/collections': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDashboardRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/_authenticated/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys_': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/sign-up-forms': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute;
  '/_authenticated/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/_authenticated/workspaces/$workspaceId/transactional': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/_authenticated/settings/api_credentials/': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/_authenticated/settings/billing/': typeof AuthenticatedSettingsBillingIndexRoute;
  '/_authenticated/settings/partner/': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/_authenticated/settings/personal/': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/_authenticated/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/_authenticated/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/_authenticated/settings/team/': typeof AuthenticatedSettingsTeamIndexRoute;
  '/_authenticated/settings/workspaces/': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/_authenticated/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/_authenticated/settings/personal/security/backup_codes': typeof AuthenticatedSettingsPersonalSecurityBackup_codesRoute;
  '/_authenticated/settings/personal/security/new': typeof AuthenticatedSettingsPersonalSecurityNewRoute;
  '/_authenticated/settings/personal/security/new_backup_codes': typeof AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute;
  '/_authenticated/settings/personal/security/new_totp': typeof AuthenticatedSettingsPersonalSecurityNew_totpRoute;
  '/_authenticated/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/_authenticated/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/_authenticated/workspaces/$workspaceId/analysis/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute;
  '/_authenticated/workspaces/$workspaceId/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute;
  '/_authenticated/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/new': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute;
  '/_authenticated/workspaces/$workspaceId/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute;
  '/_authenticated/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/_authenticated/workspaces/$workspaceId/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute;
  '/_authenticated/workspaces/$workspaceId/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute;
  '/_authenticated/workspaces/$workspaceId/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/_authenticated/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/_authenticated/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/_authenticated/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/_authenticated/workspaces/$workspaceId/reports/gmail-postmaster': typeof AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute;
  '/_authenticated/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/_authenticated/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/_authenticated/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/_authenticated/workspaces/$workspaceId/settings/consent': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute;
  '/_authenticated/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/knowledge_library': typeof AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute;
  '/_authenticated/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/_authenticated/workspaces/$workspaceId/settings/live-notification-types': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/seed-lists': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/_authenticated/workspaces/$workspaceId/sign-up-forms_/$id': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute;
  '/_authenticated/workspaces/$workspaceId/sign-up-forms_/new': typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/new': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute;
  '/_authenticated/settings/billing/available-plans/': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/_authenticated/settings/personal/security/': typeof AuthenticatedSettingsPersonalSecurityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/analysis/': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/boards/': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/collections/': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/data-index/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/goals/': typeof AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes/': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/reports/': typeof AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/template/': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/_authenticated/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/_authenticated/workspaces/$workspaceId/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute;
  '/_authenticated/workspaces/$workspaceId/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute;
  '/_authenticated/workspaces/$workspaceId/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute;
  '/_authenticated/workspaces/$workspaceId/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute;
  '/_authenticated/workspaces/$workspaceId/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/assets': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/brand': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/welcome': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/goals/$goalId/milestones': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads_/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/forms_/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/api-triggered': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/one_time_sends': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/send-volume': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/goals/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/goals/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute;
  '/_authenticated/workspaces/$workspaceId/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/in_app': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/push': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/twilio': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/whatsapp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/data-index/$type/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/goals/$goalId/': typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/analysis/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/anonymous/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/goals/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/home/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/reports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/template/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/triggered/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api_credentials/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type_/$formId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/composer/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId_/milestones': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads_/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/audiences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/apps/create': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/postmaster_tools': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/push/android': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/push/ios': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/push/web': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/phone-numbers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/send': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/': typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/activity/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/devices/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/relationships/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/$personId/sent/': typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/apps/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/push/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/in-app/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/inbox-message/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/push/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sign-up-form/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sms/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/whatsapp/$id': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/journeys/$templateWorkspaceId/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type_/$formId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/belongs': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/others': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/send': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/apps/edit/$appId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/business-info': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/review': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/devices/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/relationships/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute;
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/': typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId_/previews/$previewId': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/2fa_setup'
    | '/'
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/cli'
    | '/confirm_account'
    | '/design-studio-embed'
    | '/join-request'
    | '/onboarding'
    | '/2fa_setup/new_totp'
    | '/2fa_setup/$'
    | '/$'
    | '/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account_notice/$'
    | '/dev/vercel-install'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/mobile/authorize'
    | '/no_accessible_workspaces/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/reset_password/new_password'
    | '/signup/$'
    | '/users/$'
    | '/vercel/install'
    | '/vwb-demo/$'
    | '/2fa_setup/'
    | '/cli/'
    | '/onboarding/'
    | '/reset_password/'
    | '/internal-tools/$'
    | '/internal-tools/cio-cli-tool'
    | '/internal-tools/inspect'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/billing'
    | '/settings/experimental-features'
    | '/settings/partner'
    | '/settings/privacy'
    | '/settings/receipts'
    | '/settings/slack-agent'
    | '/settings/subscription'
    | '/trial-expired/journeys'
    | '/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/design-studio-embed/cio/email'
    | '/design-studio-embed/cio/in-app'
    | '/internal-tools/'
    | '/sample-workspace/'
    | '/settings/'
    | '/workspaces/'
    | '/design-studio-embed/cio/'
    | '/settings/account/edit'
    | '/settings/billing/$'
    | '/settings/billing/add-ons'
    | '/settings/billing/billing-details'
    | '/settings/billing/billing-history'
    | '/settings/billing/checkout'
    | '/settings/billing/inbox-preview-usage'
    | '/settings/billing/llm-usage'
    | '/settings/billing/overview'
    | '/settings/billing/payment-methods'
    | '/settings/billing/usage'
    | '/settings/billing/your-plan'
    | '/settings/partner/create'
    | '/settings/personal/google-identities'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/settings/security/sso'
    | '/settings/slack-agent/link'
    | '/settings/team/add'
    | '/settings/team/invite-guest'
    | '/settings/team/set_password'
    | '/settings/workspaces/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/anonymous'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/broadcasts'
    | '/workspaces/$workspaceId/collections'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/experiments'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/geosets'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/message-library'
    | '/workspaces/$workspaceId/outcomes'
    | '/workspaces/$workspaceId/pipelines'
    | '/workspaces/$workspaceId/sign-up-forms'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/transactional'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account/'
    | '/settings/api_credentials/'
    | '/settings/billing/'
    | '/settings/partner/'
    | '/settings/personal/'
    | '/settings/roles/'
    | '/settings/security/'
    | '/settings/team/'
    | '/settings/workspaces/'
    | '/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/settings/billing/available-plans/journeys'
    | '/settings/personal/security/backup_codes'
    | '/settings/personal/security/new'
    | '/settings/personal/security/new_backup_codes'
    | '/settings/personal/security/new_totp'
    | '/settings/team/join-requests/$requestId'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/analysis/email-clients'
    | '/workspaces/$workspaceId/analysis/gmail-postmaster'
    | '/workspaces/$workspaceId/automations/new'
    | '/workspaces/$workspaceId/boards/$boardId'
    | '/workspaces/$workspaceId/broadcasts/api-triggered'
    | '/workspaces/$workspaceId/broadcasts/one_time_sends'
    | '/workspaces/$workspaceId/broadcasts/send-volume'
    | '/workspaces/$workspaceId/broadcasts/new'
    | '/workspaces/$workspaceId/collections/$collectionId'
    | '/workspaces/$workspaceId/data-index/$'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/design-studio/dashboard'
    | '/workspaces/$workspaceId/design-studio/global-styles'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/experiments/$experimentId'
    | '/workspaces/$workspaceId/experiments/new'
    | '/workspaces/$workspaceId/geosets/$geosetId'
    | '/workspaces/$workspaceId/geosets/import'
    | '/workspaces/$workspaceId/geosets/new'
    | '/workspaces/$workspaceId/goals/$goalId'
    | '/workspaces/$workspaceId/goals/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/imports/new'
    | '/workspaces/$workspaceId/integrations/$type'
    | '/workspaces/$workspaceId/integrations/all'
    | '/workspaces/$workspaceId/integrations/cdp_in'
    | '/workspaces/$workspaceId/integrations/cdp_out'
    | '/workspaces/$workspaceId/integrations/customerio'
    | '/workspaces/$workspaceId/integrations/facebook_lead_ads'
    | '/workspaces/$workspaceId/integrations/forms'
    | '/workspaces/$workspaceId/integrations/mparticle_out'
    | '/workspaces/$workspaceId/integrations/segment_in'
    | '/workspaces/$workspaceId/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/collections'
    | '/workspaces/$workspaceId/journeys/dashboard'
    | '/workspaces/$workspaceId/journeys/deliveries'
    | '/workspaces/$workspaceId/journeys/drafts'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/message-library'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/layouts/new'
    | '/workspaces/$workspaceId/layouts/starters'
    | '/workspaces/$workspaceId/message_activity/$'
    | '/workspaces/$workspaceId/outcomes/$goalId'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/people/$personId'
    | '/workspaces/$workspaceId/people/create'
    | '/workspaces/$workspaceId/people/merge'
    | '/workspaces/$workspaceId/people/new'
    | '/workspaces/$workspaceId/people/welcome'
    | '/workspaces/$workspaceId/profile_activity/$tab'
    | '/workspaces/$workspaceId/profiles/create'
    | '/workspaces/$workspaceId/profiles/merge'
    | '/workspaces/$workspaceId/profiles/new'
    | '/workspaces/$workspaceId/profiles/welcome'
    | '/workspaces/$workspaceId/reports/deliverability'
    | '/workspaces/$workspaceId/reports/email-clients'
    | '/workspaces/$workspaceId/reports/gmail-postmaster'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/confirm_delete'
    | '/workspaces/$workspaceId/settings/consent'
    | '/workspaces/$workspaceId/settings/edit'
    | '/workspaces/$workspaceId/settings/geofences'
    | '/workspaces/$workspaceId/settings/knowledge_library'
    | '/workspaces/$workspaceId/settings/language'
    | '/workspaces/$workspaceId/settings/live-notification-types'
    | '/workspaces/$workspaceId/settings/llm_configuration'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/seed-lists'
    | '/workspaces/$workspaceId/settings/subscription_center'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/sign-up-forms/$id'
    | '/workspaces/$workspaceId/sign-up-forms/new'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/template/$templateId'
    | '/workspaces/$workspaceId/transactional/new'
    | '/settings/billing/available-plans/'
    | '/settings/personal/security/'
    | '/workspaces/$workspaceId/agent/'
    | '/workspaces/$workspaceId/analysis/'
    | '/workspaces/$workspaceId/automations/'
    | '/workspaces/$workspaceId/boards/'
    | '/workspaces/$workspaceId/broadcasts/'
    | '/workspaces/$workspaceId/collections/'
    | '/workspaces/$workspaceId/data-index/'
    | '/workspaces/$workspaceId/design-studio/'
    | '/workspaces/$workspaceId/experiments/'
    | '/workspaces/$workspaceId/geosets/'
    | '/workspaces/$workspaceId/goals/'
    | '/workspaces/$workspaceId/home/'
    | '/workspaces/$workspaceId/imports/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/layouts/'
    | '/workspaces/$workspaceId/objects/'
    | '/workspaces/$workspaceId/outcomes/'
    | '/workspaces/$workspaceId/parcel/'
    | '/workspaces/$workspaceId/people/'
    | '/workspaces/$workspaceId/pipelines/'
    | '/workspaces/$workspaceId/profile_activity/'
    | '/workspaces/$workspaceId/profiles/'
    | '/workspaces/$workspaceId/reports/'
    | '/workspaces/$workspaceId/segments/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/snippets/'
    | '/workspaces/$workspaceId/template/'
    | '/settings/team/members/$userId/edit'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/automations/welcome/create'
    | '/workspaces/$workspaceId/collections/$collectionId/data'
    | '/workspaces/$workspaceId/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/composer/actions/$actionId'
    | '/workspaces/$workspaceId/design-studio/assets'
    | '/workspaces/$workspaceId/design-studio/brand'
    | '/workspaces/$workspaceId/design-studio/welcome'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/workspaces/$workspaceId/goals/$goalId/milestones'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/integrations/all/developers'
    | '/workspaces/$workspaceId/integrations/all/directory'
    | '/workspaces/$workspaceId/integrations/all/overview'
    | '/workspaces/$workspaceId/integrations/all/webhooks'
    | '/workspaces/$workspaceId/integrations/data_out/$type'
    | '/workspaces/$workspaceId/integrations/facebook_lead_ads/$formId'
    | '/workspaces/$workspaceId/integrations/forms/$type'
    | '/workspaces/$workspaceId/integrations/forms/settings'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/automations/new'
    | '/workspaces/$workspaceId/journeys/broadcasts/api-triggered'
    | '/workspaces/$workspaceId/journeys/broadcasts/new'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletters'
    | '/workspaces/$workspaceId/journeys/broadcasts/one_time_sends'
    | '/workspaces/$workspaceId/journeys/broadcasts/send-volume'
    | '/workspaces/$workspaceId/journeys/broadcasts/welcome'
    | '/workspaces/$workspaceId/journeys/campaigns/new'
    | '/workspaces/$workspaceId/journeys/data-index/$'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/goals/$'
    | '/workspaces/$workspaceId/journeys/goals/$goalId'
    | '/workspaces/$workspaceId/journeys/goals/new'
    | '/workspaces/$workspaceId/journeys/imports/new'
    | '/workspaces/$workspaceId/journeys/integrations/$type'
    | '/workspaces/$workspaceId/journeys/integrations/all'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads'
    | '/workspaces/$workspaceId/journeys/integrations/forms'
    | '/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/layouts/new'
    | '/workspaces/$workspaceId/journeys/layouts/starters'
    | '/workspaces/$workspaceId/journeys/message_activity/$'
    | '/workspaces/$workspaceId/journeys/outbox/$'
    | '/workspaces/$workspaceId/journeys/people/create'
    | '/workspaces/$workspaceId/journeys/people/merge'
    | '/workspaces/$workspaceId/journeys/people/new'
    | '/workspaces/$workspaceId/journeys/people/welcome'
    | '/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/workspaces/$workspaceId/journeys/profiles/create'
    | '/workspaces/$workspaceId/journeys/profiles/merge'
    | '/workspaces/$workspaceId/journeys/profiles/new'
    | '/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/journeys/template/$templateId'
    | '/workspaces/$workspaceId/journeys/transactional/new'
    | '/workspaces/$workspaceId/journeys/triggered/new'
    | '/workspaces/$workspaceId/journeys/v2/$'
    | '/workspaces/$workspaceId/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/objects/$slug/guide'
    | '/workspaces/$workspaceId/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/segments/$segmentId/audiences'
    | '/workspaces/$workspaceId/segments/$segmentId/overview'
    | '/workspaces/$workspaceId/segments/$segmentId/people'
    | '/workspaces/$workspaceId/segments/$segmentId/usage'
    | '/workspaces/$workspaceId/settings/actions/email'
    | '/workspaces/$workspaceId/settings/actions/in_app'
    | '/workspaces/$workspaceId/settings/actions/line'
    | '/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/workspaces/$workspaceId/settings/actions/push'
    | '/workspaces/$workspaceId/settings/actions/slack'
    | '/workspaces/$workspaceId/settings/actions/sms'
    | '/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/workspaces/$workspaceId/settings/actions/twilio'
    | '/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/workspaces/$workspaceId/settings/actions/url_params'
    | '/workspaces/$workspaceId/settings/actions/whatsapp'
    | '/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/workspaces/$workspaceId/settings/objects/new'
    | '/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup'
    | '/workspaces/$workspaceId/agent/skills/'
    | '/workspaces/$workspaceId/automations/$campaignId/'
    | '/workspaces/$workspaceId/automations/welcome/'
    | '/workspaces/$workspaceId/campaigns/$campaignId/'
    | '/workspaces/$workspaceId/collections/$collectionId/'
    | '/workspaces/$workspaceId/data-index/$type/'
    | '/workspaces/$workspaceId/geosets/$geosetId/'
    | '/workspaces/$workspaceId/goals/$goalId/'
    | '/workspaces/$workspaceId/home/workspace-setup/'
    | '/workspaces/$workspaceId/imports/$importId/'
    | '/workspaces/$workspaceId/integrations/all/'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/'
    | '/workspaces/$workspaceId/journeys/activity_logs/'
    | '/workspaces/$workspaceId/journeys/analysis/'
    | '/workspaces/$workspaceId/journeys/anonymous/'
    | '/workspaces/$workspaceId/journeys/automations/'
    | '/workspaces/$workspaceId/journeys/broadcasts/'
    | '/workspaces/$workspaceId/journeys/campaigns/'
    | '/workspaces/$workspaceId/journeys/collections/'
    | '/workspaces/$workspaceId/journeys/data-index/'
    | '/workspaces/$workspaceId/journeys/geofences/'
    | '/workspaces/$workspaceId/journeys/goals/'
    | '/workspaces/$workspaceId/journeys/home/'
    | '/workspaces/$workspaceId/journeys/imports/'
    | '/workspaces/$workspaceId/journeys/integrations/'
    | '/workspaces/$workspaceId/journeys/layouts/'
    | '/workspaces/$workspaceId/journeys/objects/'
    | '/workspaces/$workspaceId/journeys/people/'
    | '/workspaces/$workspaceId/journeys/profile_activity/'
    | '/workspaces/$workspaceId/journeys/profiles/'
    | '/workspaces/$workspaceId/journeys/reports/'
    | '/workspaces/$workspaceId/journeys/segments/'
    | '/workspaces/$workspaceId/journeys/snippets/'
    | '/workspaces/$workspaceId/journeys/template/'
    | '/workspaces/$workspaceId/journeys/transactional/'
    | '/workspaces/$workspaceId/journeys/triggered/'
    | '/workspaces/$workspaceId/layouts/$layoutId/'
    | '/workspaces/$workspaceId/objects/$slug/'
    | '/workspaces/$workspaceId/people/$personId/'
    | '/workspaces/$workspaceId/pipelines/destinations/'
    | '/workspaces/$workspaceId/pipelines/sources/'
    | '/workspaces/$workspaceId/settings/api_credentials/'
    | '/workspaces/$workspaceId/settings/llm_configuration/'
    | '/workspaces/$workspaceId/settings/objects/'
    | '/workspaces/$workspaceId/settings/subscription_center/'
    | '/workspaces/$workspaceId/settings/webhook_configuration/'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId'
    | '/workspaces/$workspaceId/design-studio/editor/$id'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/integrations/audiences/$type/settings'
    | '/workspaces/$workspaceId/integrations/audiences/$type/setup'
    | '/workspaces/$workspaceId/integrations/forms/$type/$formId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/journeys/automations/welcome/create'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow'
    | '/workspaces/$workspaceId/journeys/campaigns/welcome/create'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/journeys/composer/actions/$actionId'
    | '/workspaces/$workspaceId/journeys/goals/$goalId/milestones'
    | '/workspaces/$workspaceId/journeys/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads/$formId'
    | '/workspaces/$workspaceId/journeys/integrations/forms/$type'
    | '/workspaces/$workspaceId/journeys/integrations/forms/settings'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/audiences'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/overview'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/people'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/usage'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/activity'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/relationships'
    | '/workspaces/$workspaceId/people/$personId/attributes/edit'
    | '/workspaces/$workspaceId/people/$personId/journeys/$subjectId'
    | '/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId'
    | '/workspaces/$workspaceId/people/$personId/segments/belongs'
    | '/workspaces/$workspaceId/people/$personId/segments/others'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/settings/actions/apps/create'
    | '/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/postmaster_tools'
    | '/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/workspaces/$workspaceId/settings/actions/push/android'
    | '/workspaces/$workspaceId/settings/actions/push/ios'
    | '/workspaces/$workspaceId/settings/actions/push/web'
    | '/workspaces/$workspaceId/settings/actions/sms/phone-numbers'
    | '/workspaces/$workspaceId/settings/actions/sms/registration'
    | '/workspaces/$workspaceId/settings/actions/sms/settings'
    | '/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/drafts'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/metrics'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/send'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/review'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/settings'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/'
    | '/workspaces/$workspaceId/data-index/$type/$itemId/'
    | '/workspaces/$workspaceId/design-studio/editor/'
    | '/workspaces/$workspaceId/dev/db/campaigns/'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/'
    | '/workspaces/$workspaceId/imports/$importId/setup/'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/'
    | '/workspaces/$workspaceId/journeys/automations/welcome/'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/'
    | '/workspaces/$workspaceId/journeys/campaigns/welcome/'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/'
    | '/workspaces/$workspaceId/journeys/data-index/$type/'
    | '/workspaces/$workspaceId/journeys/home/workspace-setup/'
    | '/workspaces/$workspaceId/journeys/imports/$importId/'
    | '/workspaces/$workspaceId/journeys/integrations/all/'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/'
    | '/workspaces/$workspaceId/journeys/objects/$slug/'
    | '/workspaces/$workspaceId/journeys/people/$personId/'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/'
    | '/workspaces/$workspaceId/people/$personId/activity/'
    | '/workspaces/$workspaceId/people/$personId/attributes/'
    | '/workspaces/$workspaceId/people/$personId/devices/'
    | '/workspaces/$workspaceId/people/$personId/drafts/'
    | '/workspaces/$workspaceId/people/$personId/journeys/'
    | '/workspaces/$workspaceId/people/$personId/live-notifications/'
    | '/workspaces/$workspaceId/people/$personId/relationships/'
    | '/workspaces/$workspaceId/people/$personId/segments/'
    | '/workspaces/$workspaceId/people/$personId/sent/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/workspaces/$workspaceId/settings/actions/apps/'
    | '/workspaces/$workspaceId/settings/actions/email/'
    | '/workspaces/$workspaceId/settings/actions/push/'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/'
    | '/workspaces/$workspaceId/settings/actions/sms/'
    | '/workspaces/$workspaceId/settings/actions/url_params/'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/form-submissions'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journey_metrics'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journeys'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/metrics'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/triggering_details'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/content'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/form-submissions'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/recipients'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/test'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/content'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/recipients'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/review'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/schedule'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/tracking'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/design-studio/editor/in-app/$id'
    | '/workspaces/$workspaceId/design-studio/editor/inbox-message/$id'
    | '/workspaces/$workspaceId/design-studio/editor/push/$id'
    | '/workspaces/$workspaceId/design-studio/editor/sign-up-form/$id'
    | '/workspaces/$workspaceId/design-studio/editor/sms/$id'
    | '/workspaces/$workspaceId/design-studio/editor/whatsapp/$id'
    | '/workspaces/$workspaceId/design-studio/journeys/$templateWorkspaceId/$templateId'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings'
    | '/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup'
    | '/workspaces/$workspaceId/journeys/integrations/forms/$type/$formId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships'
    | '/workspaces/$workspaceId/journeys/people/$personId/attributes/edit'
    | '/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId'
    | '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments/belongs'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments/others'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/send'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/settings/actions/apps/edit/$appId'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/business-info'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/review'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/sent/'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests/'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/'
    | '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/'
    | '/workspaces/$workspaceId/journeys/people/$personId/activity/'
    | '/workspaces/$workspaceId/journeys/people/$personId/attributes/'
    | '/workspaces/$workspaceId/journeys/people/$personId/devices/'
    | '/workspaces/$workspaceId/journeys/people/$personId/drafts/'
    | '/workspaces/$workspaceId/journeys/people/$personId/journeys/'
    | '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/'
    | '/workspaces/$workspaceId/journeys/people/$personId/relationships/'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments/'
    | '/workspaces/$workspaceId/journeys/people/$personId/sent/'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/'
    | '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId/previews/$previewId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/confirm_account'
    | '/design-studio-embed'
    | '/join-request'
    | '/2fa_setup/new_totp'
    | '/2fa_setup/$'
    | '/$'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account_notice/$'
    | '/dev/vercel-install'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/mobile/authorize'
    | '/no_accessible_workspaces/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/reset_password/new_password'
    | '/signup/$'
    | '/users/$'
    | '/vercel/install'
    | '/vwb-demo/$'
    | '/2fa_setup'
    | '/'
    | '/cli'
    | '/onboarding'
    | '/reset_password'
    | '/internal-tools/$'
    | '/internal-tools/cio-cli-tool'
    | '/internal-tools/inspect'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/experimental-features'
    | '/settings/privacy'
    | '/settings/receipts'
    | '/settings/slack-agent'
    | '/settings/subscription'
    | '/trial-expired/journeys'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/design-studio-embed/cio/email'
    | '/design-studio-embed/cio/in-app'
    | '/internal-tools'
    | '/sample-workspace'
    | '/settings'
    | '/workspaces'
    | '/design-studio-embed/cio'
    | '/settings/account/edit'
    | '/settings/billing/$'
    | '/settings/billing/add-ons'
    | '/settings/billing/billing-details'
    | '/settings/billing/billing-history'
    | '/settings/billing/checkout'
    | '/settings/billing/inbox-preview-usage'
    | '/settings/billing/llm-usage'
    | '/settings/billing/overview'
    | '/settings/billing/payment-methods'
    | '/settings/billing/usage'
    | '/settings/billing/your-plan'
    | '/settings/partner/create'
    | '/settings/personal/google-identities'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/settings/security/sso'
    | '/settings/slack-agent/link'
    | '/settings/team/add'
    | '/settings/team/invite-guest'
    | '/settings/team/set_password'
    | '/settings/workspaces/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/anonymous'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/message-library'
    | '/workspaces/$workspaceId/sign-up-forms'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/transactional'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account'
    | '/settings/api_credentials'
    | '/settings/billing'
    | '/settings/partner'
    | '/settings/personal'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/team'
    | '/settings/workspaces'
    | '/workspaces/$workspaceId'
    | '/pipelines/workspaces/$workspaceId'
    | '/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/settings/billing/available-plans/journeys'
    | '/settings/personal/security/backup_codes'
    | '/settings/personal/security/new'
    | '/settings/personal/security/new_backup_codes'
    | '/settings/personal/security/new_totp'
    | '/settings/team/join-requests/$requestId'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/analysis/email-clients'
    | '/workspaces/$workspaceId/analysis/gmail-postmaster'
    | '/workspaces/$workspaceId/automations/new'
    | '/workspaces/$workspaceId/boards/$boardId'
    | '/workspaces/$workspaceId/broadcasts/api-triggered'
    | '/workspaces/$workspaceId/broadcasts/one_time_sends'
    | '/workspaces/$workspaceId/broadcasts/send-volume'
    | '/workspaces/$workspaceId/broadcasts/new'
    | '/workspaces/$workspaceId/data-index/$'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/design-studio/dashboard'
    | '/workspaces/$workspaceId/design-studio/global-styles'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/experiments/$experimentId'
    | '/workspaces/$workspaceId/experiments/new'
    | '/workspaces/$workspaceId/geosets/import'
    | '/workspaces/$workspaceId/geosets/new'
    | '/workspaces/$workspaceId/goals/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/imports/new'
    | '/workspaces/$workspaceId/integrations/$type'
    | '/workspaces/$workspaceId/integrations/cdp_in'
    | '/workspaces/$workspaceId/integrations/cdp_out'
    | '/workspaces/$workspaceId/integrations/customerio'
    | '/workspaces/$workspaceId/integrations/facebook_lead_ads'
    | '/workspaces/$workspaceId/integrations/forms'
    | '/workspaces/$workspaceId/integrations/mparticle_out'
    | '/workspaces/$workspaceId/integrations/segment_in'
    | '/workspaces/$workspaceId/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/dashboard'
    | '/workspaces/$workspaceId/journeys/deliveries'
    | '/workspaces/$workspaceId/journeys/drafts'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/message-library'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/layouts/new'
    | '/workspaces/$workspaceId/layouts/starters'
    | '/workspaces/$workspaceId/message_activity/$'
    | '/workspaces/$workspaceId/outcomes/$goalId'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/people/create'
    | '/workspaces/$workspaceId/people/merge'
    | '/workspaces/$workspaceId/people/new'
    | '/workspaces/$workspaceId/people/welcome'
    | '/workspaces/$workspaceId/profile_activity/$tab'
    | '/workspaces/$workspaceId/profiles/create'
    | '/workspaces/$workspaceId/profiles/merge'
    | '/workspaces/$workspaceId/profiles/new'
    | '/workspaces/$workspaceId/profiles/welcome'
    | '/workspaces/$workspaceId/reports/deliverability'
    | '/workspaces/$workspaceId/reports/email-clients'
    | '/workspaces/$workspaceId/reports/gmail-postmaster'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/confirm_delete'
    | '/workspaces/$workspaceId/settings/consent'
    | '/workspaces/$workspaceId/settings/edit'
    | '/workspaces/$workspaceId/settings/geofences'
    | '/workspaces/$workspaceId/settings/knowledge_library'
    | '/workspaces/$workspaceId/settings/language'
    | '/workspaces/$workspaceId/settings/live-notification-types'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/seed-lists'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/sign-up-forms/$id'
    | '/workspaces/$workspaceId/sign-up-forms/new'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/template/$templateId'
    | '/workspaces/$workspaceId/transactional/new'
    | '/settings/billing/available-plans'
    | '/settings/personal/security'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/analysis'
    | '/workspaces/$workspaceId/automations'
    | '/workspaces/$workspaceId/boards'
    | '/workspaces/$workspaceId/broadcasts'
    | '/workspaces/$workspaceId/collections'
    | '/workspaces/$workspaceId/data-index'
    | '/workspaces/$workspaceId/experiments'
    | '/workspaces/$workspaceId/geosets'
    | '/workspaces/$workspaceId/goals'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/imports'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/layouts'
    | '/workspaces/$workspaceId/objects'
    | '/workspaces/$workspaceId/outcomes'
    | '/workspaces/$workspaceId/parcel'
    | '/workspaces/$workspaceId/people'
    | '/workspaces/$workspaceId/pipelines'
    | '/workspaces/$workspaceId/profile_activity'
    | '/workspaces/$workspaceId/profiles'
    | '/workspaces/$workspaceId/reports'
    | '/workspaces/$workspaceId/segments'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/template'
    | '/settings/team/members/$userId/edit'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/automations/welcome/create'
    | '/workspaces/$workspaceId/collections/$collectionId/data'
    | '/workspaces/$workspaceId/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/composer/actions/$actionId'
    | '/workspaces/$workspaceId/design-studio/assets'
    | '/workspaces/$workspaceId/design-studio/brand'
    | '/workspaces/$workspaceId/design-studio/welcome'
    | '/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/workspaces/$workspaceId/goals/$goalId/milestones'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/integrations/all/developers'
    | '/workspaces/$workspaceId/integrations/all/directory'
    | '/workspaces/$workspaceId/integrations/all/overview'
    | '/workspaces/$workspaceId/integrations/all/webhooks'
    | '/workspaces/$workspaceId/integrations/data_out/$type'
    | '/workspaces/$workspaceId/integrations/facebook_lead_ads/$formId'
    | '/workspaces/$workspaceId/integrations/forms/$type'
    | '/workspaces/$workspaceId/integrations/forms/settings'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/automations/new'
    | '/workspaces/$workspaceId/journeys/broadcasts/api-triggered'
    | '/workspaces/$workspaceId/journeys/broadcasts/new'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletters'
    | '/workspaces/$workspaceId/journeys/broadcasts/one_time_sends'
    | '/workspaces/$workspaceId/journeys/broadcasts/send-volume'
    | '/workspaces/$workspaceId/journeys/broadcasts/welcome'
    | '/workspaces/$workspaceId/journeys/campaigns/new'
    | '/workspaces/$workspaceId/journeys/data-index/$'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/goals/$'
    | '/workspaces/$workspaceId/journeys/goals/$goalId'
    | '/workspaces/$workspaceId/journeys/goals/new'
    | '/workspaces/$workspaceId/journeys/imports/new'
    | '/workspaces/$workspaceId/journeys/integrations/$type'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads'
    | '/workspaces/$workspaceId/journeys/integrations/forms'
    | '/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/layouts/new'
    | '/workspaces/$workspaceId/journeys/layouts/starters'
    | '/workspaces/$workspaceId/journeys/message_activity/$'
    | '/workspaces/$workspaceId/journeys/outbox/$'
    | '/workspaces/$workspaceId/journeys/people/create'
    | '/workspaces/$workspaceId/journeys/people/merge'
    | '/workspaces/$workspaceId/journeys/people/new'
    | '/workspaces/$workspaceId/journeys/people/welcome'
    | '/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/workspaces/$workspaceId/journeys/profiles/create'
    | '/workspaces/$workspaceId/journeys/profiles/merge'
    | '/workspaces/$workspaceId/journeys/profiles/new'
    | '/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/journeys/template/$templateId'
    | '/workspaces/$workspaceId/journeys/transactional/new'
    | '/workspaces/$workspaceId/journeys/triggered/new'
    | '/workspaces/$workspaceId/journeys/v2/$'
    | '/workspaces/$workspaceId/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/objects/$slug/guide'
    | '/workspaces/$workspaceId/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/segments/$segmentId/audiences'
    | '/workspaces/$workspaceId/segments/$segmentId/overview'
    | '/workspaces/$workspaceId/segments/$segmentId/people'
    | '/workspaces/$workspaceId/segments/$segmentId/usage'
    | '/workspaces/$workspaceId/settings/actions/in_app'
    | '/workspaces/$workspaceId/settings/actions/line'
    | '/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/workspaces/$workspaceId/settings/actions/slack'
    | '/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/workspaces/$workspaceId/settings/actions/twilio'
    | '/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/workspaces/$workspaceId/settings/actions/whatsapp'
    | '/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/workspaces/$workspaceId/settings/objects/new'
    | '/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/automations/$campaignId'
    | '/workspaces/$workspaceId/automations/welcome'
    | '/workspaces/$workspaceId/campaigns/$campaignId'
    | '/workspaces/$workspaceId/collections/$collectionId'
    | '/workspaces/$workspaceId/data-index/$type'
    | '/workspaces/$workspaceId/geosets/$geosetId'
    | '/workspaces/$workspaceId/goals/$goalId'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/imports/$importId'
    | '/workspaces/$workspaceId/integrations/all'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/activity_logs'
    | '/workspaces/$workspaceId/journeys/analysis'
    | '/workspaces/$workspaceId/journeys/anonymous'
    | '/workspaces/$workspaceId/journeys/automations'
    | '/workspaces/$workspaceId/journeys/broadcasts'
    | '/workspaces/$workspaceId/journeys/campaigns'
    | '/workspaces/$workspaceId/journeys/collections'
    | '/workspaces/$workspaceId/journeys/data-index'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/goals'
    | '/workspaces/$workspaceId/journeys/home'
    | '/workspaces/$workspaceId/journeys/imports'
    | '/workspaces/$workspaceId/journeys/integrations'
    | '/workspaces/$workspaceId/journeys/layouts'
    | '/workspaces/$workspaceId/journeys/objects'
    | '/workspaces/$workspaceId/journeys/people'
    | '/workspaces/$workspaceId/journeys/profile_activity'
    | '/workspaces/$workspaceId/journeys/profiles'
    | '/workspaces/$workspaceId/journeys/reports'
    | '/workspaces/$workspaceId/journeys/segments'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/journeys/template'
    | '/workspaces/$workspaceId/journeys/transactional'
    | '/workspaces/$workspaceId/journeys/triggered'
    | '/workspaces/$workspaceId/layouts/$layoutId'
    | '/workspaces/$workspaceId/objects/$slug'
    | '/workspaces/$workspaceId/people/$personId'
    | '/workspaces/$workspaceId/pipelines/destinations'
    | '/workspaces/$workspaceId/pipelines/sources'
    | '/workspaces/$workspaceId/settings/api_credentials'
    | '/workspaces/$workspaceId/settings/llm_configuration'
    | '/workspaces/$workspaceId/settings/objects'
    | '/workspaces/$workspaceId/settings/subscription_center'
    | '/workspaces/$workspaceId/settings/webhook_configuration'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId'
    | '/workspaces/$workspaceId/design-studio/editor/$id'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/integrations/audiences/$type/settings'
    | '/workspaces/$workspaceId/integrations/audiences/$type/setup'
    | '/workspaces/$workspaceId/integrations/forms/$type/$formId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/journeys/automations/welcome/create'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow'
    | '/workspaces/$workspaceId/journeys/campaigns/welcome/create'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/journeys/composer/actions/$actionId'
    | '/workspaces/$workspaceId/journeys/goals/$goalId/milestones'
    | '/workspaces/$workspaceId/journeys/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads/$formId'
    | '/workspaces/$workspaceId/journeys/integrations/forms/$type'
    | '/workspaces/$workspaceId/journeys/integrations/forms/settings'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/audiences'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/overview'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/people'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/usage'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/activity'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/relationships'
    | '/workspaces/$workspaceId/people/$personId/attributes/edit'
    | '/workspaces/$workspaceId/people/$personId/journeys/$subjectId'
    | '/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId'
    | '/workspaces/$workspaceId/people/$personId/segments/belongs'
    | '/workspaces/$workspaceId/people/$personId/segments/others'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/settings/actions/apps/create'
    | '/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/postmaster_tools'
    | '/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/workspaces/$workspaceId/settings/actions/push/android'
    | '/workspaces/$workspaceId/settings/actions/push/ios'
    | '/workspaces/$workspaceId/settings/actions/push/web'
    | '/workspaces/$workspaceId/settings/actions/sms/phone-numbers'
    | '/workspaces/$workspaceId/settings/actions/sms/settings'
    | '/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/drafts'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/metrics'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/send'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/review'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/settings'
    | '/workspaces/$workspaceId/automations/$campaignId/overview'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview'
    | '/workspaces/$workspaceId/data-index/$type/$itemId'
    | '/workspaces/$workspaceId/design-studio/editor'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/workspaces/$workspaceId/imports/$importId/setup'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId'
    | '/workspaces/$workspaceId/journeys/automations/welcome'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId'
    | '/workspaces/$workspaceId/journeys/campaigns/welcome'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId'
    | '/workspaces/$workspaceId/journeys/data-index/$type'
    | '/workspaces/$workspaceId/journeys/home/workspace-setup'
    | '/workspaces/$workspaceId/journeys/imports/$importId'
    | '/workspaces/$workspaceId/journeys/integrations/all'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId'
    | '/workspaces/$workspaceId/journeys/objects/$slug'
    | '/workspaces/$workspaceId/journeys/people/$personId'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId'
    | '/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/people/$personId/activity'
    | '/workspaces/$workspaceId/people/$personId/attributes'
    | '/workspaces/$workspaceId/people/$personId/devices'
    | '/workspaces/$workspaceId/people/$personId/drafts'
    | '/workspaces/$workspaceId/people/$personId/journeys'
    | '/workspaces/$workspaceId/people/$personId/live-notifications'
    | '/workspaces/$workspaceId/people/$personId/relationships'
    | '/workspaces/$workspaceId/people/$personId/segments'
    | '/workspaces/$workspaceId/people/$personId/sent'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/settings/actions/apps'
    | '/workspaces/$workspaceId/settings/actions/email'
    | '/workspaces/$workspaceId/settings/actions/push'
    | '/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/workspaces/$workspaceId/settings/actions/sms'
    | '/workspaces/$workspaceId/settings/actions/url_params'
    | '/workspaces/$workspaceId/settings/subscription_center/topics'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/form-submissions'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journey_metrics'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journeys'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/metrics'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/triggering_details'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/content'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/form-submissions'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/recipients'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/test'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/content'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/recipients'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/review'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/schedule'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/tracking'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/design-studio/editor/in-app/$id'
    | '/workspaces/$workspaceId/design-studio/editor/inbox-message/$id'
    | '/workspaces/$workspaceId/design-studio/editor/push/$id'
    | '/workspaces/$workspaceId/design-studio/editor/sign-up-form/$id'
    | '/workspaces/$workspaceId/design-studio/editor/sms/$id'
    | '/workspaces/$workspaceId/design-studio/editor/whatsapp/$id'
    | '/workspaces/$workspaceId/design-studio/journeys/$templateWorkspaceId/$templateId'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings'
    | '/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup'
    | '/workspaces/$workspaceId/journeys/integrations/forms/$type/$formId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships'
    | '/workspaces/$workspaceId/journeys/people/$personId/attributes/edit'
    | '/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId'
    | '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments/belongs'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments/others'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/drafts'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/send'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/settings/actions/apps/edit/$appId'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/business-info'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact'
    | '/workspaces/$workspaceId/settings/actions/sms/registration/review'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/sent'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview'
    | '/workspaces/$workspaceId/journeys/data-index/$type/$itemId'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/journeys/people/$personId/activity'
    | '/workspaces/$workspaceId/journeys/people/$personId/attributes'
    | '/workspaces/$workspaceId/journeys/people/$personId/devices'
    | '/workspaces/$workspaceId/journeys/people/$personId/drafts'
    | '/workspaces/$workspaceId/journeys/people/$personId/journeys'
    | '/workspaces/$workspaceId/journeys/people/$personId/live-notifications'
    | '/workspaces/$workspaceId/journeys/people/$personId/relationships'
    | '/workspaces/$workspaceId/journeys/people/$personId/segments'
    | '/workspaces/$workspaceId/journeys/people/$personId/sent'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/attributes'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains'
    | '/workspaces/$workspaceId/settings/actions/sms/registration'
    | '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent'
    | '/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests'
    | '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes'
    | '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId'
    | '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts'
    | '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId/previews/$previewId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step'
    | '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId'
    | '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId';
  id:
    | '__root__'
    | '/2fa_setup'
    | '/_authenticated'
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/cli'
    | '/confirm_account'
    | '/design-studio-embed'
    | '/join-request'
    | '/onboarding'
    | '/2fa_setup/new_totp'
    | '/2fa_setup_/$'
    | '/_authenticated/$'
    | '/_authenticated/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account_notice/$'
    | '/dev/vercel-install'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/mobile/authorize'
    | '/no_accessible_workspaces/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/reset_password/new_password'
    | '/signup/$'
    | '/users/$'
    | '/vercel/install'
    | '/vwb-demo/$'
    | '/2fa_setup/'
    | '/_authenticated/'
    | '/cli/'
    | '/onboarding/'
    | '/reset_password/'
    | '/_authenticated/internal-tools/$'
    | '/_authenticated/internal-tools/cio-cli-tool'
    | '/_authenticated/internal-tools/inspect'
    | '/_authenticated/sample-workspace/$'
    | '/_authenticated/settings/$'
    | '/_authenticated/settings/ai'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/experimental-features'
    | '/_authenticated/settings/partner'
    | '/_authenticated/settings/privacy'
    | '/_authenticated/settings/receipts'
    | '/_authenticated/settings/slack-agent'
    | '/_authenticated/settings/subscription'
    | '/_authenticated/trial-expired/journeys'
    | '/_authenticated/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/design-studio-embed/cio/email'
    | '/design-studio-embed/cio/in-app'
    | '/_authenticated/internal-tools/'
    | '/_authenticated/sample-workspace/'
    | '/_authenticated/settings/'
    | '/_authenticated/workspaces/'
    | '/design-studio-embed/cio/'
    | '/_authenticated/settings/account/edit'
    | '/_authenticated/settings/billing/$'
    | '/_authenticated/settings/billing/add-ons'
    | '/_authenticated/settings/billing/billing-details'
    | '/_authenticated/settings/billing/billing-history'
    | '/_authenticated/settings/billing/checkout'
    | '/_authenticated/settings/billing/inbox-preview-usage'
    | '/_authenticated/settings/billing/llm-usage'
    | '/_authenticated/settings/billing/overview'
    | '/_authenticated/settings/billing/payment-methods'
    | '/_authenticated/settings/billing/usage'
    | '/_authenticated/settings/billing/your-plan'
    | '/_authenticated/settings/partner/create'
    | '/_authenticated/settings/personal/google-identities'
    | '/_authenticated/settings/roles/$roleId'
    | '/_authenticated/settings/roles/new'
    | '/_authenticated/settings/security/sso'
    | '/_authenticated/settings/slack-agent_/link'
    | '/_authenticated/settings/team/add'
    | '/_authenticated/settings/team/invite-guest'
    | '/_authenticated/settings/team/set_password'
    | '/_authenticated/settings/workspaces/new'
    | '/_authenticated/workspaces/$workspaceId/$'
    | '/_authenticated/workspaces/$workspaceId/agent'
    | '/_authenticated/workspaces/$workspaceId/anonymous'
    | '/_authenticated/workspaces/$workspaceId/assets'
    | '/_authenticated/workspaces/$workspaceId/broadcasts'
    | '/_authenticated/workspaces/$workspaceId/collections'
    | '/_authenticated/workspaces/$workspaceId/dashboard'
    | '/_authenticated/workspaces/$workspaceId/design-studio'
    | '/_authenticated/workspaces/$workspaceId/experiments'
    | '/_authenticated/workspaces/$workspaceId/exports'
    | '/_authenticated/workspaces/$workspaceId/geosets'
    | '/_authenticated/workspaces/$workspaceId/health'
    | '/_authenticated/workspaces/$workspaceId/home'
    | '/_authenticated/workspaces/$workspaceId/journeys_'
    | '/_authenticated/workspaces/$workspaceId/message-library'
    | '/_authenticated/workspaces/$workspaceId/outcomes'
    | '/_authenticated/workspaces/$workspaceId/pipelines'
    | '/_authenticated/workspaces/$workspaceId/sign-up-forms'
    | '/_authenticated/workspaces/$workspaceId/snippets'
    | '/_authenticated/workspaces/$workspaceId/tasks'
    | '/_authenticated/workspaces/$workspaceId/transactional'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/_authenticated/settings/account/'
    | '/_authenticated/settings/api_credentials/'
    | '/_authenticated/settings/billing/'
    | '/_authenticated/settings/partner/'
    | '/_authenticated/settings/personal/'
    | '/_authenticated/settings/roles/'
    | '/_authenticated/settings/security/'
    | '/_authenticated/settings/team/'
    | '/_authenticated/settings/workspaces/'
    | '/_authenticated/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/_authenticated/settings/billing/available-plans/journeys'
    | '/_authenticated/settings/personal/security/backup_codes'
    | '/_authenticated/settings/personal/security/new'
    | '/_authenticated/settings/personal/security/new_backup_codes'
    | '/_authenticated/settings/personal/security/new_totp'
    | '/_authenticated/settings/team/join-requests/$requestId'
    | '/_authenticated/workspaces/$workspaceId/agent/routines'
    | '/_authenticated/workspaces/$workspaceId/agent/skills'
    | '/_authenticated/workspaces/$workspaceId/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/analysis/email-clients'
    | '/_authenticated/workspaces/$workspaceId/analysis/gmail-postmaster'
    | '/_authenticated/workspaces/$workspaceId/automations/new'
    | '/_authenticated/workspaces/$workspaceId/boards/$boardId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts/api-triggered'
    | '/_authenticated/workspaces/$workspaceId/broadcasts/one_time_sends'
    | '/_authenticated/workspaces/$workspaceId/broadcasts/send-volume'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/new'
    | '/_authenticated/workspaces/$workspaceId/collections/$collectionId'
    | '/_authenticated/workspaces/$workspaceId/data-index/$'
    | '/_authenticated/workspaces/$workspaceId/design-studio/$'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles'
    | '/_authenticated/workspaces/$workspaceId/dev/condition-viewer'
    | '/_authenticated/workspaces/$workspaceId/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/experiments/new'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId'
    | '/_authenticated/workspaces/$workspaceId/geosets/import'
    | '/_authenticated/workspaces/$workspaceId/geosets/new'
    | '/_authenticated/workspaces/$workspaceId/goals/$goalId'
    | '/_authenticated/workspaces/$workspaceId/goals/new'
    | '/_authenticated/workspaces/$workspaceId/home/add-people'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup'
    | '/_authenticated/workspaces/$workspaceId/imports/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/all'
    | '/_authenticated/workspaces/$workspaceId/integrations/cdp_in'
    | '/_authenticated/workspaces/$workspaceId/integrations/cdp_out'
    | '/_authenticated/workspaces/$workspaceId/integrations/customerio'
    | '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads'
    | '/_authenticated/workspaces/$workspaceId/integrations/forms'
    | '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out'
    | '/_authenticated/workspaces/$workspaceId/integrations/segment_in'
    | '/_authenticated/workspaces/$workspaceId/integrations/segment_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/assets'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections'
    | '/_authenticated/workspaces/$workspaceId/journeys/dashboard'
    | '/_authenticated/workspaces/$workspaceId/journeys/deliveries'
    | '/_authenticated/workspaces/$workspaceId/journeys/drafts'
    | '/_authenticated/workspaces/$workspaceId/journeys/exports'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences'
    | '/_authenticated/workspaces/$workspaceId/journeys/message-library'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets'
    | '/_authenticated/workspaces/$workspaceId/journeys/tasks'
    | '/_authenticated/workspaces/$workspaceId/layouts/new'
    | '/_authenticated/workspaces/$workspaceId/layouts/starters'
    | '/_authenticated/workspaces/$workspaceId/message_activity/$'
    | '/_authenticated/workspaces/$workspaceId/outcomes/$goalId'
    | '/_authenticated/workspaces/$workspaceId/parcel/$'
    | '/_authenticated/workspaces/$workspaceId/people/$personId'
    | '/_authenticated/workspaces/$workspaceId/people/create'
    | '/_authenticated/workspaces/$workspaceId/people/merge'
    | '/_authenticated/workspaces/$workspaceId/people/new'
    | '/_authenticated/workspaces/$workspaceId/people/welcome'
    | '/_authenticated/workspaces/$workspaceId/profile_activity/$tab'
    | '/_authenticated/workspaces/$workspaceId/profiles/create'
    | '/_authenticated/workspaces/$workspaceId/profiles/merge'
    | '/_authenticated/workspaces/$workspaceId/profiles/new'
    | '/_authenticated/workspaces/$workspaceId/profiles/welcome'
    | '/_authenticated/workspaces/$workspaceId/reports/deliverability'
    | '/_authenticated/workspaces/$workspaceId/reports/email-clients'
    | '/_authenticated/workspaces/$workspaceId/reports/gmail-postmaster'
    | '/_authenticated/workspaces/$workspaceId/settings/$'
    | '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile'
    | '/_authenticated/workspaces/$workspaceId/settings/anonymous_events'
    | '/_authenticated/workspaces/$workspaceId/settings/api-keys'
    | '/_authenticated/workspaces/$workspaceId/settings/audit-logs'
    | '/_authenticated/workspaces/$workspaceId/settings/auto_archive'
    | '/_authenticated/workspaces/$workspaceId/settings/confirm_delete'
    | '/_authenticated/workspaces/$workspaceId/settings/consent'
    | '/_authenticated/workspaces/$workspaceId/settings/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/geofences'
    | '/_authenticated/workspaces/$workspaceId/settings/knowledge_library'
    | '/_authenticated/workspaces/$workspaceId/settings/language'
    | '/_authenticated/workspaces/$workspaceId/settings/live-notification-types'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration'
    | '/_authenticated/workspaces/$workspaceId/settings/merge_options'
    | '/_authenticated/workspaces/$workspaceId/settings/seed-lists'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center'
    | '/_authenticated/workspaces/$workspaceId/settings/suppressions'
    | '/_authenticated/workspaces/$workspaceId/sign-up-forms_/$id'
    | '/_authenticated/workspaces/$workspaceId/sign-up-forms_/new'
    | '/_authenticated/workspaces/$workspaceId/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/template/$templateId'
    | '/_authenticated/workspaces/$workspaceId/transactional_/new'
    | '/_authenticated/settings/billing/available-plans/'
    | '/_authenticated/settings/personal/security/'
    | '/_authenticated/workspaces/$workspaceId/agent/'
    | '/_authenticated/workspaces/$workspaceId/analysis/'
    | '/_authenticated/workspaces/$workspaceId/automations/'
    | '/_authenticated/workspaces/$workspaceId/boards/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts/'
    | '/_authenticated/workspaces/$workspaceId/collections/'
    | '/_authenticated/workspaces/$workspaceId/data-index/'
    | '/_authenticated/workspaces/$workspaceId/design-studio/'
    | '/_authenticated/workspaces/$workspaceId/experiments/'
    | '/_authenticated/workspaces/$workspaceId/geosets/'
    | '/_authenticated/workspaces/$workspaceId/goals/'
    | '/_authenticated/workspaces/$workspaceId/home/'
    | '/_authenticated/workspaces/$workspaceId/imports/'
    | '/_authenticated/workspaces/$workspaceId/integrations/'
    | '/_authenticated/workspaces/$workspaceId/layouts/'
    | '/_authenticated/workspaces/$workspaceId/objects/'
    | '/_authenticated/workspaces/$workspaceId/outcomes/'
    | '/_authenticated/workspaces/$workspaceId/parcel/'
    | '/_authenticated/workspaces/$workspaceId/people/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/'
    | '/_authenticated/workspaces/$workspaceId/profile_activity/'
    | '/_authenticated/workspaces/$workspaceId/profiles/'
    | '/_authenticated/workspaces/$workspaceId/reports/'
    | '/_authenticated/workspaces/$workspaceId/segments/'
    | '/_authenticated/workspaces/$workspaceId/settings/'
    | '/_authenticated/workspaces/$workspaceId/snippets/'
    | '/_authenticated/workspaces/$workspaceId/template/'
    | '/_authenticated/settings/team/members/$userId/edit'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/new'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/_authenticated/workspaces/$workspaceId/automations/welcome/create'
    | '/_authenticated/workspaces/$workspaceId/collections/$collectionId/data'
    | '/_authenticated/workspaces/$workspaceId/collections/$collectionId/importing'
    | '/_authenticated/workspaces/$workspaceId/collections/$collectionId/usage'
    | '/_authenticated/workspaces/$workspaceId/composer/actions/$actionId'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/assets'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/brand'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/welcome'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/_authenticated/workspaces/$workspaceId/goals/$goalId/milestones'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/developers'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/directory'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/overview'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks'
    | '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads_/$formId'
    | '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/forms_/settings'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/api-triggered'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletters'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/one_time_sends'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/send-volume'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/welcome'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/data-index/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/goals/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId'
    | '/_authenticated/workspaces/$workspaceId/journeys/goals/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters'
    | '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/outbox/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/merge'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/welcome'
    | '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/triggered/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/v2/$'
    | '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/edit'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/guide'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/new'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/_authenticated/workspaces/$workspaceId/segments/$segmentId/audiences'
    | '/_authenticated/workspaces/$workspaceId/segments/$segmentId/overview'
    | '/_authenticated/workspaces/$workspaceId/segments/$segmentId/people'
    | '/_authenticated/workspaces/$workspaceId/segments/$segmentId/usage'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/in_app'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/line'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/push'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/slack'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/twilio'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/whatsapp'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/new'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/'
    | '/_authenticated/workspaces/$workspaceId/automations/welcome/'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/'
    | '/_authenticated/workspaces/$workspaceId/collections/$collectionId/'
    | '/_authenticated/workspaces/$workspaceId/data-index/$type/'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/'
    | '/_authenticated/workspaces/$workspaceId/goals/$goalId/'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/'
    | '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/'
    | '/_authenticated/workspaces/$workspaceId/journeys/analysis/'
    | '/_authenticated/workspaces/$workspaceId/journeys/anonymous/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/'
    | '/_authenticated/workspaces/$workspaceId/journeys/data-index/'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/'
    | '/_authenticated/workspaces/$workspaceId/journeys/goals/'
    | '/_authenticated/workspaces/$workspaceId/journeys/home/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/'
    | '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/'
    | '/_authenticated/workspaces/$workspaceId/journeys/reports/'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/'
    | '/_authenticated/workspaces/$workspaceId/journeys/template/'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/'
    | '/_authenticated/workspaces/$workspaceId/journeys/triggered/'
    | '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/'
    | '/_authenticated/workspaces/$workspaceId/settings/api_credentials/'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/drafts'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/settings'
    | '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/setup'
    | '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type_/$formId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/workflow'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/_authenticated/workspaces/$workspaceId/journeys/composer/actions/$actionId'
    | '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId_/milestones'
    | '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/add-people'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads_/$formId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/audiences'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/overview'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/people'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/usage'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/activity'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/relationships'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/edit'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/$subjectId'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/segments/belongs'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/segments/others'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/apps/create'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/postmaster_tools'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/push/android'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/push/ios'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/push/web'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/phone-numbers'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/settings'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/drafts'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/send'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/settings'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/'
    | '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/'
    | '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/activity/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/devices/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/drafts/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/relationships/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/segments/'
    | '/_authenticated/workspaces/$workspaceId/people/$personId/sent/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/apps/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/push/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journeys'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/triggering_details'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/content'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/recipients'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/reports'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/test'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/content'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/recipients'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/tracking'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/in-app/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/inbox-message/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/push/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sign-up-form/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sms/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/whatsapp/$id'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/journeys/$templateWorkspaceId/$templateId'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type_/$formId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/edit'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/belongs'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/others'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/drafts'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/send'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/apps/edit/$appId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/business-info'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/review'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/'
    | '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/activity/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/devices/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/drafts/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/relationships/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/sent/'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/'
    | '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/'
    | '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId_/previews/$previewId'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step'
    | '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  R2fa_setupRoute: typeof R2fa_setupRouteWithChildren;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AcademyLoginRoute: typeof AcademyLoginRoute;
  AcceptGuestInvitationRoute: typeof AcceptGuestInvitationRoute;
  CheckoutRoute: typeof CheckoutRoute;
  CliRoute: typeof CliRouteWithChildren;
  Confirm_accountRoute: typeof Confirm_accountRoute;
  DesignStudioEmbedRoute: typeof DesignStudioEmbedRouteWithChildren;
  JoinRequestRoute: typeof JoinRequestRoute;
  OnboardingRoute: typeof OnboardingRouteWithChildren;
  R2fa_setupSplatRoute: typeof R2fa_setupSplatRoute;
  AccountSplatRoute: typeof AccountSplatRoute;
  Account_canceledSplatRoute: typeof Account_canceledSplatRoute;
  Account_cancelledSplatRoute: typeof Account_cancelledSplatRoute;
  Confirm_account_noticeSplatRoute: typeof Confirm_account_noticeSplatRoute;
  DevVercelInstallRoute: typeof DevVercelInstallRoute;
  EnvSplatRoute: typeof EnvSplatRoute;
  HarSanitizerSplatRoute: typeof HarSanitizerSplatRoute;
  IntegrationsSplatRoute: typeof IntegrationsSplatRoute;
  JourneysSplatRoute: typeof JourneysSplatRoute;
  LoginSplatRoute: typeof LoginSplatRoute;
  LogoutSplatRoute: typeof LogoutSplatRoute;
  MobileAuthorizeRoute: typeof MobileAuthorizeRoute;
  No_accessible_workspacesSplatRoute: typeof No_accessible_workspacesSplatRoute;
  Oauth2SplatRoute: typeof Oauth2SplatRoute;
  Post_cancelSplatRoute: typeof Post_cancelSplatRoute;
  Post_registrationSplatRoute: typeof Post_registrationSplatRoute;
  Reset_passwordSplatRoute: typeof Reset_passwordSplatRoute;
  Reset_passwordNew_passwordRoute: typeof Reset_passwordNew_passwordRoute;
  SignupSplatRoute: typeof SignupSplatRoute;
  UsersSplatRoute: typeof UsersSplatRoute;
  VercelInstallRoute: typeof VercelInstallRoute;
  VwbDemoSplatRoute: typeof VwbDemoSplatRoute;
  Reset_passwordIndexRoute: typeof Reset_passwordIndexRoute;
  AccountCancelledSplatRoute: typeof AccountCancelledSplatRoute;
  PipelinesWorkspacesWorkspaceIdSplatRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  PipelinesWorkspacesWorkspaceIdIndexRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/2fa_setup': {
      id: '/2fa_setup';
      path: '/2fa_setup';
      fullPath: '/2fa_setup';
      preLoaderRoute: typeof R2fa_setupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/academy-login': {
      id: '/academy-login';
      path: '/academy-login';
      fullPath: '/academy-login';
      preLoaderRoute: typeof AcademyLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accept-guest-invitation': {
      id: '/accept-guest-invitation';
      path: '/accept-guest-invitation';
      fullPath: '/accept-guest-invitation';
      preLoaderRoute: typeof AcceptGuestInvitationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/checkout': {
      id: '/checkout';
      path: '/checkout';
      fullPath: '/checkout';
      preLoaderRoute: typeof CheckoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli': {
      id: '/cli';
      path: '/cli';
      fullPath: '/cli';
      preLoaderRoute: typeof CliRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/confirm_account': {
      id: '/confirm_account';
      path: '/confirm_account';
      fullPath: '/confirm_account';
      preLoaderRoute: typeof Confirm_accountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-studio-embed': {
      id: '/design-studio-embed';
      path: '/design-studio-embed';
      fullPath: '/design-studio-embed';
      preLoaderRoute: typeof DesignStudioEmbedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/join-request': {
      id: '/join-request';
      path: '/join-request';
      fullPath: '/join-request';
      preLoaderRoute: typeof JoinRequestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/2fa_setup/': {
      id: '/2fa_setup/';
      path: '/';
      fullPath: '/2fa_setup/';
      preLoaderRoute: typeof R2fa_setupIndexRouteImport;
      parentRoute: typeof R2fa_setupRoute;
    };
    '/2fa_setup/new_totp': {
      id: '/2fa_setup/new_totp';
      path: '/new_totp';
      fullPath: '/2fa_setup/new_totp';
      preLoaderRoute: typeof R2fa_setupNew_totpRouteImport;
      parentRoute: typeof R2fa_setupRoute;
    };
    '/2fa_setup_/$': {
      id: '/2fa_setup_/$';
      path: '/2fa_setup/$';
      fullPath: '/2fa_setup/$';
      preLoaderRoute: typeof R2fa_setupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$': {
      id: '/_authenticated/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof AuthenticatedSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces': {
      id: '/_authenticated/workspaces';
      path: '/workspaces';
      fullPath: '/workspaces';
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/account/$': {
      id: '/account/$';
      path: '/account/$';
      fullPath: '/account/$';
      preLoaderRoute: typeof AccountSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account_canceled/$': {
      id: '/account_canceled/$';
      path: '/account_canceled/$';
      fullPath: '/account_canceled/$';
      preLoaderRoute: typeof Account_canceledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account_cancelled/$': {
      id: '/account_cancelled/$';
      path: '/account_cancelled/$';
      fullPath: '/account_cancelled/$';
      preLoaderRoute: typeof Account_cancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli/': {
      id: '/cli/';
      path: '/';
      fullPath: '/cli/';
      preLoaderRoute: typeof CliIndexRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/cli/dns-setup': {
      id: '/cli/dns-setup';
      path: '/dns-setup';
      fullPath: '/cli/dns-setup';
      preLoaderRoute: typeof CliDnsSetupRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/confirm_account_notice/$': {
      id: '/confirm_account_notice/$';
      path: '/confirm_account_notice/$';
      fullPath: '/confirm_account_notice/$';
      preLoaderRoute: typeof Confirm_account_noticeSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dev/vercel-install': {
      id: '/dev/vercel-install';
      path: '/dev/vercel-install';
      fullPath: '/dev/vercel-install';
      preLoaderRoute: typeof DevVercelInstallRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/env/$': {
      id: '/env/$';
      path: '/env/$';
      fullPath: '/env/$';
      preLoaderRoute: typeof EnvSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/har-sanitizer/$': {
      id: '/har-sanitizer/$';
      path: '/har-sanitizer/$';
      fullPath: '/har-sanitizer/$';
      preLoaderRoute: typeof HarSanitizerSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/$': {
      id: '/integrations/$';
      path: '/integrations/$';
      fullPath: '/integrations/$';
      preLoaderRoute: typeof IntegrationsSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/journeys/$': {
      id: '/journeys/$';
      path: '/journeys/$';
      fullPath: '/journeys/$';
      preLoaderRoute: typeof JourneysSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login/$': {
      id: '/login/$';
      path: '/login/$';
      fullPath: '/login/$';
      preLoaderRoute: typeof LoginSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logout/$': {
      id: '/logout/$';
      path: '/logout/$';
      fullPath: '/logout/$';
      preLoaderRoute: typeof LogoutSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/mobile/authorize': {
      id: '/mobile/authorize';
      path: '/mobile/authorize';
      fullPath: '/mobile/authorize';
      preLoaderRoute: typeof MobileAuthorizeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/no_accessible_workspaces/$': {
      id: '/no_accessible_workspaces/$';
      path: '/no_accessible_workspaces/$';
      fullPath: '/no_accessible_workspaces/$';
      preLoaderRoute: typeof No_accessible_workspacesSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth2/$': {
      id: '/oauth2/$';
      path: '/oauth2/$';
      fullPath: '/oauth2/$';
      preLoaderRoute: typeof Oauth2SplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/': {
      id: '/onboarding/';
      path: '/';
      fullPath: '/onboarding/';
      preLoaderRoute: typeof OnboardingIndexRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/onboarding/get-started': {
      id: '/onboarding/get-started';
      path: '/get-started';
      fullPath: '/onboarding/get-started';
      preLoaderRoute: typeof OnboardingGetStartedRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/onboarding/wizard': {
      id: '/onboarding/wizard';
      path: '/wizard';
      fullPath: '/onboarding/wizard';
      preLoaderRoute: typeof OnboardingWizardRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/post_cancel/$': {
      id: '/post_cancel/$';
      path: '/post_cancel/$';
      fullPath: '/post_cancel/$';
      preLoaderRoute: typeof Post_cancelSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/post_registration/$': {
      id: '/post_registration/$';
      path: '/post_registration/$';
      fullPath: '/post_registration/$';
      preLoaderRoute: typeof Post_registrationSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset_password/': {
      id: '/reset_password/';
      path: '/reset_password';
      fullPath: '/reset_password/';
      preLoaderRoute: typeof Reset_passwordIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset_password/$': {
      id: '/reset_password/$';
      path: '/reset_password/$';
      fullPath: '/reset_password/$';
      preLoaderRoute: typeof Reset_passwordSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset_password/new_password': {
      id: '/reset_password/new_password';
      path: '/reset_password/new_password';
      fullPath: '/reset_password/new_password';
      preLoaderRoute: typeof Reset_passwordNew_passwordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup/$': {
      id: '/signup/$';
      path: '/signup/$';
      fullPath: '/signup/$';
      preLoaderRoute: typeof SignupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users/$': {
      id: '/users/$';
      path: '/users/$';
      fullPath: '/users/$';
      preLoaderRoute: typeof UsersSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/vercel/install': {
      id: '/vercel/install';
      path: '/vercel/install';
      fullPath: '/vercel/install';
      preLoaderRoute: typeof VercelInstallRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/vwb-demo/$': {
      id: '/vwb-demo/$';
      path: '/vwb-demo/$';
      fullPath: '/vwb-demo/$';
      preLoaderRoute: typeof VwbDemoSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/internal-tools/': {
      id: '/_authenticated/internal-tools/';
      path: '/internal-tools';
      fullPath: '/internal-tools/';
      preLoaderRoute: typeof AuthenticatedInternalToolsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/$': {
      id: '/_authenticated/internal-tools/$';
      path: '/internal-tools/$';
      fullPath: '/internal-tools/$';
      preLoaderRoute: typeof AuthenticatedInternalToolsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/cio-cli-tool': {
      id: '/_authenticated/internal-tools/cio-cli-tool';
      path: '/internal-tools/cio-cli-tool';
      fullPath: '/internal-tools/cio-cli-tool';
      preLoaderRoute: typeof AuthenticatedInternalToolsCioCliToolRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/inspect': {
      id: '/_authenticated/internal-tools/inspect';
      path: '/internal-tools/inspect';
      fullPath: '/internal-tools/inspect';
      preLoaderRoute: typeof AuthenticatedInternalToolsInspectRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/': {
      id: '/_authenticated/sample-workspace/';
      path: '/sample-workspace';
      fullPath: '/sample-workspace/';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/$': {
      id: '/_authenticated/sample-workspace/$';
      path: '/sample-workspace/$';
      fullPath: '/sample-workspace/$';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/$': {
      id: '/_authenticated/settings/$';
      path: '/settings/$';
      fullPath: '/settings/$';
      preLoaderRoute: typeof AuthenticatedSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/ai': {
      id: '/_authenticated/settings/ai';
      path: '/settings/ai';
      fullPath: '/settings/ai';
      preLoaderRoute: typeof AuthenticatedSettingsAiRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing';
      path: '/settings/billing';
      fullPath: '/settings/billing';
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/experimental-features': {
      id: '/_authenticated/settings/experimental-features';
      path: '/settings/experimental-features';
      fullPath: '/settings/experimental-features';
      preLoaderRoute: typeof AuthenticatedSettingsExperimentalFeaturesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/partner': {
      id: '/_authenticated/settings/partner';
      path: '/settings/partner';
      fullPath: '/settings/partner';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/privacy': {
      id: '/_authenticated/settings/privacy';
      path: '/settings/privacy';
      fullPath: '/settings/privacy';
      preLoaderRoute: typeof AuthenticatedSettingsPrivacyRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/receipts': {
      id: '/_authenticated/settings/receipts';
      path: '/settings/receipts';
      fullPath: '/settings/receipts';
      preLoaderRoute: typeof AuthenticatedSettingsReceiptsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/slack-agent': {
      id: '/_authenticated/settings/slack-agent';
      path: '/settings/slack-agent';
      fullPath: '/settings/slack-agent';
      preLoaderRoute: typeof AuthenticatedSettingsSlackAgentRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/subscription': {
      id: '/_authenticated/settings/subscription';
      path: '/settings/subscription';
      fullPath: '/settings/subscription';
      preLoaderRoute: typeof AuthenticatedSettingsSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/trial-expired/journeys': {
      id: '/_authenticated/trial-expired/journeys';
      path: '/trial-expired/journeys';
      fullPath: '/trial-expired/journeys';
      preLoaderRoute: typeof AuthenticatedTrialExpiredJourneysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/': {
      id: '/_authenticated/workspaces/';
      path: '/';
      fullPath: '/workspaces/';
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/_authenticated/workspaces/$workspaceId': {
      id: '/_authenticated/workspaces/$workspaceId';
      path: '/$workspaceId';
      fullPath: '/workspaces/$workspaceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/account/cancelled/$': {
      id: '/account/cancelled/$';
      path: '/account/cancelled/$';
      fullPath: '/account/cancelled/$';
      preLoaderRoute: typeof AccountCancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-studio-embed/cio/': {
      id: '/design-studio-embed/cio/';
      path: '/cio';
      fullPath: '/design-studio-embed/cio/';
      preLoaderRoute: typeof DesignStudioEmbedCioIndexRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/design-studio-embed/cio/$': {
      id: '/design-studio-embed/cio/$';
      path: '/cio/$';
      fullPath: '/design-studio-embed/cio/$';
      preLoaderRoute: typeof DesignStudioEmbedCioSplatRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/design-studio-embed/cio/email': {
      id: '/design-studio-embed/cio/email';
      path: '/cio/email';
      fullPath: '/design-studio-embed/cio/email';
      preLoaderRoute: typeof DesignStudioEmbedCioEmailRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/design-studio-embed/cio/in-app': {
      id: '/design-studio-embed/cio/in-app';
      path: '/cio/in-app';
      fullPath: '/design-studio-embed/cio/in-app';
      preLoaderRoute: typeof DesignStudioEmbedCioInAppRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/_authenticated/settings/account/': {
      id: '/_authenticated/settings/account/';
      path: '/settings/account';
      fullPath: '/settings/account/';
      preLoaderRoute: typeof AuthenticatedSettingsAccountIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/account/edit': {
      id: '/_authenticated/settings/account/edit';
      path: '/settings/account/edit';
      fullPath: '/settings/account/edit';
      preLoaderRoute: typeof AuthenticatedSettingsAccountEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/api_credentials/': {
      id: '/_authenticated/settings/api_credentials/';
      path: '/settings/api_credentials';
      fullPath: '/settings/api_credentials/';
      preLoaderRoute: typeof AuthenticatedSettingsApi_credentialsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/billing/': {
      id: '/_authenticated/settings/billing/';
      path: '/';
      fullPath: '/settings/billing/';
      preLoaderRoute: typeof AuthenticatedSettingsBillingIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/$': {
      id: '/_authenticated/settings/billing/$';
      path: '/$';
      fullPath: '/settings/billing/$';
      preLoaderRoute: typeof AuthenticatedSettingsBillingSplatRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/add-ons': {
      id: '/_authenticated/settings/billing/add-ons';
      path: '/add-ons';
      fullPath: '/settings/billing/add-ons';
      preLoaderRoute: typeof AuthenticatedSettingsBillingAddOnsRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/billing-details': {
      id: '/_authenticated/settings/billing/billing-details';
      path: '/billing-details';
      fullPath: '/settings/billing/billing-details';
      preLoaderRoute: typeof AuthenticatedSettingsBillingBillingDetailsRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/billing-history': {
      id: '/_authenticated/settings/billing/billing-history';
      path: '/billing-history';
      fullPath: '/settings/billing/billing-history';
      preLoaderRoute: typeof AuthenticatedSettingsBillingBillingHistoryRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/checkout': {
      id: '/_authenticated/settings/billing/checkout';
      path: '/checkout';
      fullPath: '/settings/billing/checkout';
      preLoaderRoute: typeof AuthenticatedSettingsBillingCheckoutRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/inbox-preview-usage': {
      id: '/_authenticated/settings/billing/inbox-preview-usage';
      path: '/inbox-preview-usage';
      fullPath: '/settings/billing/inbox-preview-usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingInboxPreviewUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/llm-usage': {
      id: '/_authenticated/settings/billing/llm-usage';
      path: '/llm-usage';
      fullPath: '/settings/billing/llm-usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingLlmUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/overview': {
      id: '/_authenticated/settings/billing/overview';
      path: '/overview';
      fullPath: '/settings/billing/overview';
      preLoaderRoute: typeof AuthenticatedSettingsBillingOverviewRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/payment-methods': {
      id: '/_authenticated/settings/billing/payment-methods';
      path: '/payment-methods';
      fullPath: '/settings/billing/payment-methods';
      preLoaderRoute: typeof AuthenticatedSettingsBillingPaymentMethodsRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/usage': {
      id: '/_authenticated/settings/billing/usage';
      path: '/usage';
      fullPath: '/settings/billing/usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/your-plan': {
      id: '/_authenticated/settings/billing/your-plan';
      path: '/your-plan';
      fullPath: '/settings/billing/your-plan';
      preLoaderRoute: typeof AuthenticatedSettingsBillingYourPlanRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/partner/': {
      id: '/_authenticated/settings/partner/';
      path: '/';
      fullPath: '/settings/partner/';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsPartnerRoute;
    };
    '/_authenticated/settings/partner/create': {
      id: '/_authenticated/settings/partner/create';
      path: '/create';
      fullPath: '/settings/partner/create';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerCreateRouteImport;
      parentRoute: typeof AuthenticatedSettingsPartnerRoute;
    };
    '/_authenticated/settings/personal/': {
      id: '/_authenticated/settings/personal/';
      path: '/settings/personal';
      fullPath: '/settings/personal/';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/google-identities': {
      id: '/_authenticated/settings/personal/google-identities';
      path: '/settings/personal/google-identities';
      fullPath: '/settings/personal/google-identities';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/': {
      id: '/_authenticated/settings/roles/';
      path: '/settings/roles';
      fullPath: '/settings/roles/';
      preLoaderRoute: typeof AuthenticatedSettingsRolesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/$roleId': {
      id: '/_authenticated/settings/roles/$roleId';
      path: '/settings/roles/$roleId';
      fullPath: '/settings/roles/$roleId';
      preLoaderRoute: typeof AuthenticatedSettingsRolesRoleIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/new': {
      id: '/_authenticated/settings/roles/new';
      path: '/settings/roles/new';
      fullPath: '/settings/roles/new';
      preLoaderRoute: typeof AuthenticatedSettingsRolesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/security/': {
      id: '/_authenticated/settings/security/';
      path: '/settings/security';
      fullPath: '/settings/security/';
      preLoaderRoute: typeof AuthenticatedSettingsSecurityIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/security/sso': {
      id: '/_authenticated/settings/security/sso';
      path: '/settings/security/sso';
      fullPath: '/settings/security/sso';
      preLoaderRoute: typeof AuthenticatedSettingsSecuritySsoRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/slack-agent_/link': {
      id: '/_authenticated/settings/slack-agent_/link';
      path: '/settings/slack-agent/link';
      fullPath: '/settings/slack-agent/link';
      preLoaderRoute: typeof AuthenticatedSettingsSlackAgentLinkRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/': {
      id: '/_authenticated/settings/team/';
      path: '/settings/team';
      fullPath: '/settings/team/';
      preLoaderRoute: typeof AuthenticatedSettingsTeamIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/add': {
      id: '/_authenticated/settings/team/add';
      path: '/settings/team/add';
      fullPath: '/settings/team/add';
      preLoaderRoute: typeof AuthenticatedSettingsTeamAddRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/invite-guest': {
      id: '/_authenticated/settings/team/invite-guest';
      path: '/settings/team/invite-guest';
      fullPath: '/settings/team/invite-guest';
      preLoaderRoute: typeof AuthenticatedSettingsTeamInviteGuestRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/set_password': {
      id: '/_authenticated/settings/team/set_password';
      path: '/settings/team/set_password';
      fullPath: '/settings/team/set_password';
      preLoaderRoute: typeof AuthenticatedSettingsTeamSet_passwordRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/workspaces/': {
      id: '/_authenticated/settings/workspaces/';
      path: '/settings/workspaces';
      fullPath: '/settings/workspaces/';
      preLoaderRoute: typeof AuthenticatedSettingsWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/workspaces/new': {
      id: '/_authenticated/settings/workspaces/new';
      path: '/settings/workspaces/new';
      fullPath: '/settings/workspaces/new';
      preLoaderRoute: typeof AuthenticatedSettingsWorkspacesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/': {
      id: '/_authenticated/workspaces/$workspaceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/$': {
      id: '/_authenticated/workspaces/$workspaceId/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent': {
      id: '/_authenticated/workspaces/$workspaceId/agent';
      path: '/agent';
      fullPath: '/workspaces/$workspaceId/agent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/anonymous': {
      id: '/_authenticated/workspaces/$workspaceId/anonymous';
      path: '/anonymous';
      fullPath: '/workspaces/$workspaceId/anonymous';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnonymousRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/assets': {
      id: '/_authenticated/workspaces/$workspaceId/assets';
      path: '/assets';
      fullPath: '/workspaces/$workspaceId/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts';
      path: '/broadcasts';
      fullPath: '/workspaces/$workspaceId/broadcasts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections': {
      id: '/_authenticated/workspaces/$workspaceId/collections';
      path: '/collections';
      fullPath: '/workspaces/$workspaceId/collections';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dashboard': {
      id: '/_authenticated/workspaces/$workspaceId/dashboard';
      path: '/dashboard';
      fullPath: '/workspaces/$workspaceId/dashboard';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDashboardRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio';
      path: '/design-studio';
      fullPath: '/workspaces/$workspaceId/design-studio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments': {
      id: '/_authenticated/workspaces/$workspaceId/experiments';
      path: '/experiments';
      fullPath: '/workspaces/$workspaceId/experiments';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets': {
      id: '/_authenticated/workspaces/$workspaceId/geosets';
      path: '/geosets';
      fullPath: '/workspaces/$workspaceId/geosets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/health': {
      id: '/_authenticated/workspaces/$workspaceId/health';
      path: '/health';
      fullPath: '/workspaces/$workspaceId/health';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home': {
      id: '/_authenticated/workspaces/$workspaceId/home';
      path: '/home';
      fullPath: '/workspaces/$workspaceId/home';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys_': {
      id: '/_authenticated/workspaces/$workspaceId/journeys_';
      path: '/journeys';
      fullPath: '/workspaces/$workspaceId/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/message-library': {
      id: '/_authenticated/workspaces/$workspaceId/message-library';
      path: '/message-library';
      fullPath: '/workspaces/$workspaceId/message-library';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes';
      path: '/outcomes';
      fullPath: '/workspaces/$workspaceId/outcomes';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines';
      path: '/pipelines';
      fullPath: '/workspaces/$workspaceId/pipelines';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/sign-up-forms': {
      id: '/_authenticated/workspaces/$workspaceId/sign-up-forms';
      path: '/sign-up-forms';
      fullPath: '/workspaces/$workspaceId/sign-up-forms';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/snippets';
      path: '/snippets';
      fullPath: '/workspaces/$workspaceId/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/tasks';
      path: '/tasks';
      fullPath: '/workspaces/$workspaceId/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional': {
      id: '/_authenticated/workspaces/$workspaceId/transactional';
      path: '/transactional';
      fullPath: '/workspaces/$workspaceId/transactional';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/pipelines/workspaces/$workspaceId/': {
      id: '/pipelines/workspaces/$workspaceId/';
      path: '/pipelines/workspaces/$workspaceId';
      fullPath: '/pipelines/workspaces/$workspaceId/';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pipelines/workspaces/$workspaceId/$': {
      id: '/pipelines/workspaces/$workspaceId/$';
      path: '/pipelines/workspaces/$workspaceId/$';
      fullPath: '/pipelines/workspaces/$workspaceId/$';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId': {
      id: '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId';
      path: '/settings/api_credentials/service_accounts/$serviceAccountId';
      fullPath: '/settings/api_credentials/service_accounts/$serviceAccountId';
      preLoaderRoute: typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/billing/available-plans/': {
      id: '/_authenticated/settings/billing/available-plans/';
      path: '/available-plans';
      fullPath: '/settings/billing/available-plans/';
      preLoaderRoute: typeof AuthenticatedSettingsBillingAvailablePlansIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/available-plans/journeys': {
      id: '/_authenticated/settings/billing/available-plans/journeys';
      path: '/available-plans/journeys';
      fullPath: '/settings/billing/available-plans/journeys';
      preLoaderRoute: typeof AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/personal/security/': {
      id: '/_authenticated/settings/personal/security/';
      path: '/settings/personal/security';
      fullPath: '/settings/personal/security/';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalSecurityIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/security/backup_codes': {
      id: '/_authenticated/settings/personal/security/backup_codes';
      path: '/settings/personal/security/backup_codes';
      fullPath: '/settings/personal/security/backup_codes';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalSecurityBackup_codesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/security/new': {
      id: '/_authenticated/settings/personal/security/new';
      path: '/settings/personal/security/new';
      fullPath: '/settings/personal/security/new';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalSecurityNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/security/new_backup_codes': {
      id: '/_authenticated/settings/personal/security/new_backup_codes';
      path: '/settings/personal/security/new_backup_codes';
      fullPath: '/settings/personal/security/new_backup_codes';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalSecurityNew_backup_codesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/security/new_totp': {
      id: '/_authenticated/settings/personal/security/new_totp';
      path: '/settings/personal/security/new_totp';
      fullPath: '/settings/personal/security/new_totp';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalSecurityNew_totpRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/join-requests/$requestId': {
      id: '/_authenticated/settings/team/join-requests/$requestId';
      path: '/settings/team/join-requests/$requestId';
      fullPath: '/settings/team/join-requests/$requestId';
      preLoaderRoute: typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/routines': {
      id: '/_authenticated/workspaces/$workspaceId/agent/routines';
      path: '/routines';
      fullPath: '/workspaces/$workspaceId/agent/routines';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills';
      path: '/skills';
      fullPath: '/workspaces/$workspaceId/agent/skills';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/';
      path: '/analysis';
      fullPath: '/workspaces/$workspaceId/analysis/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/deliverability';
      path: '/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/email-clients': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/email-clients';
      path: '/analysis/email-clients';
      fullPath: '/workspaces/$workspaceId/analysis/email-clients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/gmail-postmaster': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/gmail-postmaster';
      path: '/analysis/gmail-postmaster';
      fullPath: '/workspaces/$workspaceId/analysis/gmail-postmaster';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/';
      path: '/automations';
      fullPath: '/workspaces/$workspaceId/automations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/new': {
      id: '/_authenticated/workspaces/$workspaceId/automations/new';
      path: '/automations/new';
      fullPath: '/workspaces/$workspaceId/automations/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/boards/': {
      id: '/_authenticated/workspaces/$workspaceId/boards/';
      path: '/boards';
      fullPath: '/workspaces/$workspaceId/boards/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/boards/$boardId': {
      id: '/_authenticated/workspaces/$workspaceId/boards/$boardId';
      path: '/boards/$boardId';
      fullPath: '/workspaces/$workspaceId/boards/$boardId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/broadcasts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts/api-triggered': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts/api-triggered';
      path: '/api-triggered';
      fullPath: '/workspaces/$workspaceId/broadcasts/api-triggered';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts/one_time_sends': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts/one_time_sends';
      path: '/one_time_sends';
      fullPath: '/workspaces/$workspaceId/broadcasts/one_time_sends';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts/send-volume': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts/send-volume';
      path: '/send-volume';
      fullPath: '/workspaces/$workspaceId/broadcasts/send-volume';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/new': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/new';
      path: '/broadcasts/new';
      fullPath: '/workspaces/$workspaceId/broadcasts/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/': {
      id: '/_authenticated/workspaces/$workspaceId/collections/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/collections/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/$collectionId': {
      id: '/_authenticated/workspaces/$workspaceId/collections/$collectionId';
      path: '/$collectionId';
      fullPath: '/workspaces/$workspaceId/collections/$collectionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/data-index/': {
      id: '/_authenticated/workspaces/$workspaceId/data-index/';
      path: '/data-index';
      fullPath: '/workspaces/$workspaceId/data-index/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/data-index/$': {
      id: '/_authenticated/workspaces/$workspaceId/data-index/$';
      path: '/data-index/$';
      fullPath: '/workspaces/$workspaceId/data-index/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/design-studio/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/$': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/design-studio/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor';
      path: '/design-studio';
      fullPath: '/workspaces/$workspaceId/design-studio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard';
      path: '/design-studio/dashboard';
      fullPath: '/workspaces/$workspaceId/design-studio/dashboard';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles';
      path: '/design-studio/global-styles';
      fullPath: '/workspaces/$workspaceId/design-studio/global-styles';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': {
      id: '/_authenticated/workspaces/$workspaceId/dev/condition-viewer';
      path: '/dev/condition-viewer';
      fullPath: '/workspaces/$workspaceId/dev/condition-viewer';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/experiments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/$experimentId';
      path: '/$experimentId';
      fullPath: '/workspaces/$workspaceId/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/new': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/experiments/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId';
      path: '/$geosetId';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/import': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/import';
      path: '/import';
      fullPath: '/workspaces/$workspaceId/geosets/import';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/new': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/geosets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/goals/': {
      id: '/_authenticated/workspaces/$workspaceId/goals/';
      path: '/goals';
      fullPath: '/workspaces/$workspaceId/goals/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/goals/$goalId': {
      id: '/_authenticated/workspaces/$workspaceId/goals/$goalId';
      path: '/goals/$goalId';
      fullPath: '/workspaces/$workspaceId/goals/$goalId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/goals/new': {
      id: '/_authenticated/workspaces/$workspaceId/goals/new';
      path: '/goals/new';
      fullPath: '/workspaces/$workspaceId/goals/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/': {
      id: '/_authenticated/workspaces/$workspaceId/home/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup';
      path: '/workspace-setup';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/';
      path: '/imports';
      fullPath: '/workspaces/$workspaceId/imports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/new': {
      id: '/_authenticated/workspaces/$workspaceId/imports/new';
      path: '/imports/new';
      fullPath: '/workspaces/$workspaceId/imports/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/';
      path: '/integrations';
      fullPath: '/workspaces/$workspaceId/integrations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/$type';
      path: '/integrations/$type';
      fullPath: '/workspaces/$workspaceId/integrations/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all';
      path: '/integrations/all';
      fullPath: '/workspaces/$workspaceId/integrations/all';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/cdp_in': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/cdp_in';
      path: '/integrations/cdp_in';
      fullPath: '/workspaces/$workspaceId/integrations/cdp_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/cdp_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/cdp_out';
      path: '/integrations/cdp_out';
      fullPath: '/workspaces/$workspaceId/integrations/cdp_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/customerio': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/customerio';
      path: '/integrations/customerio';
      fullPath: '/workspaces/$workspaceId/integrations/customerio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads';
      path: '/integrations/facebook_lead_ads';
      fullPath: '/workspaces/$workspaceId/integrations/facebook_lead_ads';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/forms': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/forms';
      path: '/integrations/forms';
      fullPath: '/workspaces/$workspaceId/integrations/forms';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out';
      path: '/integrations/mparticle_out';
      fullPath: '/workspaces/$workspaceId/integrations/mparticle_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/segment_in': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/segment_in';
      path: '/integrations/segment_in';
      fullPath: '/workspaces/$workspaceId/integrations/segment_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/segment_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/segment_out';
      path: '/integrations/segment_out';
      fullPath: '/workspaces/$workspaceId/integrations/segment_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/$';
      path: '/journeys/$';
      fullPath: '/workspaces/$workspaceId/journeys/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/assets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/assets';
      path: '/journeys/assets';
      fullPath: '/workspaces/$workspaceId/journeys/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections';
      path: '/journeys/collections';
      fullPath: '/workspaces/$workspaceId/journeys/collections';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/dashboard': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/dashboard';
      path: '/journeys/dashboard';
      fullPath: '/workspaces/$workspaceId/journeys/dashboard';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/deliveries': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/deliveries';
      path: '/journeys/deliveries';
      fullPath: '/workspaces/$workspaceId/journeys/deliveries';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/drafts';
      path: '/journeys/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/exports': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/exports';
      path: '/journeys/exports';
      fullPath: '/workspaces/$workspaceId/journeys/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences';
      path: '/journeys/geofences';
      fullPath: '/workspaces/$workspaceId/journeys/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/message-library': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/message-library';
      path: '/journeys/message-library';
      fullPath: '/workspaces/$workspaceId/journeys/message-library';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings';
      path: '/journeys/settings';
      fullPath: '/workspaces/$workspaceId/journeys/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets';
      path: '/journeys/snippets';
      fullPath: '/workspaces/$workspaceId/journeys/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/tasks';
      path: '/journeys/tasks';
      fullPath: '/workspaces/$workspaceId/journeys/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/layouts/': {
      id: '/_authenticated/workspaces/$workspaceId/layouts/';
      path: '/layouts';
      fullPath: '/workspaces/$workspaceId/layouts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/layouts/new': {
      id: '/_authenticated/workspaces/$workspaceId/layouts/new';
      path: '/layouts/new';
      fullPath: '/workspaces/$workspaceId/layouts/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/layouts/starters': {
      id: '/_authenticated/workspaces/$workspaceId/layouts/starters';
      path: '/layouts/starters';
      fullPath: '/workspaces/$workspaceId/layouts/starters';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/message_activity/$': {
      id: '/_authenticated/workspaces/$workspaceId/message_activity/$';
      path: '/message_activity/$';
      fullPath: '/workspaces/$workspaceId/message_activity/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/';
      path: '/objects';
      fullPath: '/workspaces/$workspaceId/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes/': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/outcomes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes/$goalId': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes/$goalId';
      path: '/$goalId';
      fullPath: '/workspaces/$workspaceId/outcomes/$goalId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/';
      path: '/parcel';
      fullPath: '/workspaces/$workspaceId/parcel/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/$': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/$';
      path: '/parcel/$';
      fullPath: '/workspaces/$workspaceId/parcel/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/': {
      id: '/_authenticated/workspaces/$workspaceId/people/';
      path: '/people';
      fullPath: '/workspaces/$workspaceId/people/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId';
      path: '/people/$personId';
      fullPath: '/workspaces/$workspaceId/people/$personId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/create': {
      id: '/_authenticated/workspaces/$workspaceId/people/create';
      path: '/people/create';
      fullPath: '/workspaces/$workspaceId/people/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/merge': {
      id: '/_authenticated/workspaces/$workspaceId/people/merge';
      path: '/people/merge';
      fullPath: '/workspaces/$workspaceId/people/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/new': {
      id: '/_authenticated/workspaces/$workspaceId/people/new';
      path: '/people/new';
      fullPath: '/workspaces/$workspaceId/people/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/people/welcome';
      path: '/people/welcome';
      fullPath: '/workspaces/$workspaceId/people/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profile_activity/': {
      id: '/_authenticated/workspaces/$workspaceId/profile_activity/';
      path: '/profile_activity';
      fullPath: '/workspaces/$workspaceId/profile_activity/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profile_activity/$tab': {
      id: '/_authenticated/workspaces/$workspaceId/profile_activity/$tab';
      path: '/profile_activity/$tab';
      fullPath: '/workspaces/$workspaceId/profile_activity/$tab';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/';
      path: '/profiles';
      fullPath: '/workspaces/$workspaceId/profiles/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/create': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/create';
      path: '/profiles/create';
      fullPath: '/workspaces/$workspaceId/profiles/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/merge': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/merge';
      path: '/profiles/merge';
      fullPath: '/workspaces/$workspaceId/profiles/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/new': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/new';
      path: '/profiles/new';
      fullPath: '/workspaces/$workspaceId/profiles/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/welcome';
      path: '/profiles/welcome';
      fullPath: '/workspaces/$workspaceId/profiles/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/': {
      id: '/_authenticated/workspaces/$workspaceId/reports/';
      path: '/reports';
      fullPath: '/workspaces/$workspaceId/reports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/reports/deliverability';
      path: '/reports/deliverability';
      fullPath: '/workspaces/$workspaceId/reports/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/email-clients': {
      id: '/_authenticated/workspaces/$workspaceId/reports/email-clients';
      path: '/reports/email-clients';
      fullPath: '/workspaces/$workspaceId/reports/email-clients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/gmail-postmaster': {
      id: '/_authenticated/workspaces/$workspaceId/reports/gmail-postmaster';
      path: '/reports/gmail-postmaster';
      fullPath: '/workspaces/$workspaceId/reports/gmail-postmaster';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/segments/': {
      id: '/_authenticated/workspaces/$workspaceId/segments/';
      path: '/segments';
      fullPath: '/workspaces/$workspaceId/segments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/settings/$';
      path: '/settings/$';
      fullPath: '/workspaces/$workspaceId/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': {
      id: '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile';
      path: '/settings/ai-business-profile';
      fullPath: '/workspaces/$workspaceId/settings/ai-business-profile';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': {
      id: '/_authenticated/workspaces/$workspaceId/settings/anonymous_events';
      path: '/settings/anonymous_events';
      fullPath: '/workspaces/$workspaceId/settings/anonymous_events';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api-keys': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/workspaces/$workspaceId/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/audit-logs': {
      id: '/_authenticated/workspaces/$workspaceId/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/workspaces/$workspaceId/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/auto_archive': {
      id: '/_authenticated/workspaces/$workspaceId/settings/auto_archive';
      path: '/settings/auto_archive';
      fullPath: '/workspaces/$workspaceId/settings/auto_archive';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/confirm_delete': {
      id: '/_authenticated/workspaces/$workspaceId/settings/confirm_delete';
      path: '/settings/confirm_delete';
      fullPath: '/workspaces/$workspaceId/settings/confirm_delete';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/consent': {
      id: '/_authenticated/workspaces/$workspaceId/settings/consent';
      path: '/settings/consent';
      fullPath: '/workspaces/$workspaceId/settings/consent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConsentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/edit';
      path: '/settings/edit';
      fullPath: '/workspaces/$workspaceId/settings/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/settings/geofences';
      path: '/settings/geofences';
      fullPath: '/workspaces/$workspaceId/settings/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/knowledge_library': {
      id: '/_authenticated/workspaces/$workspaceId/settings/knowledge_library';
      path: '/settings/knowledge_library';
      fullPath: '/workspaces/$workspaceId/settings/knowledge_library';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/language': {
      id: '/_authenticated/workspaces/$workspaceId/settings/language';
      path: '/settings/language';
      fullPath: '/workspaces/$workspaceId/settings/language';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/live-notification-types': {
      id: '/_authenticated/workspaces/$workspaceId/settings/live-notification-types';
      path: '/settings/live-notification-types';
      fullPath: '/workspaces/$workspaceId/settings/live-notification-types';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration';
      path: '/settings/llm_configuration';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/merge_options': {
      id: '/_authenticated/workspaces/$workspaceId/settings/merge_options';
      path: '/settings/merge_options';
      fullPath: '/workspaces/$workspaceId/settings/merge_options';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/seed-lists': {
      id: '/_authenticated/workspaces/$workspaceId/settings/seed-lists';
      path: '/settings/seed-lists';
      fullPath: '/workspaces/$workspaceId/settings/seed-lists';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center';
      path: '/settings/subscription_center';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/suppressions': {
      id: '/_authenticated/workspaces/$workspaceId/settings/suppressions';
      path: '/settings/suppressions';
      fullPath: '/workspaces/$workspaceId/settings/suppressions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/sign-up-forms_/$id': {
      id: '/_authenticated/workspaces/$workspaceId/sign-up-forms_/$id';
      path: '/sign-up-forms/$id';
      fullPath: '/workspaces/$workspaceId/sign-up-forms/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/sign-up-forms_/new': {
      id: '/_authenticated/workspaces/$workspaceId/sign-up-forms_/new';
      path: '/sign-up-forms/new';
      fullPath: '/workspaces/$workspaceId/sign-up-forms/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/template/': {
      id: '/_authenticated/workspaces/$workspaceId/template/';
      path: '/template';
      fullPath: '/workspaces/$workspaceId/template/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/template/$templateId': {
      id: '/_authenticated/workspaces/$workspaceId/template/$templateId';
      path: '/template/$templateId';
      fullPath: '/workspaces/$workspaceId/template/$templateId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/new': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/new';
      path: '/transactional/new';
      fullPath: '/workspaces/$workspaceId/transactional/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/settings/team/members/$userId/edit': {
      id: '/_authenticated/settings/team/members/$userId/edit';
      path: '/settings/team/members/$userId/edit';
      fullPath: '/settings/team/members/$userId/edit';
      preLoaderRoute: typeof AuthenticatedSettingsTeamMembersUserIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/skills/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath';
      path: '/$skillPath';
      fullPath: '/workspaces/$workspaceId/agent/skills/$skillPath';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/new': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/agent/skills/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/';
      path: '/automations/$campaignId';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow';
      path: '/automations/$campaignId/workflow';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/workflow';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/welcome/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/welcome/';
      path: '/automations/welcome';
      fullPath: '/workspaces/$workspaceId/automations/welcome/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/welcome/create': {
      id: '/_authenticated/workspaces/$workspaceId/automations/welcome/create';
      path: '/automations/welcome/create';
      fullPath: '/workspaces/$workspaceId/automations/welcome/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/';
      path: '/campaigns/$campaignId';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/$collectionId/': {
      id: '/_authenticated/workspaces/$workspaceId/collections/$collectionId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/collections/$collectionId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/$collectionId/data': {
      id: '/_authenticated/workspaces/$workspaceId/collections/$collectionId/data';
      path: '/data';
      fullPath: '/workspaces/$workspaceId/collections/$collectionId/data';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/$collectionId/importing': {
      id: '/_authenticated/workspaces/$workspaceId/collections/$collectionId/importing';
      path: '/importing';
      fullPath: '/workspaces/$workspaceId/collections/$collectionId/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/collections/$collectionId/usage': {
      id: '/_authenticated/workspaces/$workspaceId/collections/$collectionId/usage';
      path: '/usage';
      fullPath: '/workspaces/$workspaceId/collections/$collectionId/usage';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/composer/actions/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/composer/actions/$actionId';
      path: '/composer/actions/$actionId';
      fullPath: '/workspaces/$workspaceId/composer/actions/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/data-index/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/data-index/$type/';
      path: '/data-index/$type';
      fullPath: '/workspaces/$workspaceId/data-index/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/assets': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/assets';
      path: '/assets';
      fullPath: '/workspaces/$workspaceId/design-studio/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/brand': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/brand';
      path: '/brand';
      fullPath: '/workspaces/$workspaceId/design-studio/brand';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/welcome';
      path: '/welcome';
      fullPath: '/workspaces/$workspaceId/design-studio/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns';
      path: '/dev/db/campaigns';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit';
      path: '/edit';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences';
      path: '/geofences';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/goals/$goalId/': {
      id: '/_authenticated/workspaces/$workspaceId/goals/$goalId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/goals/$goalId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/goals/$goalId/milestones': {
      id: '/_authenticated/workspaces/$workspaceId/goals/$goalId/milestones';
      path: '/milestones';
      fullPath: '/workspaces/$workspaceId/goals/$goalId/milestones';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/';
      path: '/imports/$importId';
      fullPath: '/workspaces/$workspaceId/imports/$importId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/all/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/developers': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/developers';
      path: '/developers';
      fullPath: '/workspaces/$workspaceId/integrations/all/developers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/directory': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/directory';
      path: '/directory';
      fullPath: '/workspaces/$workspaceId/integrations/all/directory';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/overview': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/overview';
      path: '/overview';
      fullPath: '/workspaces/$workspaceId/integrations/all/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks';
      path: '/webhooks';
      fullPath: '/workspaces/$workspaceId/integrations/all/webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type';
      path: '/integrations/data_out/$type';
      fullPath: '/workspaces/$workspaceId/integrations/data_out/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads_/$formId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads_/$formId';
      path: '/integrations/facebook_lead_ads/$formId';
      fullPath: '/workspaces/$workspaceId/integrations/facebook_lead_ads/$formId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type';
      path: '/integrations/forms/$type';
      fullPath: '/workspaces/$workspaceId/integrations/forms/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/forms_/settings': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/forms_/settings';
      path: '/integrations/forms/settings';
      fullPath: '/workspaces/$workspaceId/integrations/forms/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/';
      path: '/integrations/reporting-webhooks';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId';
      path: '/integrations/reporting-webhooks/$webhookId';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new';
      path: '/integrations/reporting-webhooks/new';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type';
      path: '/integrations/sql-sync/$type';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type';
      path: '/integrations/warehouse/$type';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery';
      path: '/integrations/warehouse/bigquery';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/bigquery';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift';
      path: '/integrations/warehouse/redshift';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/redshift';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake';
      path: '/integrations/warehouse/snowflake';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/snowflake';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/';
      path: '/journeys/activity_logs';
      fullPath: '/workspaces/$workspaceId/journeys/activity_logs/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab';
      path: '/journeys/activity_logs/$tab';
      fullPath: '/workspaces/$workspaceId/journeys/activity_logs/$tab';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/analysis/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/analysis/';
      path: '/journeys/analysis';
      fullPath: '/workspaces/$workspaceId/journeys/analysis/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability';
      path: '/journeys/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/journeys/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/anonymous/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/anonymous/';
      path: '/journeys/anonymous';
      fullPath: '/workspaces/$workspaceId/journeys/anonymous/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/';
      path: '/journeys/automations';
      fullPath: '/workspaces/$workspaceId/journeys/automations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/new';
      path: '/journeys/automations/new';
      fullPath: '/workspaces/$workspaceId/journeys/automations/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/';
      path: '/journeys/broadcasts';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/api-triggered': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/api-triggered';
      path: '/journeys/broadcasts/api-triggered';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/api-triggered';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/new';
      path: '/journeys/broadcasts/new';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletters': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletters';
      path: '/journeys/broadcasts/newsletters';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletters';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/one_time_sends': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/one_time_sends';
      path: '/journeys/broadcasts/one_time_sends';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/one_time_sends';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/send-volume': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/send-volume';
      path: '/journeys/broadcasts/send-volume';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/send-volume';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/welcome';
      path: '/journeys/broadcasts/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/';
      path: '/journeys/campaigns';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/new';
      path: '/journeys/campaigns/new';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/collections/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/data-index/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/data-index/';
      path: '/journeys/data-index';
      fullPath: '/workspaces/$workspaceId/journeys/data-index/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/data-index/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$';
      path: '/journeys/data-index/$';
      fullPath: '/workspaces/$workspaceId/journeys/data-index/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/goals/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/goals/';
      path: '/journeys/goals';
      fullPath: '/workspaces/$workspaceId/journeys/goals/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/goals/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/goals/$';
      path: '/journeys/goals/$';
      fullPath: '/workspaces/$workspaceId/journeys/goals/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId';
      path: '/journeys/goals/$goalId';
      fullPath: '/workspaces/$workspaceId/journeys/goals/$goalId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/goals/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/goals/new';
      path: '/journeys/goals/new';
      fullPath: '/workspaces/$workspaceId/journeys/goals/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/home/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/home/';
      path: '/journeys/home';
      fullPath: '/workspaces/$workspaceId/journeys/home/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/';
      path: '/journeys/imports';
      fullPath: '/workspaces/$workspaceId/journeys/imports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/new';
      path: '/journeys/imports/new';
      fullPath: '/workspaces/$workspaceId/journeys/imports/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/';
      path: '/journeys/integrations';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type';
      path: '/journeys/integrations/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all';
      path: '/journeys/integrations/all';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in';
      path: '/journeys/integrations/cdp_in';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/cdp_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out';
      path: '/journeys/integrations/cdp_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/cdp_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio';
      path: '/journeys/integrations/customerio';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/customerio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads';
      path: '/journeys/integrations/facebook_lead_ads';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms';
      path: '/journeys/integrations/forms';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/forms';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out';
      path: '/journeys/integrations/mparticle_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/mparticle_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks';
      path: '/journeys/integrations/reporting-webhooks';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in';
      path: '/journeys/integrations/segment_in';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/segment_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out';
      path: '/journeys/integrations/segment_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/segment_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/';
      path: '/journeys/layouts';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/new';
      path: '/journeys/layouts/new';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters';
      path: '/journeys/layouts/starters';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/starters';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$';
      path: '/journeys/message_activity/$';
      fullPath: '/workspaces/$workspaceId/journeys/message_activity/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/';
      path: '/journeys/objects';
      fullPath: '/workspaces/$workspaceId/journeys/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/outbox/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/outbox/$';
      path: '/journeys/outbox/$';
      fullPath: '/workspaces/$workspaceId/journeys/outbox/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/';
      path: '/journeys/people';
      fullPath: '/workspaces/$workspaceId/journeys/people/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/create';
      path: '/journeys/people/create';
      fullPath: '/workspaces/$workspaceId/journeys/people/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/merge': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/merge';
      path: '/journeys/people/merge';
      fullPath: '/workspaces/$workspaceId/journeys/people/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/new';
      path: '/journeys/people/new';
      fullPath: '/workspaces/$workspaceId/journeys/people/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/welcome';
      path: '/journeys/people/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/people/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/';
      path: '/journeys/profile_activity';
      fullPath: '/workspaces/$workspaceId/journeys/profile_activity/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab';
      path: '/journeys/profile_activity/$tab';
      fullPath: '/workspaces/$workspaceId/journeys/profile_activity/$tab';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/';
      path: '/journeys/profiles';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/create';
      path: '/journeys/profiles/create';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge';
      path: '/journeys/profiles/merge';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/new';
      path: '/journeys/profiles/new';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome';
      path: '/journeys/profiles/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/reports/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/reports/';
      path: '/journeys/reports';
      fullPath: '/workspaces/$workspaceId/journeys/reports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/';
      path: '/journeys/segments';
      fullPath: '/workspaces/$workspaceId/journeys/segments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/journeys/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$';
      path: '/journeys/setup-guide/$';
      fullPath: '/workspaces/$workspaceId/journeys/setup-guide/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/template/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/template/';
      path: '/journeys/template';
      fullPath: '/workspaces/$workspaceId/journeys/template/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId';
      path: '/journeys/template/$templateId';
      fullPath: '/workspaces/$workspaceId/journeys/template/$templateId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/';
      path: '/journeys/transactional';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/new';
      path: '/journeys/transactional/new';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/triggered/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/triggered/';
      path: '/journeys/triggered';
      fullPath: '/workspaces/$workspaceId/journeys/triggered/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/triggered/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/triggered/new';
      path: '/journeys/triggered/new';
      fullPath: '/workspaces/$workspaceId/journeys/triggered/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/v2/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/v2/$';
      path: '/journeys/v2/$';
      fullPath: '/workspaces/$workspaceId/journeys/v2/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/': {
      id: '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/';
      path: '/layouts/$layoutId';
      fullPath: '/workspaces/$workspaceId/layouts/$layoutId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/layouts/$layoutId/edit';
      path: '/layouts/$layoutId/edit';
      fullPath: '/workspaces/$workspaceId/layouts/$layoutId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/';
      path: '/objects/$slug';
      fullPath: '/workspaces/$workspaceId/objects/$slug/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId';
      path: '/objects/$slug/$objectId';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/guide': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/guide';
      path: '/objects/$slug/guide';
      fullPath: '/workspaces/$workspaceId/objects/$slug/guide';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/new': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/new';
      path: '/objects/$slug/new';
      fullPath: '/workspaces/$workspaceId/objects/$slug/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/people/$personId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/';
      path: '/destinations';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      path: '/destinations/$destinationId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add';
      path: '/destinations/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys';
      path: '/destinations/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/';
      path: '/sources';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId';
      path: '/sources/$sourceId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add';
      path: '/sources/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys';
      path: '/sources/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/segments/$segmentId/audiences': {
      id: '/_authenticated/workspaces/$workspaceId/segments/$segmentId/audiences';
      path: '/segments/$segmentId/audiences';
      fullPath: '/workspaces/$workspaceId/segments/$segmentId/audiences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/segments/$segmentId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/segments/$segmentId/overview';
      path: '/segments/$segmentId/overview';
      fullPath: '/workspaces/$workspaceId/segments/$segmentId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/segments/$segmentId/people': {
      id: '/_authenticated/workspaces/$workspaceId/segments/$segmentId/people';
      path: '/segments/$segmentId/people';
      fullPath: '/workspaces/$workspaceId/segments/$segmentId/people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/segments/$segmentId/usage': {
      id: '/_authenticated/workspaces/$workspaceId/segments/$segmentId/usage';
      path: '/segments/$segmentId/usage';
      fullPath: '/workspaces/$workspaceId/segments/$segmentId/usage';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email';
      path: '/settings/actions/email';
      fullPath: '/workspaces/$workspaceId/settings/actions/email';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/in_app': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/in_app';
      path: '/settings/actions/in_app';
      fullPath: '/workspaces/$workspaceId/settings/actions/in_app';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/line': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/line';
      path: '/settings/actions/line';
      fullPath: '/workspaces/$workspaceId/settings/actions/line';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits';
      path: '/settings/actions/message_frequency_limits';
      fullPath: '/workspaces/$workspaceId/settings/actions/message_frequency_limits';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit';
      path: '/settings/actions/messaging_limit';
      fullPath: '/workspaces/$workspaceId/settings/actions/messaging_limit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/push': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/push';
      path: '/settings/actions/push';
      fullPath: '/workspaces/$workspaceId/settings/actions/push';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/slack': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/slack';
      path: '/settings/actions/slack';
      fullPath: '/workspaces/$workspaceId/settings/actions/slack';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms';
      path: '/settings/actions/sms';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers';
      path: '/settings/actions/sms-providers';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match';
      path: '/settings/actions/time_zone_match';
      fullPath: '/workspaces/$workspaceId/settings/actions/time_zone_match';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/twilio': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/twilio';
      path: '/settings/actions/twilio';
      fullPath: '/workspaces/$workspaceId/settings/actions/twilio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship';
      path: '/settings/actions/urban_airship';
      fullPath: '/workspaces/$workspaceId/settings/actions/urban_airship';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params';
      path: '/settings/actions/url_params';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/whatsapp': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/whatsapp';
      path: '/settings/actions/whatsapp';
      fullPath: '/workspaces/$workspaceId/settings/actions/whatsapp';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api_credentials/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api_credentials/';
      path: '/settings/api_credentials';
      fullPath: '/workspaces/$workspaceId/settings/api_credentials/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/';
      path: '/settings/objects';
      fullPath: '/workspaces/$workspaceId/settings/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/new';
      path: '/settings/objects/new';
      fullPath: '/workspaces/$workspaceId/settings/objects/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/';
      path: '/settings/webhook_configuration';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new';
      path: '/settings/webhook_configuration/new';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview';
      path: '/transactional/$transactionalMessageId/overview';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup';
      path: '/transactional/$transactionalMessageId/setup';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/';
      path: '/automations/$campaignId/overview';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/drafts';
      path: '/automations/$campaignId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions';
      path: '/automations/$campaignId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics';
      path: '/automations/$campaignId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/metrics';
      path: '/automations/$campaignId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests';
      path: '/automations/$campaignId/overview/tests';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/';
      path: '/broadcasts/broadcast/$broadcastId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview';
      path: '/broadcasts/newsletter/$newsletterId/overview';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup';
      path: '/broadcasts/newsletter/$newsletterId/setup';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/';
      path: '/campaigns/$campaignId/overview';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts';
      path: '/campaigns/$campaignId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions';
      path: '/campaigns/$campaignId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics';
      path: '/campaigns/$campaignId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics';
      path: '/campaigns/$campaignId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests';
      path: '/campaigns/$campaignId/overview/tests';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/': {
      id: '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/';
      path: '/data-index/$type/$itemId';
      fullPath: '/workspaces/$workspaceId/data-index/$type/$itemId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId': {
      id: '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId';
      path: '/data-index/$type/$itemId/$nestedItemId';
      fullPath: '/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/';
      path: '/editor';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id';
      path: '/editor/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import';
      path: '/import';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/import';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/';
      path: '/imports/$importId/setup';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields';
      path: '/imports/$importId/setup/fields';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/fields';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing';
      path: '/imports/$importId/setup/importing';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing';
      path: '/imports/$importId/setup/preprocessing';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/preprocessing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview';
      path: '/imports/$importId/setup/preview';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/preview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review';
      path: '/imports/$importId/setup/review';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating';
      path: '/imports/$importId/setup/validating';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/validating';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/settings': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/settings';
      path: '/integrations/audiences/$type/settings';
      fullPath: '/workspaces/$workspaceId/integrations/audiences/$type/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/setup': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/setup';
      path: '/integrations/audiences/$type/setup';
      fullPath: '/workspaces/$workspaceId/integrations/audiences/$type/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type_/$formId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/forms_/$type_/$formId';
      path: '/integrations/forms/$type/$formId';
      fullPath: '/workspaces/$workspaceId/integrations/forms/$type/$formId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId';
      path: '/$sqlImportId';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync';
      path: '/integrations/warehouse/$type/sync';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/$type/sync';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/';
      path: '/journeys/automations/$campaignId';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/workflow': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/workflow';
      path: '/journeys/automations/$campaignId/workflow';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/workflow';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/';
      path: '/journeys/automations/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/automations/welcome/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/welcome/create';
      path: '/journeys/automations/welcome/create';
      fullPath: '/workspaces/$workspaceId/journeys/automations/welcome/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/';
      path: '/journeys/broadcasts/broadcast';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/';
      path: '/journeys/broadcasts/newsletter';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/';
      path: '/journeys/campaigns/$campaignId';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow';
      path: '/journeys/campaigns/$campaignId/workflow';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/';
      path: '/journeys/campaigns/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/welcome/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/create';
      path: '/journeys/campaigns/welcome/create';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/welcome/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/';
      path: '/$collectionId';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$';
      path: '/$collectionId/$';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data';
      path: '/$collectionId/data';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/data';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing';
      path: '/$collectionId/importing';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage';
      path: '/$collectionId/usage';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/usage';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/composer/actions/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/composer/actions/$actionId';
      path: '/journeys/composer/actions/$actionId';
      fullPath: '/workspaces/$workspaceId/journeys/composer/actions/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/';
      path: '/journeys/data-index/$type';
      fullPath: '/workspaces/$workspaceId/journeys/data-index/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId_/milestones': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId_/milestones';
      path: '/journeys/goals/$goalId/milestones';
      fullPath: '/workspaces/$workspaceId/journeys/goals/$goalId/milestones';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/';
      path: '/journeys/home/workspace-setup';
      fullPath: '/workspaces/$workspaceId/journeys/home/workspace-setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/add-people';
      path: '/journeys/home/workspace-setup/add-people';
      fullPath: '/workspaces/$workspaceId/journeys/home/workspace-setup/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/';
      path: '/journeys/imports/$importId';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers';
      path: '/developers';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/developers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory';
      path: '/directory';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/directory';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview';
      path: '/overview';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks';
      path: '/webhooks';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type';
      path: '/journeys/integrations/data_out/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/data_out/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads_/$formId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads_/$formId';
      path: '/journeys/integrations/facebook_lead_ads/$formId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads/$formId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type';
      path: '/journeys/integrations/forms/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/forms/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/settings';
      path: '/journeys/integrations/forms/settings';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/forms/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId';
      path: '/$webhookId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type';
      path: '/journeys/integrations/sql-sync/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type';
      path: '/journeys/integrations/warehouse/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery';
      path: '/journeys/integrations/warehouse/bigquery';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift';
      path: '/journeys/integrations/warehouse/redshift';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake';
      path: '/journeys/integrations/warehouse/snowflake';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/';
      path: '/journeys/layouts/$layoutId';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/$layoutId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit';
      path: '/journeys/layouts/$layoutId/edit';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/';
      path: '/journeys/objects/$slug';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide';
      path: '/journeys/objects/$slug/guide';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/guide';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new';
      path: '/journeys/objects/$slug/new';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/';
      path: '/journeys/people/$personId';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/';
      path: '/journeys/segments/$segmentId';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/audiences': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/audiences';
      path: '/journeys/segments/$segmentId/audiences';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/audiences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/overview';
      path: '/journeys/segments/$segmentId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/people': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/people';
      path: '/journeys/segments/$segmentId/people';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/usage': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/usage';
      path: '/journeys/segments/$segmentId/usage';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/usage';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview';
      path: '/journeys/transactional/$transactionalMessageId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup';
      path: '/journeys/transactional/$transactionalMessageId/setup';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/activity': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/activity';
      path: '/activity';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/activity';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/relationships': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/relationships';
      path: '/relationships';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/relationships';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/activity/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/activity/';
      path: '/activity';
      fullPath: '/workspaces/$workspaceId/people/$personId/activity/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/';
      path: '/attributes';
      fullPath: '/workspaces/$workspaceId/people/$personId/attributes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/edit': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/attributes/edit';
      path: '/attributes/edit';
      fullPath: '/workspaces/$workspaceId/people/$personId/attributes/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/devices/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/devices/';
      path: '/devices';
      fullPath: '/workspaces/$workspaceId/people/$personId/devices/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/drafts/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/drafts/';
      path: '/drafts';
      fullPath: '/workspaces/$workspaceId/people/$personId/drafts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/';
      path: '/journeys';
      fullPath: '/workspaces/$workspaceId/people/$personId/journeys/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/$subjectId': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/journeys/$subjectId';
      path: '/journeys/$subjectId';
      fullPath: '/workspaces/$workspaceId/people/$personId/journeys/$subjectId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/';
      path: '/live-notifications';
      fullPath: '/workspaces/$workspaceId/people/$personId/live-notifications/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId';
      path: '/live-notifications/$conversationId';
      fullPath: '/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/relationships/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/relationships/';
      path: '/relationships';
      fullPath: '/workspaces/$workspaceId/people/$personId/relationships/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/segments/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/segments/';
      path: '/segments';
      fullPath: '/workspaces/$workspaceId/people/$personId/segments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/segments/belongs': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/segments/belongs';
      path: '/segments/belongs';
      fullPath: '/workspaces/$workspaceId/people/$personId/segments/belongs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/segments/others': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/segments/others';
      path: '/segments/others';
      fullPath: '/workspaces/$workspaceId/people/$personId/segments/others';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/$personId/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/people/$personId/sent/';
      path: '/sent';
      fullPath: '/workspaces/$workspaceId/people/$personId/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      path: '/data-out';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      path: '/subscriptions';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      path: '/tester';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId';
      path: '/destinations/add/$destinationOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      path: '/data-in';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      path: '/databases';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      path: '/imports';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      path: '/syncs';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId';
      path: '/sources/add/$sourceOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/apps/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/apps/';
      path: '/settings/actions/apps';
      fullPath: '/workspaces/$workspaceId/settings/actions/apps/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/apps/create': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/apps/create';
      path: '/settings/actions/apps/create';
      fullPath: '/workspaces/$workspaceId/settings/actions/apps/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults';
      path: '/defaults';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/defaults';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability';
      path: '/deliverability';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses';
      path: '/dynamic_addresses';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses';
      path: '/from_addresses';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/from_addresses';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/postmaster_tools': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/postmaster_tools';
      path: '/postmaster_tools';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/postmaster_tools';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp';
      path: '/smtp';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/smtp';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list';
      path: '/suppression_list';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/suppression_list';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/push/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/push/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/push/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/push/android': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/push/android';
      path: '/android';
      fullPath: '/workspaces/$workspaceId/settings/actions/push/android';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/push/ios': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/push/ios';
      path: '/ios';
      fullPath: '/workspaces/$workspaceId/settings/actions/push/ios';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/push/web': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/push/web';
      path: '/web';
      fullPath: '/workspaces/$workspaceId/settings/actions/push/web';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/phone-numbers': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/phone-numbers';
      path: '/phone-numbers';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/phone-numbers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration';
      path: '/registration';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/registration';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/settings': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit';
      path: '/edit';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId';
      path: '/settings/api_credentials/service_accounts/$serviceAccountId';
      fullPath: '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit';
      path: '/$configurationId/edit';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType';
      path: '/settings/objects/edit/$objectType';
      fullPath: '/workspaces/$workspaceId/settings/objects/edit/$objectType';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit';
      path: '/branding/edit';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/branding/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit';
      path: '/localization/edit';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/localization/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/';
      path: '/topics';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/topics/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences';
      path: '/topics/set_preferences';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit';
      path: '/settings/webhook_configuration/$webhookId/edit';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/drafts';
      path: '/drafts';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/metrics';
      path: '/metrics';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/send': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/send';
      path: '/send';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/send';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/review';
      path: '/review';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/settings': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/setup/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/';
      path: '/automations/$campaignId/overview/sent';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId';
      path: '/automations/$campaignId/overview/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/tests/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/';
      path: '/broadcasts/broadcast/$broadcastId/overview';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/form-submissions';
      path: '/broadcasts/broadcast/$broadcastId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journey_metrics';
      path: '/broadcasts/broadcast/$broadcastId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journeys';
      path: '/broadcasts/broadcast/$broadcastId/overview/journeys';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/metrics';
      path: '/broadcasts/broadcast/$broadcastId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests';
      path: '/broadcasts/broadcast/$broadcastId/overview/tests';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/triggering_details': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/triggering_details';
      path: '/broadcasts/broadcast/$broadcastId/overview/triggering_details';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/triggering_details';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/content': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/content';
      path: '/content';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/content';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/form-submissions';
      path: '/form-submissions';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/recipients': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/recipients';
      path: '/recipients';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/recipients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/reports': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/reports';
      path: '/reports';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent';
      path: '/sent';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/test': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/test';
      path: '/test';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/test';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/content': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/content';
      path: '/content';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/content';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/recipients': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/recipients';
      path: '/recipients';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/recipients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/review';
      path: '/review';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule';
      path: '/schedule';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/schedule';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/tracking': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/tracking';
      path: '/tracking';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/setup/tracking';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/';
      path: '/campaigns/$campaignId/overview/sent';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId';
      path: '/campaigns/$campaignId/overview/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/in-app/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/in-app/$id';
      path: '/editor/in-app/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/in-app/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/inbox-message/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/inbox-message/$id';
      path: '/editor/inbox-message/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/inbox-message/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/push/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/push/$id';
      path: '/editor/push/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/push/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sign-up-form/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sign-up-form/$id';
      path: '/editor/sign-up-form/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/sign-up-form/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sms/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sms/$id';
      path: '/editor/sms/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/sms/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/whatsapp/$id': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/whatsapp/$id';
      path: '/editor/whatsapp/$id';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/whatsapp/$id';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/journeys/$templateWorkspaceId/$templateId': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/journeys/$templateWorkspaceId/$templateId';
      path: '/journeys/$templateWorkspaceId/$templateId';
      fullPath: '/workspaces/$workspaceId/design-studio/journeys/$templateWorkspaceId/$templateId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      path: '/actions/$actionId';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query';
      path: '/query';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      path: '/relationships-query';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/';
      path: '/journeys/automations/$campaignId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts';
      path: '/journeys/automations/$campaignId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions';
      path: '/journeys/automations/$campaignId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics';
      path: '/journeys/automations/$campaignId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics';
      path: '/journeys/automations/$campaignId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests';
      path: '/journeys/automations/$campaignId/overview/tests';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/';
      path: '/journeys/broadcasts/broadcast/$broadcastId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview';
      path: '/journeys/broadcasts/newsletter/$newsletterId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup';
      path: '/journeys/broadcasts/newsletter/$newsletterId/setup';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/';
      path: '/journeys/campaigns/$campaignId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts';
      path: '/journeys/campaigns/$campaignId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions';
      path: '/journeys/campaigns/$campaignId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics';
      path: '/journeys/campaigns/$campaignId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics';
      path: '/journeys/campaigns/$campaignId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests';
      path: '/journeys/campaigns/$campaignId/overview/tests';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/';
      path: '/journeys/data-index/$type/$itemId';
      fullPath: '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId';
      path: '/journeys/data-index/$type/$itemId/$nestedItemId';
      fullPath: '/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/';
      path: '/journeys/imports/$importId/setup';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields';
      path: '/journeys/imports/$importId/setup/fields';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing';
      path: '/journeys/imports/$importId/setup/importing';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing';
      path: '/journeys/imports/$importId/setup/preprocessing';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview';
      path: '/journeys/imports/$importId/setup/preview';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review';
      path: '/journeys/imports/$importId/setup/review';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating';
      path: '/journeys/imports/$importId/setup/validating';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings';
      path: '/journeys/integrations/audiences/$type/settings';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup';
      path: '/journeys/integrations/audiences/$type/setup';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type_/$formId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type_/$formId';
      path: '/journeys/integrations/forms/$type/$formId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/forms/$type/$formId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId';
      path: '/$sqlImportId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync';
      path: '/journeys/integrations/warehouse/$type/sync';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/';
      path: '/journeys/objects/$slug/$objectId';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity';
      path: '/journeys/objects/$slug/$objectId/activity';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/activity';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships';
      path: '/journeys/objects/$slug/$objectId/relationships';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/activity/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/activity/';
      path: '/journeys/people/$personId/activity';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/activity/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/';
      path: '/journeys/people/$personId/attributes';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/attributes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/edit': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/edit';
      path: '/journeys/people/$personId/attributes/edit';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/attributes/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/devices/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/devices/';
      path: '/journeys/people/$personId/devices';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/devices/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/drafts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/drafts/';
      path: '/journeys/people/$personId/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/drafts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/';
      path: '/journeys/people/$personId/journeys';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/journeys/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId';
      path: '/journeys/people/$personId/journeys/$subjectId';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/';
      path: '/journeys/people/$personId/live-notifications';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId';
      path: '/journeys/people/$personId/live-notifications/$conversationId';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/relationships/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/relationships/';
      path: '/journeys/people/$personId/relationships';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/relationships/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/';
      path: '/journeys/people/$personId/segments';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/segments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/belongs': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/belongs';
      path: '/journeys/people/$personId/segments/belongs';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/segments/belongs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/others': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/others';
      path: '/journeys/people/$personId/segments/others';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/segments/others';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/sent/';
      path: '/journeys/people/$personId/sent';
      fullPath: '/workspaces/$workspaceId/journeys/people/$personId/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/drafts';
      path: '/journeys/transactional/$transactionalMessageId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/metrics';
      path: '/journeys/transactional/$transactionalMessageId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/send': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/send';
      path: '/journeys/transactional/$transactionalMessageId/overview/send';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/send';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review';
      path: '/review';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/';
      path: '/attributes';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit';
      path: '/attributes/edit';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      path: '/$subscriptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      path: '/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId';
      path: '/sources/$sourceId/syncs/$syncId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add';
      path: '/sources/$sourceId/syncs/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/apps/edit/$appId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/apps/edit/$appId';
      path: '/settings/actions/apps/edit/$appId';
      fullPath: '/workspaces/$workspaceId/settings/actions/apps/edit/$appId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/';
      path: '/sending_domains';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/sending_domains/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId';
      path: '/sending_domains/$domainId';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId';
      path: '/credentials/$credentialId';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/registration/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/business-info': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/business-info';
      path: '/business-info';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/registration/business-info';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact';
      path: '/point-of-contact';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/review': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/review';
      path: '/review';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms/registration/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/';
      path: '/sent';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId';
      path: '/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/transactional/$transactionalMessageId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/';
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/';
      path: '/broadcasts/broadcast/$broadcastId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId';
      path: '/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/$deliveryId';
      path: '/$deliveryId';
      fullPath: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId';
      path: '/editor/$id/inbox-previews/$runId';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/';
      path: '/journeys/automations/$campaignId/overview/sent';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId';
      path: '/journeys/automations/$campaignId/overview/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions';
      path: '/journeys/automations/$campaignId/overview/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions';
      path: '/journeys/automations/$campaignId/setup/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journey_metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/journeys';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/metrics';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/tests';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content';
      path: '/content';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/content';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions';
      path: '/form-submissions';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/form-submissions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients';
      path: '/recipients';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/recipients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports';
      path: '/reports';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/reports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent';
      path: '/sent';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test';
      path: '/test';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/test';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93RouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content';
      path: '/content';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/content';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients';
      path: '/recipients';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/recipients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review';
      path: '/review';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule';
      path: '/schedule';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/schedule';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking';
      path: '/tracking';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup/tracking';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/';
      path: '/journeys/campaigns/$campaignId/overview/sent';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId';
      path: '/journeys/campaigns/$campaignId/overview/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions';
      path: '/journeys/campaigns/$campaignId/overview/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions';
      path: '/journeys/campaigns/$campaignId/setup/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query';
      path: '/$sqlImportId/query';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query';
      path: '/$sqlImportId/relationships-query';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings';
      path: '/$sqlImportId/settings';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/';
      path: '/journeys/objects/$slug/$objectId/attributes';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit';
      path: '/journeys/objects/$slug/$objectId/attributes/edit';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/attributes/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new';
      path: '/journeys/segments/$segmentId/imports/csv/new';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/';
      path: '/journeys/transactional/$transactionalMessageId/overview/sent';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId';
      path: '/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/';
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      path: '/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/drafts/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId';
      path: '/$actionId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId';
      path: '/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview/sent/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId_/previews/$previewId': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId_/previews/$previewId';
      path: '/editor/$id/inbox-previews/$runId/previews/$previewId';
      fullPath: '/workspaces/$workspaceId/design-studio/editor/$id/inbox-previews/$runId/previews/$previewId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      path: '/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId';
      path: '/experiments/$experimentId';
      fullPath: '/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/';
      path: '/journeys/segments/$segmentId/imports/csv/setup/$importId';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step';
      path: '/journeys/segments/$segmentId/imports/csv/setup/$importId/$step';
      fullPath: '/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
  }
}

interface R2fa_setupRouteChildren {
  R2fa_setupNew_totpRoute: typeof R2fa_setupNew_totpRoute;
  R2fa_setupIndexRoute: typeof R2fa_setupIndexRoute;
}

const R2fa_setupRouteChildren: R2fa_setupRouteChildren = {
  R2fa_setupNew_totpRoute: R2fa_setupNew_totpRoute,
  R2fa_setupIndexRoute: R2fa_setupIndexRoute,
};

const R2fa_setupRouteWithChildren = R2fa_setupRoute._addFileChildren(
  R2fa_setupRouteChildren,
);

interface AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteChildren: AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsApiTriggeredRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsOne_time_sendsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsSendVolumeRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute;
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute;
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdDataRoute,
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdUsageRoute,
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdCollectionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdCollectionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdCollectionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsCollectionIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdCollectionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdCollectionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdCollectionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren: AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren: AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute,
    AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdExperimentsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren: AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute,
    AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdOutcomesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteChildren: AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorBrandRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInAppIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorInboxMessageIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorPushIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSignUpFormIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorSmsIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorWhatsappIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorJourneysTemplateWorkspaceIdTemplateIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorEditorIdInboxPreviewsRunIdPreviewsPreviewIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute;
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute:
      AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdMilestonesRoute,
    AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesEditRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysSubjectIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsConversationIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsBelongsRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsOthersRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdActivityIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdAttributesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDevicesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdDraftsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdJourneysIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdLiveNotificationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRelationshipsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSegmentsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdSentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren: AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdActivityRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRelationshipsRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesEditRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdAttributesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailPostmaster_toolsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushAndroidRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIosRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushWebRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationBusinessInfoRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationPointOfContactRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsPhoneNumbersRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRegistrationRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteChildren: AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSendRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewSentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren: AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteChildren: AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewContentRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewReportsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupContentRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRecipientsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupScheduleRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupTrackingRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentDeliveryIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewContentRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRecipientsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewReportsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewSentRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewChar91testChar93Route,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupContentRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRecipientsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupScheduleRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupTrackingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsExperimentsExperimentIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAnonymousRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnonymousRoute;
  AuthenticatedWorkspacesWorkspaceIdAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdCollectionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCollectionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdDashboardRoute: typeof AuthenticatedWorkspacesWorkspaceIdDashboardRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdExperimentsRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHealthRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  AuthenticatedWorkspacesWorkspaceIdOutcomesRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalRoute;
  AuthenticatedWorkspacesWorkspaceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute;
  AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute;
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute: typeof AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAnonymousRoute:
      AuthenticatedWorkspacesWorkspaceIdAnonymousRoute,
    AuthenticatedWorkspacesWorkspaceIdAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdCollectionsRoute:
      AuthenticatedWorkspacesWorkspaceIdCollectionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdDashboardRoute:
      AuthenticatedWorkspacesWorkspaceIdDashboardRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdExperimentsRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHealthRoute:
      AuthenticatedWorkspacesWorkspaceIdHealthRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute:
      AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute,
    AuthenticatedWorkspacesWorkspaceIdOutcomesRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute:
      AuthenticatedWorkspacesWorkspaceIdSignUpFormsRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalRoute,
    AuthenticatedWorkspacesWorkspaceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisGmailPostmasterRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdDataIndexSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudio_editorRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute,
    AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute:
      AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute,
    AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGoalsGoalIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGoalsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDashboardRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdLayoutsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute:
      AuthenticatedWorkspacesWorkspaceIdLayoutsStartersRoute,
    AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute:
      AuthenticatedWorkspacesWorkspaceIdMessage_activitySplatRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPeoplePersonIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute:
      AuthenticatedWorkspacesWorkspaceIdProfile_activityTabRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsGmailPostmasterRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsConsentRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsKnowledge_libraryRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLiveNotificationTypesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSeedListsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute,
    AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSignUpFormsIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSignUpFormsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute:
      AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalNewRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDataIndexIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGoalsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdLayoutsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdProfile_activityIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSegmentsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdComposerActionsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFacebook_lead_adsFormIdRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsApiTriggeredRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewslettersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsOne_time_sendsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsSendVolumeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGoalsSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGoalsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute,
    AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute:
      AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdAudiencesRoute,
    AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute:
      AuthenticatedWorkspacesWorkspaceIdSegmentsSegmentIdUsageRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsIn_appRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsPushRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsTwilioRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsWhatsappRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdOverviewRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdTransactionalTransactionalMessageIdSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsWelcomeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDataIndexTypeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAnonymousIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGoalsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysHomeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysReportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdLayoutsLayoutIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsNewsletterNewsletterIdSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdNestedItemIdRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAudiencesTypeSetupRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsFormsTypeFormIdRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdWorkflowRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdWorkflowRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysComposerActionsActionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGoalsGoalIdMilestonesRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFacebook_lead_adsFormIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdAudiencesRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdUsageRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDataIndexTypeItemIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsWelcomeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsWelcomeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysHomeWorkspaceSetupIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdOverviewRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsNewsletterNewsletterIdSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdNestedItemIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAudiencesTypeSetupRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsFormsTypeFormIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdActivityRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdRelationshipsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesEditRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysSubjectIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsConversationIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsBelongsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsOthersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSendRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsAppsEditAppIdRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdOverviewSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdCampaignsCampaignIdOverviewSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDataIndexTypeItemIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdActivityIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdAttributesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDevicesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdDraftsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdJourneysIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdLiveNotificationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdRelationshipsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSegmentsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeoplePersonIdSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewFormSubmissionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourney_metricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewMetricsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTestsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewTriggering_detailsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesEditRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdAttributesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTransactionalTransactionalMessageIdOverviewSentIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewDraftsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdDeliveryIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdStepRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysBroadcastsBroadcastBroadcastIdOverviewBroadcastsTriggerIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSegmentsSegmentIdImportsCsvSetupImportIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdRouteChildren,
  );

interface AuthenticatedWorkspacesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute;
}

const AuthenticatedWorkspacesRouteChildren: AuthenticatedWorkspacesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdRouteWithChildren,
    AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  };

const AuthenticatedWorkspacesRouteWithChildren =
  AuthenticatedWorkspacesRoute._addFileChildren(
    AuthenticatedWorkspacesRouteChildren,
  );

interface AuthenticatedSettingsBillingRouteChildren {
  AuthenticatedSettingsBillingSplatRoute: typeof AuthenticatedSettingsBillingSplatRoute;
  AuthenticatedSettingsBillingAddOnsRoute: typeof AuthenticatedSettingsBillingAddOnsRoute;
  AuthenticatedSettingsBillingBillingDetailsRoute: typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  AuthenticatedSettingsBillingBillingHistoryRoute: typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  AuthenticatedSettingsBillingCheckoutRoute: typeof AuthenticatedSettingsBillingCheckoutRoute;
  AuthenticatedSettingsBillingInboxPreviewUsageRoute: typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  AuthenticatedSettingsBillingLlmUsageRoute: typeof AuthenticatedSettingsBillingLlmUsageRoute;
  AuthenticatedSettingsBillingOverviewRoute: typeof AuthenticatedSettingsBillingOverviewRoute;
  AuthenticatedSettingsBillingPaymentMethodsRoute: typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  AuthenticatedSettingsBillingUsageRoute: typeof AuthenticatedSettingsBillingUsageRoute;
  AuthenticatedSettingsBillingYourPlanRoute: typeof AuthenticatedSettingsBillingYourPlanRoute;
  AuthenticatedSettingsBillingIndexRoute: typeof AuthenticatedSettingsBillingIndexRoute;
  AuthenticatedSettingsBillingAvailablePlansJourneysRoute: typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  AuthenticatedSettingsBillingAvailablePlansIndexRoute: typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
}

const AuthenticatedSettingsBillingRouteChildren: AuthenticatedSettingsBillingRouteChildren =
  {
    AuthenticatedSettingsBillingSplatRoute:
      AuthenticatedSettingsBillingSplatRoute,
    AuthenticatedSettingsBillingAddOnsRoute:
      AuthenticatedSettingsBillingAddOnsRoute,
    AuthenticatedSettingsBillingBillingDetailsRoute:
      AuthenticatedSettingsBillingBillingDetailsRoute,
    AuthenticatedSettingsBillingBillingHistoryRoute:
      AuthenticatedSettingsBillingBillingHistoryRoute,
    AuthenticatedSettingsBillingCheckoutRoute:
      AuthenticatedSettingsBillingCheckoutRoute,
    AuthenticatedSettingsBillingInboxPreviewUsageRoute:
      AuthenticatedSettingsBillingInboxPreviewUsageRoute,
    AuthenticatedSettingsBillingLlmUsageRoute:
      AuthenticatedSettingsBillingLlmUsageRoute,
    AuthenticatedSettingsBillingOverviewRoute:
      AuthenticatedSettingsBillingOverviewRoute,
    AuthenticatedSettingsBillingPaymentMethodsRoute:
      AuthenticatedSettingsBillingPaymentMethodsRoute,
    AuthenticatedSettingsBillingUsageRoute:
      AuthenticatedSettingsBillingUsageRoute,
    AuthenticatedSettingsBillingYourPlanRoute:
      AuthenticatedSettingsBillingYourPlanRoute,
    AuthenticatedSettingsBillingIndexRoute:
      AuthenticatedSettingsBillingIndexRoute,
    AuthenticatedSettingsBillingAvailablePlansJourneysRoute:
      AuthenticatedSettingsBillingAvailablePlansJourneysRoute,
    AuthenticatedSettingsBillingAvailablePlansIndexRoute:
      AuthenticatedSettingsBillingAvailablePlansIndexRoute,
  };

const AuthenticatedSettingsBillingRouteWithChildren =
  AuthenticatedSettingsBillingRoute._addFileChildren(
    AuthenticatedSettingsBillingRouteChildren,
  );

interface AuthenticatedSettingsPartnerRouteChildren {
  AuthenticatedSettingsPartnerCreateRoute: typeof AuthenticatedSettingsPartnerCreateRoute;
  AuthenticatedSettingsPartnerIndexRoute: typeof AuthenticatedSettingsPartnerIndexRoute;
}

const AuthenticatedSettingsPartnerRouteChildren: AuthenticatedSettingsPartnerRouteChildren =
  {
    AuthenticatedSettingsPartnerCreateRoute:
      AuthenticatedSettingsPartnerCreateRoute,
    AuthenticatedSettingsPartnerIndexRoute:
      AuthenticatedSettingsPartnerIndexRoute,
  };

const AuthenticatedSettingsPartnerRouteWithChildren =
  AuthenticatedSettingsPartnerRoute._addFileChildren(
    AuthenticatedSettingsPartnerRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute;
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRouteWithChildren;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedInternalToolsSplatRoute: typeof AuthenticatedInternalToolsSplatRoute;
  AuthenticatedInternalToolsCioCliToolRoute: typeof AuthenticatedInternalToolsCioCliToolRoute;
  AuthenticatedInternalToolsInspectRoute: typeof AuthenticatedInternalToolsInspectRoute;
  AuthenticatedSampleWorkspaceSplatRoute: typeof AuthenticatedSampleWorkspaceSplatRoute;
  AuthenticatedSettingsSplatRoute: typeof AuthenticatedSettingsSplatRoute;
  AuthenticatedSettingsAiRoute: typeof AuthenticatedSettingsAiRoute;
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute;
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute;
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRouteWithChildren;
  AuthenticatedSettingsExperimentalFeaturesRoute: typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  AuthenticatedSettingsPartnerRoute: typeof AuthenticatedSettingsPartnerRouteWithChildren;
  AuthenticatedSettingsPrivacyRoute: typeof AuthenticatedSettingsPrivacyRoute;
  AuthenticatedSettingsReceiptsRoute: typeof AuthenticatedSettingsReceiptsRoute;
  AuthenticatedSettingsSlackAgentRoute: typeof AuthenticatedSettingsSlackAgentRoute;
  AuthenticatedSettingsSubscriptionRoute: typeof AuthenticatedSettingsSubscriptionRoute;
  AuthenticatedTrialExpiredJourneysRoute: typeof AuthenticatedTrialExpiredJourneysRoute;
  AuthenticatedInternalToolsIndexRoute: typeof AuthenticatedInternalToolsIndexRoute;
  AuthenticatedSampleWorkspaceIndexRoute: typeof AuthenticatedSampleWorkspaceIndexRoute;
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute;
  AuthenticatedSettingsAccountEditRoute: typeof AuthenticatedSettingsAccountEditRoute;
  AuthenticatedSettingsPersonalGoogleIdentitiesRoute: typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  AuthenticatedSettingsRolesRoleIdRoute: typeof AuthenticatedSettingsRolesRoleIdRoute;
  AuthenticatedSettingsRolesNewRoute: typeof AuthenticatedSettingsRolesNewRoute;
  AuthenticatedSettingsSecuritySsoRoute: typeof AuthenticatedSettingsSecuritySsoRoute;
  AuthenticatedSettingsSlackAgentLinkRoute: typeof AuthenticatedSettingsSlackAgentLinkRoute;
  AuthenticatedSettingsTeamAddRoute: typeof AuthenticatedSettingsTeamAddRoute;
  AuthenticatedSettingsTeamInviteGuestRoute: typeof AuthenticatedSettingsTeamInviteGuestRoute;
  AuthenticatedSettingsTeamSet_passwordRoute: typeof AuthenticatedSettingsTeamSet_passwordRoute;
  AuthenticatedSettingsWorkspacesNewRoute: typeof AuthenticatedSettingsWorkspacesNewRoute;
  AuthenticatedSettingsAccountIndexRoute: typeof AuthenticatedSettingsAccountIndexRoute;
  AuthenticatedSettingsApi_credentialsIndexRoute: typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  AuthenticatedSettingsPersonalIndexRoute: typeof AuthenticatedSettingsPersonalIndexRoute;
  AuthenticatedSettingsRolesIndexRoute: typeof AuthenticatedSettingsRolesIndexRoute;
  AuthenticatedSettingsSecurityIndexRoute: typeof AuthenticatedSettingsSecurityIndexRoute;
  AuthenticatedSettingsTeamIndexRoute: typeof AuthenticatedSettingsTeamIndexRoute;
  AuthenticatedSettingsWorkspacesIndexRoute: typeof AuthenticatedSettingsWorkspacesIndexRoute;
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute: typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  AuthenticatedSettingsPersonalSecurityBackup_codesRoute: typeof AuthenticatedSettingsPersonalSecurityBackup_codesRoute;
  AuthenticatedSettingsPersonalSecurityNewRoute: typeof AuthenticatedSettingsPersonalSecurityNewRoute;
  AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute: typeof AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute;
  AuthenticatedSettingsPersonalSecurityNew_totpRoute: typeof AuthenticatedSettingsPersonalSecurityNew_totpRoute;
  AuthenticatedSettingsTeamJoinRequestsRequestIdRoute: typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  AuthenticatedSettingsPersonalSecurityIndexRoute: typeof AuthenticatedSettingsPersonalSecurityIndexRoute;
  AuthenticatedSettingsTeamMembersUserIdEditRoute: typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedInternalToolsSplatRoute: AuthenticatedInternalToolsSplatRoute,
  AuthenticatedInternalToolsCioCliToolRoute:
    AuthenticatedInternalToolsCioCliToolRoute,
  AuthenticatedInternalToolsInspectRoute:
    AuthenticatedInternalToolsInspectRoute,
  AuthenticatedSampleWorkspaceSplatRoute:
    AuthenticatedSampleWorkspaceSplatRoute,
  AuthenticatedSettingsSplatRoute: AuthenticatedSettingsSplatRoute,
  AuthenticatedSettingsAiRoute: AuthenticatedSettingsAiRoute,
  AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
  AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
  AuthenticatedSettingsBillingRoute:
    AuthenticatedSettingsBillingRouteWithChildren,
  AuthenticatedSettingsExperimentalFeaturesRoute:
    AuthenticatedSettingsExperimentalFeaturesRoute,
  AuthenticatedSettingsPartnerRoute:
    AuthenticatedSettingsPartnerRouteWithChildren,
  AuthenticatedSettingsPrivacyRoute: AuthenticatedSettingsPrivacyRoute,
  AuthenticatedSettingsReceiptsRoute: AuthenticatedSettingsReceiptsRoute,
  AuthenticatedSettingsSlackAgentRoute: AuthenticatedSettingsSlackAgentRoute,
  AuthenticatedSettingsSubscriptionRoute:
    AuthenticatedSettingsSubscriptionRoute,
  AuthenticatedTrialExpiredJourneysRoute:
    AuthenticatedTrialExpiredJourneysRoute,
  AuthenticatedInternalToolsIndexRoute: AuthenticatedInternalToolsIndexRoute,
  AuthenticatedSampleWorkspaceIndexRoute:
    AuthenticatedSampleWorkspaceIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsAccountEditRoute: AuthenticatedSettingsAccountEditRoute,
  AuthenticatedSettingsPersonalGoogleIdentitiesRoute:
    AuthenticatedSettingsPersonalGoogleIdentitiesRoute,
  AuthenticatedSettingsRolesRoleIdRoute: AuthenticatedSettingsRolesRoleIdRoute,
  AuthenticatedSettingsRolesNewRoute: AuthenticatedSettingsRolesNewRoute,
  AuthenticatedSettingsSecuritySsoRoute: AuthenticatedSettingsSecuritySsoRoute,
  AuthenticatedSettingsSlackAgentLinkRoute:
    AuthenticatedSettingsSlackAgentLinkRoute,
  AuthenticatedSettingsTeamAddRoute: AuthenticatedSettingsTeamAddRoute,
  AuthenticatedSettingsTeamInviteGuestRoute:
    AuthenticatedSettingsTeamInviteGuestRoute,
  AuthenticatedSettingsTeamSet_passwordRoute:
    AuthenticatedSettingsTeamSet_passwordRoute,
  AuthenticatedSettingsWorkspacesNewRoute:
    AuthenticatedSettingsWorkspacesNewRoute,
  AuthenticatedSettingsAccountIndexRoute:
    AuthenticatedSettingsAccountIndexRoute,
  AuthenticatedSettingsApi_credentialsIndexRoute:
    AuthenticatedSettingsApi_credentialsIndexRoute,
  AuthenticatedSettingsPersonalIndexRoute:
    AuthenticatedSettingsPersonalIndexRoute,
  AuthenticatedSettingsRolesIndexRoute: AuthenticatedSettingsRolesIndexRoute,
  AuthenticatedSettingsSecurityIndexRoute:
    AuthenticatedSettingsSecurityIndexRoute,
  AuthenticatedSettingsTeamIndexRoute: AuthenticatedSettingsTeamIndexRoute,
  AuthenticatedSettingsWorkspacesIndexRoute:
    AuthenticatedSettingsWorkspacesIndexRoute,
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute:
    AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute,
  AuthenticatedSettingsPersonalSecurityBackup_codesRoute:
    AuthenticatedSettingsPersonalSecurityBackup_codesRoute,
  AuthenticatedSettingsPersonalSecurityNewRoute:
    AuthenticatedSettingsPersonalSecurityNewRoute,
  AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute:
    AuthenticatedSettingsPersonalSecurityNew_backup_codesRoute,
  AuthenticatedSettingsPersonalSecurityNew_totpRoute:
    AuthenticatedSettingsPersonalSecurityNew_totpRoute,
  AuthenticatedSettingsTeamJoinRequestsRequestIdRoute:
    AuthenticatedSettingsTeamJoinRequestsRequestIdRoute,
  AuthenticatedSettingsPersonalSecurityIndexRoute:
    AuthenticatedSettingsPersonalSecurityIndexRoute,
  AuthenticatedSettingsTeamMembersUserIdEditRoute:
    AuthenticatedSettingsTeamMembersUserIdEditRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface CliRouteChildren {
  CliDnsSetupRoute: typeof CliDnsSetupRoute;
  CliIndexRoute: typeof CliIndexRoute;
}

const CliRouteChildren: CliRouteChildren = {
  CliDnsSetupRoute: CliDnsSetupRoute,
  CliIndexRoute: CliIndexRoute,
};

const CliRouteWithChildren = CliRoute._addFileChildren(CliRouteChildren);

interface DesignStudioEmbedRouteChildren {
  DesignStudioEmbedCioSplatRoute: typeof DesignStudioEmbedCioSplatRoute;
  DesignStudioEmbedCioEmailRoute: typeof DesignStudioEmbedCioEmailRoute;
  DesignStudioEmbedCioInAppRoute: typeof DesignStudioEmbedCioInAppRoute;
  DesignStudioEmbedCioIndexRoute: typeof DesignStudioEmbedCioIndexRoute;
}

const DesignStudioEmbedRouteChildren: DesignStudioEmbedRouteChildren = {
  DesignStudioEmbedCioSplatRoute: DesignStudioEmbedCioSplatRoute,
  DesignStudioEmbedCioEmailRoute: DesignStudioEmbedCioEmailRoute,
  DesignStudioEmbedCioInAppRoute: DesignStudioEmbedCioInAppRoute,
  DesignStudioEmbedCioIndexRoute: DesignStudioEmbedCioIndexRoute,
};

const DesignStudioEmbedRouteWithChildren =
  DesignStudioEmbedRoute._addFileChildren(DesignStudioEmbedRouteChildren);

interface OnboardingRouteChildren {
  OnboardingGetStartedRoute: typeof OnboardingGetStartedRoute;
  OnboardingWizardRoute: typeof OnboardingWizardRoute;
  OnboardingIndexRoute: typeof OnboardingIndexRoute;
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingGetStartedRoute: OnboardingGetStartedRoute,
  OnboardingWizardRoute: OnboardingWizardRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
};

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  R2fa_setupRoute: R2fa_setupRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcademyLoginRoute: AcademyLoginRoute,
  AcceptGuestInvitationRoute: AcceptGuestInvitationRoute,
  CheckoutRoute: CheckoutRoute,
  CliRoute: CliRouteWithChildren,
  Confirm_accountRoute: Confirm_accountRoute,
  DesignStudioEmbedRoute: DesignStudioEmbedRouteWithChildren,
  JoinRequestRoute: JoinRequestRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  R2fa_setupSplatRoute: R2fa_setupSplatRoute,
  AccountSplatRoute: AccountSplatRoute,
  Account_canceledSplatRoute: Account_canceledSplatRoute,
  Account_cancelledSplatRoute: Account_cancelledSplatRoute,
  Confirm_account_noticeSplatRoute: Confirm_account_noticeSplatRoute,
  DevVercelInstallRoute: DevVercelInstallRoute,
  EnvSplatRoute: EnvSplatRoute,
  HarSanitizerSplatRoute: HarSanitizerSplatRoute,
  IntegrationsSplatRoute: IntegrationsSplatRoute,
  JourneysSplatRoute: JourneysSplatRoute,
  LoginSplatRoute: LoginSplatRoute,
  LogoutSplatRoute: LogoutSplatRoute,
  MobileAuthorizeRoute: MobileAuthorizeRoute,
  No_accessible_workspacesSplatRoute: No_accessible_workspacesSplatRoute,
  Oauth2SplatRoute: Oauth2SplatRoute,
  Post_cancelSplatRoute: Post_cancelSplatRoute,
  Post_registrationSplatRoute: Post_registrationSplatRoute,
  Reset_passwordSplatRoute: Reset_passwordSplatRoute,
  Reset_passwordNew_passwordRoute: Reset_passwordNew_passwordRoute,
  SignupSplatRoute: SignupSplatRoute,
  UsersSplatRoute: UsersSplatRoute,
  VercelInstallRoute: VercelInstallRoute,
  VwbDemoSplatRoute: VwbDemoSplatRoute,
  Reset_passwordIndexRoute: Reset_passwordIndexRoute,
  AccountCancelledSplatRoute: AccountCancelledSplatRoute,
  PipelinesWorkspacesWorkspaceIdSplatRoute:
    PipelinesWorkspacesWorkspaceIdSplatRoute,
  PipelinesWorkspacesWorkspaceIdIndexRoute:
    PipelinesWorkspacesWorkspaceIdIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
